var Gc = Object.defineProperty;
var Kc = (i, t, e) => t in i ? Gc(i, t, { enumerable: !0, configurable: !0, writable: !0, value: e }) : i[t] = e;
var P = (i, t, e) => Kc(i, typeof t != "symbol" ? t + "" : t, e);
function le(i) {
  if (i === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return i;
}
function Xi(i, t) {
  i.prototype = Object.create(t.prototype), i.prototype.constructor = i, i.__proto__ = t;
}
/*!
 * GSAP 3.12.5
 * https://gsap.com
 *
 * @license Copyright 2008-2024, GreenSock. All rights reserved.
 * Subject to the terms at https://gsap.com/standard-license or for
 * Club GSAP members, the agreement issued with that membership.
 * @author: Jack Doyle, jack@greensock.com
*/
var qt = {
  autoSleep: 120,
  force3D: "auto",
  nullTargetWarn: 1,
  units: {
    lineHeight: ""
  }
}, nn = {
  duration: 0.5,
  overwrite: !1,
  delay: 0
}, Cs, St, rt, Yt = 1e8, tt = 1 / Yt, Gr = Math.PI * 2, jc = Gr / 4, Zc = 0, Gi = Math.sqrt, Qc = Math.cos, Jc = Math.sin, bt = function(t) {
  return typeof t == "string";
}, lt = function(t) {
  return typeof t == "function";
}, pe = function(t) {
  return typeof t == "number";
}, Os = function(t) {
  return typeof t > "u";
}, oe = function(t) {
  return typeof t == "object";
}, Mt = function(t) {
  return t !== !1;
}, As = function() {
  return typeof window < "u";
}, Kn = function(t) {
  return lt(t) || bt(t);
}, Ki = typeof ArrayBuffer == "function" && ArrayBuffer.isView || function() {
}, Tt = Array.isArray, Kr = /(?:-?\.?\d|\.)+/gi, ji = /[-+=.]*\d+[.e\-+]*\d*[e\-+]*\d*/g, Xe = /[-+=.]*\d+[.e-]*\d*[a-z%]*/g, $r = /[-+=.]*\d+\.?\d*(?:e-|e\+)?\d*/gi, Zi = /[+-]=-?[.\d]+/, Qi = /[^,'"\[\]\s]+/gi, ta = /^[+\-=e\s\d]*\d+[.\d]*([a-z]*|%)\s*$/i, it, Jt, jr, Ps, Vt = {}, or = {}, Ji, to = function(t) {
  return (or = Ve(t, Vt)) && Rt;
}, Ms = function(t, e) {
  return console.warn("Invalid property", t, "set to", e, "Missing plugin? gsap.registerPlugin()");
}, xn = function(t, e) {
  return !e && console.warn(t);
}, eo = function(t, e) {
  return t && (Vt[t] = e) && or && (or[t] = e) || Vt;
}, Sn = function() {
  return 0;
}, ea = {
  suppressEvents: !0,
  isStart: !0,
  kill: !1
}, Jn = {
  suppressEvents: !0,
  kill: !1
}, na = {
  suppressEvents: !0
}, Es = {}, xe = [], Zr = {}, no, $t = {}, Fr = {}, li = 30, tr = [], Ds = "", Ls = function(t) {
  var e = t[0], n, r;
  if (oe(e) || lt(e) || (t = [t]), !(n = (e._gsap || {}).harness)) {
    for (r = tr.length; r-- && !tr[r].targetTest(e); )
      ;
    n = tr[r];
  }
  for (r = t.length; r--; )
    t[r] && (t[r]._gsap || (t[r]._gsap = new Oo(t[r], n))) || t.splice(r, 1);
  return t;
}, Fe = function(t) {
  return t._gsap || Ls(Xt(t))[0]._gsap;
}, ro = function(t, e, n) {
  return (n = t[e]) && lt(n) ? t[e]() : Os(n) && t.getAttribute && t.getAttribute(e) || n;
}, Et = function(t, e) {
  return (t = t.split(",")).forEach(e) || t;
}, ht = function(t) {
  return Math.round(t * 1e5) / 1e5 || 0;
}, vt = function(t) {
  return Math.round(t * 1e7) / 1e7 || 0;
}, Ze = function(t, e) {
  var n = e.charAt(0), r = parseFloat(e.substr(2));
  return t = parseFloat(t), n === "+" ? t + r : n === "-" ? t - r : n === "*" ? t * r : t / r;
}, ra = function(t, e) {
  for (var n = e.length, r = 0; t.indexOf(e[r]) < 0 && ++r < n; )
    ;
  return r < n;
}, cr = function() {
  var t = xe.length, e = xe.slice(0), n, r;
  for (Zr = {}, xe.length = 0, n = 0; n < t; n++)
    r = e[n], r && r._lazy && (r.render(r._lazy[0], r._lazy[1], !0)._lazy = 0);
}, so = function(t, e, n, r) {
  xe.length && !St && cr(), t.render(e, n, St && e < 0 && (t._initted || t._startAt)), xe.length && !St && cr();
}, io = function(t) {
  var e = parseFloat(t);
  return (e || e === 0) && (t + "").match(Qi).length < 2 ? e : bt(t) ? t.trim() : t;
}, oo = function(t) {
  return t;
}, Gt = function(t, e) {
  for (var n in e)
    n in t || (t[n] = e[n]);
  return t;
}, sa = function(t) {
  return function(e, n) {
    for (var r in n)
      r in e || r === "duration" && t || r === "ease" || (e[r] = n[r]);
  };
}, Ve = function(t, e) {
  for (var n in e)
    t[n] = e[n];
  return t;
}, ui = function i(t, e) {
  for (var n in e)
    n !== "__proto__" && n !== "constructor" && n !== "prototype" && (t[n] = oe(e[n]) ? i(t[n] || (t[n] = {}), e[n]) : e[n]);
  return t;
}, ar = function(t, e) {
  var n = {}, r;
  for (r in t)
    r in e || (n[r] = t[r]);
  return n;
}, vn = function(t) {
  var e = t.parent || it, n = t.keyframes ? sa(Tt(t.keyframes)) : Gt;
  if (Mt(t.inherit))
    for (; e; )
      n(t, e.vars.defaults), e = e.parent || e._dp;
  return t;
}, ia = function(t, e) {
  for (var n = t.length, r = n === e.length; r && n-- && t[n] === e[n]; )
    ;
  return n < 0;
}, co = function(t, e, n, r, s) {
  var o = t[r], c;
  if (s)
    for (c = e[s]; o && o[s] > c; )
      o = o._prev;
  return o ? (e._next = o._next, o._next = e) : (e._next = t[n], t[n] = e), e._next ? e._next._prev = e : t[r] = e, e._prev = o, e.parent = e._dp = t, e;
}, wr = function(t, e, n, r) {
  n === void 0 && (n = "_first"), r === void 0 && (r = "_last");
  var s = e._prev, o = e._next;
  s ? s._next = o : t[n] === e && (t[n] = o), o ? o._prev = s : t[r] === e && (t[r] = s), e._next = e._prev = e.parent = null;
}, Ce = function(t, e) {
  t.parent && (!e || t.parent.autoRemoveChildren) && t.parent.remove && t.parent.remove(t), t._act = 0;
}, ze = function(t, e) {
  if (t && (!e || e._end > t._dur || e._start < 0))
    for (var n = t; n; )
      n._dirty = 1, n = n.parent;
  return t;
}, oa = function(t) {
  for (var e = t.parent; e && e.parent; )
    e._dirty = 1, e.totalDuration(), e = e.parent;
  return t;
}, Qr = function(t, e, n, r) {
  return t._startAt && (St ? t._startAt.revert(Jn) : t.vars.immediateRender && !t.vars.autoRevert || t._startAt.render(e, !0, r));
}, ca = function i(t) {
  return !t || t._ts && i(t.parent);
}, fi = function(t) {
  return t._repeat ? rn(t._tTime, t = t.duration() + t._rDelay) * t : 0;
}, rn = function(t, e) {
  var n = Math.floor(t /= e);
  return t && n === t ? n - 1 : n;
}, lr = function(t, e) {
  return (t - e._start) * e._ts + (e._ts >= 0 ? 0 : e._dirty ? e.totalDuration() : e._tDur);
}, xr = function(t) {
  return t._end = vt(t._start + (t._tDur / Math.abs(t._ts || t._rts || tt) || 0));
}, Sr = function(t, e) {
  var n = t._dp;
  return n && n.smoothChildTiming && t._ts && (t._start = vt(n._time - (t._ts > 0 ? e / t._ts : ((t._dirty ? t.totalDuration() : t._tDur) - e) / -t._ts)), xr(t), n._dirty || ze(n, t)), t;
}, ao = function(t, e) {
  var n;
  if ((e._time || !e._dur && e._initted || e._start < t._time && (e._dur || !e.add)) && (n = lr(t.rawTime(), e), (!e._dur || Rn(0, e.totalDuration(), n) - e._tTime > tt) && e.render(n, !0)), ze(t, e)._dp && t._initted && t._time >= t._dur && t._ts) {
    if (t._dur < t.duration())
      for (n = t; n._dp; )
        n.rawTime() >= 0 && n.totalTime(n._tTime), n = n._dp;
    t._zTime = -tt;
  }
}, te = function(t, e, n, r) {
  return e.parent && Ce(e), e._start = vt((pe(n) ? n : n || t !== it ? Ut(t, n, e) : t._time) + e._delay), e._end = vt(e._start + (e.totalDuration() / Math.abs(e.timeScale()) || 0)), co(t, e, "_first", "_last", t._sort ? "_start" : 0), Jr(e) || (t._recent = e), r || ao(t, e), t._ts < 0 && Sr(t, t._tTime), t;
}, lo = function(t, e) {
  return (Vt.ScrollTrigger || Ms("scrollTrigger", e)) && Vt.ScrollTrigger.create(e, t);
}, uo = function(t, e, n, r, s) {
  if (Is(t, e, s), !t._initted)
    return 1;
  if (!n && t._pt && !St && (t._dur && t.vars.lazy !== !1 || !t._dur && t.vars.lazy) && no !== Ft.frame)
    return xe.push(t), t._lazy = [s, r], 1;
}, aa = function i(t) {
  var e = t.parent;
  return e && e._ts && e._initted && !e._lock && (e.rawTime() < 0 || i(e));
}, Jr = function(t) {
  var e = t.data;
  return e === "isFromStart" || e === "isStart";
}, la = function(t, e, n, r) {
  var s = t.ratio, o = e < 0 || !e && (!t._start && aa(t) && !(!t._initted && Jr(t)) || (t._ts < 0 || t._dp._ts < 0) && !Jr(t)) ? 0 : 1, c = t._rDelay, a = 0, l, u, f;
  if (c && t._repeat && (a = Rn(0, t._tDur, e), u = rn(a, c), t._yoyo && u & 1 && (o = 1 - o), u !== rn(t._tTime, c) && (s = 1 - o, t.vars.repeatRefresh && t._initted && t.invalidate())), o !== s || St || r || t._zTime === tt || !e && t._zTime) {
    if (!t._initted && uo(t, e, r, n, a))
      return;
    for (f = t._zTime, t._zTime = e || (n ? tt : 0), n || (n = e && !f), t.ratio = o, t._from && (o = 1 - o), t._time = 0, t._tTime = a, l = t._pt; l; )
      l.r(o, l.d), l = l._next;
    e < 0 && Qr(t, e, n, !0), t._onUpdate && !n && Nt(t, "onUpdate"), a && t._repeat && !n && t.parent && Nt(t, "onRepeat"), (e >= t._tDur || e < 0) && t.ratio === o && (o && Ce(t, 1), !n && !St && (Nt(t, o ? "onComplete" : "onReverseComplete", !0), t._prom && t._prom()));
  } else t._zTime || (t._zTime = e);
}, ua = function(t, e, n) {
  var r;
  if (n > e)
    for (r = t._first; r && r._start <= n; ) {
      if (r.data === "isPause" && r._start > e)
        return r;
      r = r._next;
    }
  else
    for (r = t._last; r && r._start >= n; ) {
      if (r.data === "isPause" && r._start < e)
        return r;
      r = r._prev;
    }
}, sn = function(t, e, n, r) {
  var s = t._repeat, o = vt(e) || 0, c = t._tTime / t._tDur;
  return c && !r && (t._time *= o / t._dur), t._dur = o, t._tDur = s ? s < 0 ? 1e10 : vt(o * (s + 1) + t._rDelay * s) : o, c > 0 && !r && Sr(t, t._tTime = t._tDur * c), t.parent && xr(t), n || ze(t.parent, t), t;
}, hi = function(t) {
  return t instanceof Ct ? ze(t) : sn(t, t._dur);
}, fa = {
  _start: 0,
  endTime: Sn,
  totalDuration: Sn
}, Ut = function i(t, e, n) {
  var r = t.labels, s = t._recent || fa, o = t.duration() >= Yt ? s.endTime(!1) : t._dur, c, a, l;
  return bt(e) && (isNaN(e) || e in r) ? (a = e.charAt(0), l = e.substr(-1) === "%", c = e.indexOf("="), a === "<" || a === ">" ? (c >= 0 && (e = e.replace(/=/, "")), (a === "<" ? s._start : s.endTime(s._repeat >= 0)) + (parseFloat(e.substr(1)) || 0) * (l ? (c < 0 ? s : n).totalDuration() / 100 : 1)) : c < 0 ? (e in r || (r[e] = o), r[e]) : (a = parseFloat(e.charAt(c - 1) + e.substr(c + 1)), l && n && (a = a / 100 * (Tt(n) ? n[0] : n).totalDuration()), c > 1 ? i(t, e.substr(0, c - 1), n) + a : o + a)) : e == null ? o : +e;
}, bn = function(t, e, n) {
  var r = pe(e[1]), s = (r ? 2 : 1) + (t < 2 ? 0 : 1), o = e[s], c, a;
  if (r && (o.duration = e[1]), o.parent = n, t) {
    for (c = o, a = n; a && !("immediateRender" in c); )
      c = a.vars.defaults || {}, a = Mt(a.vars.inherit) && a.parent;
    o.immediateRender = Mt(c.immediateRender), t < 2 ? o.runBackwards = 1 : o.startAt = e[s - 1];
  }
  return new _t(e[0], o, e[s + 1]);
}, Pe = function(t, e) {
  return t || t === 0 ? e(t) : e;
}, Rn = function(t, e, n) {
  return n < t ? t : n > e ? e : n;
}, xt = function(t, e) {
  return !bt(t) || !(e = ta.exec(t)) ? "" : e[1];
}, ha = function(t, e, n) {
  return Pe(n, function(r) {
    return Rn(t, e, r);
  });
}, ts = [].slice, fo = function(t, e) {
  return t && oe(t) && "length" in t && (!e && !t.length || t.length - 1 in t && oe(t[0])) && !t.nodeType && t !== Jt;
}, da = function(t, e, n) {
  return n === void 0 && (n = []), t.forEach(function(r) {
    var s;
    return bt(r) && !e || fo(r, 1) ? (s = n).push.apply(s, Xt(r)) : n.push(r);
  }) || n;
}, Xt = function(t, e, n) {
  return rt && !e && rt.selector ? rt.selector(t) : bt(t) && !n && (jr || !on()) ? ts.call((e || Ps).querySelectorAll(t), 0) : Tt(t) ? da(t, n) : fo(t) ? ts.call(t, 0) : t ? [t] : [];
}, es = function(t) {
  return t = Xt(t)[0] || xn("Invalid scope") || {}, function(e) {
    var n = t.current || t.nativeElement || t;
    return Xt(e, n.querySelectorAll ? n : n === t ? xn("Invalid scope") || Ps.createElement("div") : t);
  };
}, ho = function(t) {
  return t.sort(function() {
    return 0.5 - Math.random();
  });
}, po = function(t) {
  if (lt(t))
    return t;
  var e = oe(t) ? t : {
    each: t
  }, n = He(e.ease), r = e.from || 0, s = parseFloat(e.base) || 0, o = {}, c = r > 0 && r < 1, a = isNaN(r) || c, l = e.axis, u = r, f = r;
  return bt(r) ? u = f = {
    center: 0.5,
    edges: 0.5,
    end: 1
  }[r] || 0 : !c && a && (u = r[0], f = r[1]), function(d, _, p) {
    var h = (p || e).length, m = o[h], g, v, x, y, b, S, T, k, w;
    if (!m) {
      if (w = e.grid === "auto" ? 0 : (e.grid || [1, Yt])[1], !w) {
        for (T = -Yt; T < (T = p[w++].getBoundingClientRect().left) && w < h; )
          ;
        w < h && w--;
      }
      for (m = o[h] = [], g = a ? Math.min(w, h) * u - 0.5 : r % w, v = w === Yt ? 0 : a ? h * f / w - 0.5 : r / w | 0, T = 0, k = Yt, S = 0; S < h; S++)
        x = S % w - g, y = v - (S / w | 0), m[S] = b = l ? Math.abs(l === "y" ? y : x) : Gi(x * x + y * y), b > T && (T = b), b < k && (k = b);
      r === "random" && ho(m), m.max = T - k, m.min = k, m.v = h = (parseFloat(e.amount) || parseFloat(e.each) * (w > h ? h - 1 : l ? l === "y" ? h / w : w : Math.max(w, h / w)) || 0) * (r === "edges" ? -1 : 1), m.b = h < 0 ? s - h : s, m.u = xt(e.amount || e.each) || 0, n = n && h < 0 ? To(n) : n;
    }
    return h = (m[d] - m.min) / m.max || 0, vt(m.b + (n ? n(h) : h) * m.v) + m.u;
  };
}, ns = function(t) {
  var e = Math.pow(10, ((t + "").split(".")[1] || "").length);
  return function(n) {
    var r = vt(Math.round(parseFloat(n) / t) * t * e);
    return (r - r % 1) / e + (pe(n) ? 0 : xt(n));
  };
}, _o = function(t, e) {
  var n = Tt(t), r, s;
  return !n && oe(t) && (r = n = t.radius || Yt, t.values ? (t = Xt(t.values), (s = !pe(t[0])) && (r *= r)) : t = ns(t.increment)), Pe(e, n ? lt(t) ? function(o) {
    return s = t(o), Math.abs(s - o) <= r ? s : o;
  } : function(o) {
    for (var c = parseFloat(s ? o.x : o), a = parseFloat(s ? o.y : 0), l = Yt, u = 0, f = t.length, d, _; f--; )
      s ? (d = t[f].x - c, _ = t[f].y - a, d = d * d + _ * _) : d = Math.abs(t[f] - c), d < l && (l = d, u = f);
    return u = !r || l <= r ? t[u] : o, s || u === o || pe(o) ? u : u + xt(o);
  } : ns(t));
}, mo = function(t, e, n, r) {
  return Pe(Tt(t) ? !e : n === !0 ? !!(n = 0) : !r, function() {
    return Tt(t) ? t[~~(Math.random() * t.length)] : (n = n || 1e-5) && (r = n < 1 ? Math.pow(10, (n + "").length - 2) : 1) && Math.floor(Math.round((t - n / 2 + Math.random() * (e - t + n * 0.99)) / n) * n * r) / r;
  });
}, pa = function() {
  for (var t = arguments.length, e = new Array(t), n = 0; n < t; n++)
    e[n] = arguments[n];
  return function(r) {
    return e.reduce(function(s, o) {
      return o(s);
    }, r);
  };
}, _a = function(t, e) {
  return function(n) {
    return t(parseFloat(n)) + (e || xt(n));
  };
}, ma = function(t, e, n) {
  return yo(t, e, 0, 1, n);
}, go = function(t, e, n) {
  return Pe(n, function(r) {
    return t[~~e(r)];
  });
}, ga = function i(t, e, n) {
  var r = e - t;
  return Tt(t) ? go(t, i(0, t.length), e) : Pe(n, function(s) {
    return (r + (s - t) % r) % r + t;
  });
}, ya = function i(t, e, n) {
  var r = e - t, s = r * 2;
  return Tt(t) ? go(t, i(0, t.length - 1), e) : Pe(n, function(o) {
    return o = (s + (o - t) % s) % s || 0, t + (o > r ? s - o : o);
  });
}, Tn = function(t) {
  for (var e = 0, n = "", r, s, o, c; ~(r = t.indexOf("random(", e)); )
    o = t.indexOf(")", r), c = t.charAt(r + 7) === "[", s = t.substr(r + 7, o - r - 7).match(c ? Qi : Kr), n += t.substr(e, r - e) + mo(c ? s : +s[0], c ? 0 : +s[1], +s[2] || 1e-5), e = o + 1;
  return n + t.substr(e, t.length - e);
}, yo = function(t, e, n, r, s) {
  var o = e - t, c = r - n;
  return Pe(s, function(a) {
    return n + ((a - t) / o * c || 0);
  });
}, va = function i(t, e, n, r) {
  var s = isNaN(t + e) ? 0 : function(_) {
    return (1 - _) * t + _ * e;
  };
  if (!s) {
    var o = bt(t), c = {}, a, l, u, f, d;
    if (n === !0 && (r = 1) && (n = null), o)
      t = {
        p: t
      }, e = {
        p: e
      };
    else if (Tt(t) && !Tt(e)) {
      for (u = [], f = t.length, d = f - 2, l = 1; l < f; l++)
        u.push(i(t[l - 1], t[l]));
      f--, s = function(p) {
        p *= f;
        var h = Math.min(d, ~~p);
        return u[h](p - h);
      }, n = e;
    } else r || (t = Ve(Tt(t) ? [] : {}, t));
    if (!u) {
      for (a in e)
        Rs.call(c, t, a, "get", e[a]);
      s = function(p) {
        return zs(p, c) || (o ? t.p : t);
      };
    }
  }
  return Pe(n, s);
}, di = function(t, e, n) {
  var r = t.labels, s = Yt, o, c, a;
  for (o in r)
    c = r[o] - e, c < 0 == !!n && c && s > (c = Math.abs(c)) && (a = o, s = c);
  return a;
}, Nt = function(t, e, n) {
  var r = t.vars, s = r[e], o = rt, c = t._ctx, a, l, u;
  if (s)
    return a = r[e + "Params"], l = r.callbackScope || t, n && xe.length && cr(), c && (rt = c), u = a ? s.apply(l, a) : s.call(l), rt = o, u;
}, gn = function(t) {
  return Ce(t), t.scrollTrigger && t.scrollTrigger.kill(!!St), t.progress() < 1 && Nt(t, "onInterrupt"), t;
}, Ge, vo = [], bo = function(t) {
  if (t)
    if (t = !t.name && t.default || t, As() || t.headless) {
      var e = t.name, n = lt(t), r = e && !n && t.init ? function() {
        this._props = [];
      } : t, s = {
        init: Sn,
        render: zs,
        add: Rs,
        kill: Ia,
        modifier: Ra,
        rawVars: 0
      }, o = {
        targetTest: 0,
        get: 0,
        getSetter: Fs,
        aliases: {},
        register: 0
      };
      if (on(), t !== r) {
        if ($t[e])
          return;
        Gt(r, Gt(ar(t, s), o)), Ve(r.prototype, Ve(s, ar(t, o))), $t[r.prop = e] = r, t.targetTest && (tr.push(r), Es[e] = 1), e = (e === "css" ? "CSS" : e.charAt(0).toUpperCase() + e.substr(1)) + "Plugin";
      }
      eo(e, r), t.register && t.register(Rt, r, Dt);
    } else
      vo.push(t);
}, J = 255, yn = {
  aqua: [0, J, J],
  lime: [0, J, 0],
  silver: [192, 192, 192],
  black: [0, 0, 0],
  maroon: [128, 0, 0],
  teal: [0, 128, 128],
  blue: [0, 0, J],
  navy: [0, 0, 128],
  white: [J, J, J],
  olive: [128, 128, 0],
  yellow: [J, J, 0],
  orange: [J, 165, 0],
  gray: [128, 128, 128],
  purple: [128, 0, 128],
  green: [0, 128, 0],
  red: [J, 0, 0],
  pink: [J, 192, 203],
  cyan: [0, J, J],
  transparent: [J, J, J, 0]
}, zr = function(t, e, n) {
  return t += t < 0 ? 1 : t > 1 ? -1 : 0, (t * 6 < 1 ? e + (n - e) * t * 6 : t < 0.5 ? n : t * 3 < 2 ? e + (n - e) * (2 / 3 - t) * 6 : e) * J + 0.5 | 0;
}, wo = function(t, e, n) {
  var r = t ? pe(t) ? [t >> 16, t >> 8 & J, t & J] : 0 : yn.black, s, o, c, a, l, u, f, d, _, p;
  if (!r) {
    if (t.substr(-1) === "," && (t = t.substr(0, t.length - 1)), yn[t])
      r = yn[t];
    else if (t.charAt(0) === "#") {
      if (t.length < 6 && (s = t.charAt(1), o = t.charAt(2), c = t.charAt(3), t = "#" + s + s + o + o + c + c + (t.length === 5 ? t.charAt(4) + t.charAt(4) : "")), t.length === 9)
        return r = parseInt(t.substr(1, 6), 16), [r >> 16, r >> 8 & J, r & J, parseInt(t.substr(7), 16) / 255];
      t = parseInt(t.substr(1), 16), r = [t >> 16, t >> 8 & J, t & J];
    } else if (t.substr(0, 3) === "hsl") {
      if (r = p = t.match(Kr), !e)
        a = +r[0] % 360 / 360, l = +r[1] / 100, u = +r[2] / 100, o = u <= 0.5 ? u * (l + 1) : u + l - u * l, s = u * 2 - o, r.length > 3 && (r[3] *= 1), r[0] = zr(a + 1 / 3, s, o), r[1] = zr(a, s, o), r[2] = zr(a - 1 / 3, s, o);
      else if (~t.indexOf("="))
        return r = t.match(ji), n && r.length < 4 && (r[3] = 1), r;
    } else
      r = t.match(Kr) || yn.transparent;
    r = r.map(Number);
  }
  return e && !p && (s = r[0] / J, o = r[1] / J, c = r[2] / J, f = Math.max(s, o, c), d = Math.min(s, o, c), u = (f + d) / 2, f === d ? a = l = 0 : (_ = f - d, l = u > 0.5 ? _ / (2 - f - d) : _ / (f + d), a = f === s ? (o - c) / _ + (o < c ? 6 : 0) : f === o ? (c - s) / _ + 2 : (s - o) / _ + 4, a *= 60), r[0] = ~~(a + 0.5), r[1] = ~~(l * 100 + 0.5), r[2] = ~~(u * 100 + 0.5)), n && r.length < 4 && (r[3] = 1), r;
}, xo = function(t) {
  var e = [], n = [], r = -1;
  return t.split(Se).forEach(function(s) {
    var o = s.match(Xe) || [];
    e.push.apply(e, o), n.push(r += o.length + 1);
  }), e.c = n, e;
}, pi = function(t, e, n) {
  var r = "", s = (t + r).match(Se), o = e ? "hsla(" : "rgba(", c = 0, a, l, u, f;
  if (!s)
    return t;
  if (s = s.map(function(d) {
    return (d = wo(d, e, 1)) && o + (e ? d[0] + "," + d[1] + "%," + d[2] + "%," + d[3] : d.join(",")) + ")";
  }), n && (u = xo(t), a = n.c, a.join(r) !== u.c.join(r)))
    for (l = t.replace(Se, "1").split(Xe), f = l.length - 1; c < f; c++)
      r += l[c] + (~a.indexOf(c) ? s.shift() || o + "0,0,0,0)" : (u.length ? u : s.length ? s : n).shift());
  if (!l)
    for (l = t.split(Se), f = l.length - 1; c < f; c++)
      r += l[c] + s[c];
  return r + l[f];
}, Se = function() {
  var i = "(?:\\b(?:(?:rgb|rgba|hsl|hsla)\\(.+?\\))|\\B#(?:[0-9a-f]{3,4}){1,2}\\b", t;
  for (t in yn)
    i += "|" + t + "\\b";
  return new RegExp(i + ")", "gi");
}(), ba = /hsl[a]?\(/, So = function(t) {
  var e = t.join(" "), n;
  if (Se.lastIndex = 0, Se.test(e))
    return n = ba.test(e), t[1] = pi(t[1], n), t[0] = pi(t[0], n, xo(t[1])), !0;
}, kn, Ft = function() {
  var i = Date.now, t = 500, e = 33, n = i(), r = n, s = 1e3 / 240, o = s, c = [], a, l, u, f, d, _, p = function h(m) {
    var g = i() - r, v = m === !0, x, y, b, S;
    if ((g > t || g < 0) && (n += g - e), r += g, b = r - n, x = b - o, (x > 0 || v) && (S = ++f.frame, d = b - f.time * 1e3, f.time = b = b / 1e3, o += x + (x >= s ? 4 : s - x), y = 1), v || (a = l(h)), y)
      for (_ = 0; _ < c.length; _++)
        c[_](b, d, S, m);
  };
  return f = {
    time: 0,
    frame: 0,
    tick: function() {
      p(!0);
    },
    deltaRatio: function(m) {
      return d / (1e3 / (m || 60));
    },
    wake: function() {
      Ji && (!jr && As() && (Jt = jr = window, Ps = Jt.document || {}, Vt.gsap = Rt, (Jt.gsapVersions || (Jt.gsapVersions = [])).push(Rt.version), to(or || Jt.GreenSockGlobals || !Jt.gsap && Jt || {}), vo.forEach(bo)), u = typeof requestAnimationFrame < "u" && requestAnimationFrame, a && f.sleep(), l = u || function(m) {
        return setTimeout(m, o - f.time * 1e3 + 1 | 0);
      }, kn = 1, p(2));
    },
    sleep: function() {
      (u ? cancelAnimationFrame : clearTimeout)(a), kn = 0, l = Sn;
    },
    lagSmoothing: function(m, g) {
      t = m || 1 / 0, e = Math.min(g || 33, t);
    },
    fps: function(m) {
      s = 1e3 / (m || 240), o = f.time * 1e3 + s;
    },
    add: function(m, g, v) {
      var x = g ? function(y, b, S, T) {
        m(y, b, S, T), f.remove(x);
      } : m;
      return f.remove(m), c[v ? "unshift" : "push"](x), on(), x;
    },
    remove: function(m, g) {
      ~(g = c.indexOf(m)) && c.splice(g, 1) && _ >= g && _--;
    },
    _listeners: c
  }, f;
}(), on = function() {
  return !kn && Ft.wake();
}, G = {}, wa = /^[\d.\-M][\d.\-,\s]/, xa = /["']/g, Sa = function(t) {
  for (var e = {}, n = t.substr(1, t.length - 3).split(":"), r = n[0], s = 1, o = n.length, c, a, l; s < o; s++)
    a = n[s], c = s !== o - 1 ? a.lastIndexOf(",") : a.length, l = a.substr(0, c), e[r] = isNaN(l) ? l.replace(xa, "").trim() : +l, r = a.substr(c + 1).trim();
  return e;
}, Ta = function(t) {
  var e = t.indexOf("(") + 1, n = t.indexOf(")"), r = t.indexOf("(", e);
  return t.substring(e, ~r && r < n ? t.indexOf(")", n + 1) : n);
}, ka = function(t) {
  var e = (t + "").split("("), n = G[e[0]];
  return n && e.length > 1 && n.config ? n.config.apply(null, ~t.indexOf("{") ? [Sa(e[1])] : Ta(t).split(",").map(io)) : G._CE && wa.test(t) ? G._CE("", t) : n;
}, To = function(t) {
  return function(e) {
    return 1 - t(1 - e);
  };
}, ko = function i(t, e) {
  for (var n = t._first, r; n; )
    n instanceof Ct ? i(n, e) : n.vars.yoyoEase && (!n._yoyo || !n._repeat) && n._yoyo !== e && (n.timeline ? i(n.timeline, e) : (r = n._ease, n._ease = n._yEase, n._yEase = r, n._yoyo = e)), n = n._next;
}, He = function(t, e) {
  return t && (lt(t) ? t : G[t] || ka(t)) || e;
}, Ue = function(t, e, n, r) {
  n === void 0 && (n = function(a) {
    return 1 - e(1 - a);
  }), r === void 0 && (r = function(a) {
    return a < 0.5 ? e(a * 2) / 2 : 1 - e((1 - a) * 2) / 2;
  });
  var s = {
    easeIn: e,
    easeOut: n,
    easeInOut: r
  }, o;
  return Et(t, function(c) {
    G[c] = Vt[c] = s, G[o = c.toLowerCase()] = n;
    for (var a in s)
      G[o + (a === "easeIn" ? ".in" : a === "easeOut" ? ".out" : ".inOut")] = G[c + "." + a] = s[a];
  }), s;
}, Co = function(t) {
  return function(e) {
    return e < 0.5 ? (1 - t(1 - e * 2)) / 2 : 0.5 + t((e - 0.5) * 2) / 2;
  };
}, Hr = function i(t, e, n) {
  var r = e >= 1 ? e : 1, s = (n || (t ? 0.3 : 0.45)) / (e < 1 ? e : 1), o = s / Gr * (Math.asin(1 / r) || 0), c = function(u) {
    return u === 1 ? 1 : r * Math.pow(2, -10 * u) * Jc((u - o) * s) + 1;
  }, a = t === "out" ? c : t === "in" ? function(l) {
    return 1 - c(1 - l);
  } : Co(c);
  return s = Gr / s, a.config = function(l, u) {
    return i(t, l, u);
  }, a;
}, Nr = function i(t, e) {
  e === void 0 && (e = 1.70158);
  var n = function(o) {
    return o ? --o * o * ((e + 1) * o + e) + 1 : 0;
  }, r = t === "out" ? n : t === "in" ? function(s) {
    return 1 - n(1 - s);
  } : Co(n);
  return r.config = function(s) {
    return i(t, s);
  }, r;
};
Et("Linear,Quad,Cubic,Quart,Quint,Strong", function(i, t) {
  var e = t < 5 ? t + 1 : t;
  Ue(i + ",Power" + (e - 1), t ? function(n) {
    return Math.pow(n, e);
  } : function(n) {
    return n;
  }, function(n) {
    return 1 - Math.pow(1 - n, e);
  }, function(n) {
    return n < 0.5 ? Math.pow(n * 2, e) / 2 : 1 - Math.pow((1 - n) * 2, e) / 2;
  });
});
G.Linear.easeNone = G.none = G.Linear.easeIn;
Ue("Elastic", Hr("in"), Hr("out"), Hr());
(function(i, t) {
  var e = 1 / t, n = 2 * e, r = 2.5 * e, s = function(c) {
    return c < e ? i * c * c : c < n ? i * Math.pow(c - 1.5 / t, 2) + 0.75 : c < r ? i * (c -= 2.25 / t) * c + 0.9375 : i * Math.pow(c - 2.625 / t, 2) + 0.984375;
  };
  Ue("Bounce", function(o) {
    return 1 - s(1 - o);
  }, s);
})(7.5625, 2.75);
Ue("Expo", function(i) {
  return i ? Math.pow(2, 10 * (i - 1)) : 0;
});
Ue("Circ", function(i) {
  return -(Gi(1 - i * i) - 1);
});
Ue("Sine", function(i) {
  return i === 1 ? 1 : -Qc(i * jc) + 1;
});
Ue("Back", Nr("in"), Nr("out"), Nr());
G.SteppedEase = G.steps = Vt.SteppedEase = {
  config: function(t, e) {
    t === void 0 && (t = 1);
    var n = 1 / t, r = t + (e ? 0 : 1), s = e ? 1 : 0, o = 1 - tt;
    return function(c) {
      return ((r * Rn(0, o, c) | 0) + s) * n;
    };
  }
};
nn.ease = G["quad.out"];
Et("onComplete,onUpdate,onStart,onRepeat,onReverseComplete,onInterrupt", function(i) {
  return Ds += i + "," + i + "Params,";
});
var Oo = function(t, e) {
  this.id = Zc++, t._gsap = this, this.target = t, this.harness = e, this.get = e ? e.get : ro, this.set = e ? e.getSetter : Fs;
}, Cn = /* @__PURE__ */ function() {
  function i(e) {
    this.vars = e, this._delay = +e.delay || 0, (this._repeat = e.repeat === 1 / 0 ? -2 : e.repeat || 0) && (this._rDelay = e.repeatDelay || 0, this._yoyo = !!e.yoyo || !!e.yoyoEase), this._ts = 1, sn(this, +e.duration, 1, 1), this.data = e.data, rt && (this._ctx = rt, rt.data.push(this)), kn || Ft.wake();
  }
  var t = i.prototype;
  return t.delay = function(n) {
    return n || n === 0 ? (this.parent && this.parent.smoothChildTiming && this.startTime(this._start + n - this._delay), this._delay = n, this) : this._delay;
  }, t.duration = function(n) {
    return arguments.length ? this.totalDuration(this._repeat > 0 ? n + (n + this._rDelay) * this._repeat : n) : this.totalDuration() && this._dur;
  }, t.totalDuration = function(n) {
    return arguments.length ? (this._dirty = 0, sn(this, this._repeat < 0 ? n : (n - this._repeat * this._rDelay) / (this._repeat + 1))) : this._tDur;
  }, t.totalTime = function(n, r) {
    if (on(), !arguments.length)
      return this._tTime;
    var s = this._dp;
    if (s && s.smoothChildTiming && this._ts) {
      for (Sr(this, n), !s._dp || s.parent || ao(s, this); s && s.parent; )
        s.parent._time !== s._start + (s._ts >= 0 ? s._tTime / s._ts : (s.totalDuration() - s._tTime) / -s._ts) && s.totalTime(s._tTime, !0), s = s.parent;
      !this.parent && this._dp.autoRemoveChildren && (this._ts > 0 && n < this._tDur || this._ts < 0 && n > 0 || !this._tDur && !n) && te(this._dp, this, this._start - this._delay);
    }
    return (this._tTime !== n || !this._dur && !r || this._initted && Math.abs(this._zTime) === tt || !n && !this._initted && (this.add || this._ptLookup)) && (this._ts || (this._pTime = n), so(this, n, r)), this;
  }, t.time = function(n, r) {
    return arguments.length ? this.totalTime(Math.min(this.totalDuration(), n + fi(this)) % (this._dur + this._rDelay) || (n ? this._dur : 0), r) : this._time;
  }, t.totalProgress = function(n, r) {
    return arguments.length ? this.totalTime(this.totalDuration() * n, r) : this.totalDuration() ? Math.min(1, this._tTime / this._tDur) : this.rawTime() > 0 ? 1 : 0;
  }, t.progress = function(n, r) {
    return arguments.length ? this.totalTime(this.duration() * (this._yoyo && !(this.iteration() & 1) ? 1 - n : n) + fi(this), r) : this.duration() ? Math.min(1, this._time / this._dur) : this.rawTime() > 0 ? 1 : 0;
  }, t.iteration = function(n, r) {
    var s = this.duration() + this._rDelay;
    return arguments.length ? this.totalTime(this._time + (n - 1) * s, r) : this._repeat ? rn(this._tTime, s) + 1 : 1;
  }, t.timeScale = function(n, r) {
    if (!arguments.length)
      return this._rts === -tt ? 0 : this._rts;
    if (this._rts === n)
      return this;
    var s = this.parent && this._ts ? lr(this.parent._time, this) : this._tTime;
    return this._rts = +n || 0, this._ts = this._ps || n === -tt ? 0 : this._rts, this.totalTime(Rn(-Math.abs(this._delay), this._tDur, s), r !== !1), xr(this), oa(this);
  }, t.paused = function(n) {
    return arguments.length ? (this._ps !== n && (this._ps = n, n ? (this._pTime = this._tTime || Math.max(-this._delay, this.rawTime()), this._ts = this._act = 0) : (on(), this._ts = this._rts, this.totalTime(this.parent && !this.parent.smoothChildTiming ? this.rawTime() : this._tTime || this._pTime, this.progress() === 1 && Math.abs(this._zTime) !== tt && (this._tTime -= tt)))), this) : this._ps;
  }, t.startTime = function(n) {
    if (arguments.length) {
      this._start = n;
      var r = this.parent || this._dp;
      return r && (r._sort || !this.parent) && te(r, this, n - this._delay), this;
    }
    return this._start;
  }, t.endTime = function(n) {
    return this._start + (Mt(n) ? this.totalDuration() : this.duration()) / Math.abs(this._ts || 1);
  }, t.rawTime = function(n) {
    var r = this.parent || this._dp;
    return r ? n && (!this._ts || this._repeat && this._time && this.totalProgress() < 1) ? this._tTime % (this._dur + this._rDelay) : this._ts ? lr(r.rawTime(n), this) : this._tTime : this._tTime;
  }, t.revert = function(n) {
    n === void 0 && (n = na);
    var r = St;
    return St = n, (this._initted || this._startAt) && (this.timeline && this.timeline.revert(n), this.totalTime(-0.01, n.suppressEvents)), this.data !== "nested" && n.kill !== !1 && this.kill(), St = r, this;
  }, t.globalTime = function(n) {
    for (var r = this, s = arguments.length ? n : r.rawTime(); r; )
      s = r._start + s / (Math.abs(r._ts) || 1), r = r._dp;
    return !this.parent && this._sat ? this._sat.globalTime(n) : s;
  }, t.repeat = function(n) {
    return arguments.length ? (this._repeat = n === 1 / 0 ? -2 : n, hi(this)) : this._repeat === -2 ? 1 / 0 : this._repeat;
  }, t.repeatDelay = function(n) {
    if (arguments.length) {
      var r = this._time;
      return this._rDelay = n, hi(this), r ? this.time(r) : this;
    }
    return this._rDelay;
  }, t.yoyo = function(n) {
    return arguments.length ? (this._yoyo = n, this) : this._yoyo;
  }, t.seek = function(n, r) {
    return this.totalTime(Ut(this, n), Mt(r));
  }, t.restart = function(n, r) {
    return this.play().totalTime(n ? -this._delay : 0, Mt(r));
  }, t.play = function(n, r) {
    return n != null && this.seek(n, r), this.reversed(!1).paused(!1);
  }, t.reverse = function(n, r) {
    return n != null && this.seek(n || this.totalDuration(), r), this.reversed(!0).paused(!1);
  }, t.pause = function(n, r) {
    return n != null && this.seek(n, r), this.paused(!0);
  }, t.resume = function() {
    return this.paused(!1);
  }, t.reversed = function(n) {
    return arguments.length ? (!!n !== this.reversed() && this.timeScale(-this._rts || (n ? -tt : 0)), this) : this._rts < 0;
  }, t.invalidate = function() {
    return this._initted = this._act = 0, this._zTime = -tt, this;
  }, t.isActive = function() {
    var n = this.parent || this._dp, r = this._start, s;
    return !!(!n || this._ts && this._initted && n.isActive() && (s = n.rawTime(!0)) >= r && s < this.endTime(!0) - tt);
  }, t.eventCallback = function(n, r, s) {
    var o = this.vars;
    return arguments.length > 1 ? (r ? (o[n] = r, s && (o[n + "Params"] = s), n === "onUpdate" && (this._onUpdate = r)) : delete o[n], this) : o[n];
  }, t.then = function(n) {
    var r = this;
    return new Promise(function(s) {
      var o = lt(n) ? n : oo, c = function() {
        var l = r.then;
        r.then = null, lt(o) && (o = o(r)) && (o.then || o === r) && (r.then = l), s(o), r.then = l;
      };
      r._initted && r.totalProgress() === 1 && r._ts >= 0 || !r._tTime && r._ts < 0 ? c() : r._prom = c;
    });
  }, t.kill = function() {
    gn(this);
  }, i;
}();
Gt(Cn.prototype, {
  _time: 0,
  _start: 0,
  _end: 0,
  _tTime: 0,
  _tDur: 0,
  _dirty: 0,
  _repeat: 0,
  _yoyo: !1,
  parent: null,
  _initted: !1,
  _rDelay: 0,
  _ts: 1,
  _dp: 0,
  ratio: 0,
  _zTime: -tt,
  _prom: 0,
  _ps: !1,
  _rts: 1
});
var Ct = /* @__PURE__ */ function(i) {
  Xi(t, i);
  function t(n, r) {
    var s;
    return n === void 0 && (n = {}), s = i.call(this, n) || this, s.labels = {}, s.smoothChildTiming = !!n.smoothChildTiming, s.autoRemoveChildren = !!n.autoRemoveChildren, s._sort = Mt(n.sortChildren), it && te(n.parent || it, le(s), r), n.reversed && s.reverse(), n.paused && s.paused(!0), n.scrollTrigger && lo(le(s), n.scrollTrigger), s;
  }
  var e = t.prototype;
  return e.to = function(r, s, o) {
    return bn(0, arguments, this), this;
  }, e.from = function(r, s, o) {
    return bn(1, arguments, this), this;
  }, e.fromTo = function(r, s, o, c) {
    return bn(2, arguments, this), this;
  }, e.set = function(r, s, o) {
    return s.duration = 0, s.parent = this, vn(s).repeatDelay || (s.repeat = 0), s.immediateRender = !!s.immediateRender, new _t(r, s, Ut(this, o), 1), this;
  }, e.call = function(r, s, o) {
    return te(this, _t.delayedCall(0, r, s), o);
  }, e.staggerTo = function(r, s, o, c, a, l, u) {
    return o.duration = s, o.stagger = o.stagger || c, o.onComplete = l, o.onCompleteParams = u, o.parent = this, new _t(r, o, Ut(this, a)), this;
  }, e.staggerFrom = function(r, s, o, c, a, l, u) {
    return o.runBackwards = 1, vn(o).immediateRender = Mt(o.immediateRender), this.staggerTo(r, s, o, c, a, l, u);
  }, e.staggerFromTo = function(r, s, o, c, a, l, u, f) {
    return c.startAt = o, vn(c).immediateRender = Mt(c.immediateRender), this.staggerTo(r, s, c, a, l, u, f);
  }, e.render = function(r, s, o) {
    var c = this._time, a = this._dirty ? this.totalDuration() : this._tDur, l = this._dur, u = r <= 0 ? 0 : vt(r), f = this._zTime < 0 != r < 0 && (this._initted || !l), d, _, p, h, m, g, v, x, y, b, S, T;
    if (this !== it && u > a && r >= 0 && (u = a), u !== this._tTime || o || f) {
      if (c !== this._time && l && (u += this._time - c, r += this._time - c), d = u, y = this._start, x = this._ts, g = !x, f && (l || (c = this._zTime), (r || !s) && (this._zTime = r)), this._repeat) {
        if (S = this._yoyo, m = l + this._rDelay, this._repeat < -1 && r < 0)
          return this.totalTime(m * 100 + r, s, o);
        if (d = vt(u % m), u === a ? (h = this._repeat, d = l) : (h = ~~(u / m), h && h === u / m && (d = l, h--), d > l && (d = l)), b = rn(this._tTime, m), !c && this._tTime && b !== h && this._tTime - b * m - this._dur <= 0 && (b = h), S && h & 1 && (d = l - d, T = 1), h !== b && !this._lock) {
          var k = S && b & 1, w = k === (S && h & 1);
          if (h < b && (k = !k), c = k ? 0 : u % l ? l : u, this._lock = 1, this.render(c || (T ? 0 : vt(h * m)), s, !l)._lock = 0, this._tTime = u, !s && this.parent && Nt(this, "onRepeat"), this.vars.repeatRefresh && !T && (this.invalidate()._lock = 1), c && c !== this._time || g !== !this._ts || this.vars.onRepeat && !this.parent && !this._act)
            return this;
          if (l = this._dur, a = this._tDur, w && (this._lock = 2, c = k ? l : -1e-4, this.render(c, !0), this.vars.repeatRefresh && !T && this.invalidate()), this._lock = 0, !this._ts && !g)
            return this;
          ko(this, T);
        }
      }
      if (this._hasPause && !this._forcing && this._lock < 2 && (v = ua(this, vt(c), vt(d)), v && (u -= d - (d = v._start))), this._tTime = u, this._time = d, this._act = !x, this._initted || (this._onUpdate = this.vars.onUpdate, this._initted = 1, this._zTime = r, c = 0), !c && d && !s && !h && (Nt(this, "onStart"), this._tTime !== u))
        return this;
      if (d >= c && r >= 0)
        for (_ = this._first; _; ) {
          if (p = _._next, (_._act || d >= _._start) && _._ts && v !== _) {
            if (_.parent !== this)
              return this.render(r, s, o);
            if (_.render(_._ts > 0 ? (d - _._start) * _._ts : (_._dirty ? _.totalDuration() : _._tDur) + (d - _._start) * _._ts, s, o), d !== this._time || !this._ts && !g) {
              v = 0, p && (u += this._zTime = -tt);
              break;
            }
          }
          _ = p;
        }
      else {
        _ = this._last;
        for (var O = r < 0 ? r : d; _; ) {
          if (p = _._prev, (_._act || O <= _._end) && _._ts && v !== _) {
            if (_.parent !== this)
              return this.render(r, s, o);
            if (_.render(_._ts > 0 ? (O - _._start) * _._ts : (_._dirty ? _.totalDuration() : _._tDur) + (O - _._start) * _._ts, s, o || St && (_._initted || _._startAt)), d !== this._time || !this._ts && !g) {
              v = 0, p && (u += this._zTime = O ? -tt : tt);
              break;
            }
          }
          _ = p;
        }
      }
      if (v && !s && (this.pause(), v.render(d >= c ? 0 : -tt)._zTime = d >= c ? 1 : -1, this._ts))
        return this._start = y, xr(this), this.render(r, s, o);
      this._onUpdate && !s && Nt(this, "onUpdate", !0), (u === a && this._tTime >= this.totalDuration() || !u && c) && (y === this._start || Math.abs(x) !== Math.abs(this._ts)) && (this._lock || ((r || !l) && (u === a && this._ts > 0 || !u && this._ts < 0) && Ce(this, 1), !s && !(r < 0 && !c) && (u || c || !a) && (Nt(this, u === a && r >= 0 ? "onComplete" : "onReverseComplete", !0), this._prom && !(u < a && this.timeScale() > 0) && this._prom())));
    }
    return this;
  }, e.add = function(r, s) {
    var o = this;
    if (pe(s) || (s = Ut(this, s, r)), !(r instanceof Cn)) {
      if (Tt(r))
        return r.forEach(function(c) {
          return o.add(c, s);
        }), this;
      if (bt(r))
        return this.addLabel(r, s);
      if (lt(r))
        r = _t.delayedCall(0, r);
      else
        return this;
    }
    return this !== r ? te(this, r, s) : this;
  }, e.getChildren = function(r, s, o, c) {
    r === void 0 && (r = !0), s === void 0 && (s = !0), o === void 0 && (o = !0), c === void 0 && (c = -Yt);
    for (var a = [], l = this._first; l; )
      l._start >= c && (l instanceof _t ? s && a.push(l) : (o && a.push(l), r && a.push.apply(a, l.getChildren(!0, s, o)))), l = l._next;
    return a;
  }, e.getById = function(r) {
    for (var s = this.getChildren(1, 1, 1), o = s.length; o--; )
      if (s[o].vars.id === r)
        return s[o];
  }, e.remove = function(r) {
    return bt(r) ? this.removeLabel(r) : lt(r) ? this.killTweensOf(r) : (wr(this, r), r === this._recent && (this._recent = this._last), ze(this));
  }, e.totalTime = function(r, s) {
    return arguments.length ? (this._forcing = 1, !this._dp && this._ts && (this._start = vt(Ft.time - (this._ts > 0 ? r / this._ts : (this.totalDuration() - r) / -this._ts))), i.prototype.totalTime.call(this, r, s), this._forcing = 0, this) : this._tTime;
  }, e.addLabel = function(r, s) {
    return this.labels[r] = Ut(this, s), this;
  }, e.removeLabel = function(r) {
    return delete this.labels[r], this;
  }, e.addPause = function(r, s, o) {
    var c = _t.delayedCall(0, s || Sn, o);
    return c.data = "isPause", this._hasPause = 1, te(this, c, Ut(this, r));
  }, e.removePause = function(r) {
    var s = this._first;
    for (r = Ut(this, r); s; )
      s._start === r && s.data === "isPause" && Ce(s), s = s._next;
  }, e.killTweensOf = function(r, s, o) {
    for (var c = this.getTweensOf(r, o), a = c.length; a--; )
      ve !== c[a] && c[a].kill(r, s);
    return this;
  }, e.getTweensOf = function(r, s) {
    for (var o = [], c = Xt(r), a = this._first, l = pe(s), u; a; )
      a instanceof _t ? ra(a._targets, c) && (l ? (!ve || a._initted && a._ts) && a.globalTime(0) <= s && a.globalTime(a.totalDuration()) > s : !s || a.isActive()) && o.push(a) : (u = a.getTweensOf(c, s)).length && o.push.apply(o, u), a = a._next;
    return o;
  }, e.tweenTo = function(r, s) {
    s = s || {};
    var o = this, c = Ut(o, r), a = s, l = a.startAt, u = a.onStart, f = a.onStartParams, d = a.immediateRender, _, p = _t.to(o, Gt({
      ease: s.ease || "none",
      lazy: !1,
      immediateRender: !1,
      time: c,
      overwrite: "auto",
      duration: s.duration || Math.abs((c - (l && "time" in l ? l.time : o._time)) / o.timeScale()) || tt,
      onStart: function() {
        if (o.pause(), !_) {
          var m = s.duration || Math.abs((c - (l && "time" in l ? l.time : o._time)) / o.timeScale());
          p._dur !== m && sn(p, m, 0, 1).render(p._time, !0, !0), _ = 1;
        }
        u && u.apply(p, f || []);
      }
    }, s));
    return d ? p.render(0) : p;
  }, e.tweenFromTo = function(r, s, o) {
    return this.tweenTo(s, Gt({
      startAt: {
        time: Ut(this, r)
      }
    }, o));
  }, e.recent = function() {
    return this._recent;
  }, e.nextLabel = function(r) {
    return r === void 0 && (r = this._time), di(this, Ut(this, r));
  }, e.previousLabel = function(r) {
    return r === void 0 && (r = this._time), di(this, Ut(this, r), 1);
  }, e.currentLabel = function(r) {
    return arguments.length ? this.seek(r, !0) : this.previousLabel(this._time + tt);
  }, e.shiftChildren = function(r, s, o) {
    o === void 0 && (o = 0);
    for (var c = this._first, a = this.labels, l; c; )
      c._start >= o && (c._start += r, c._end += r), c = c._next;
    if (s)
      for (l in a)
        a[l] >= o && (a[l] += r);
    return ze(this);
  }, e.invalidate = function(r) {
    var s = this._first;
    for (this._lock = 0; s; )
      s.invalidate(r), s = s._next;
    return i.prototype.invalidate.call(this, r);
  }, e.clear = function(r) {
    r === void 0 && (r = !0);
    for (var s = this._first, o; s; )
      o = s._next, this.remove(s), s = o;
    return this._dp && (this._time = this._tTime = this._pTime = 0), r && (this.labels = {}), ze(this);
  }, e.totalDuration = function(r) {
    var s = 0, o = this, c = o._last, a = Yt, l, u, f;
    if (arguments.length)
      return o.timeScale((o._repeat < 0 ? o.duration() : o.totalDuration()) / (o.reversed() ? -r : r));
    if (o._dirty) {
      for (f = o.parent; c; )
        l = c._prev, c._dirty && c.totalDuration(), u = c._start, u > a && o._sort && c._ts && !o._lock ? (o._lock = 1, te(o, c, u - c._delay, 1)._lock = 0) : a = u, u < 0 && c._ts && (s -= u, (!f && !o._dp || f && f.smoothChildTiming) && (o._start += u / o._ts, o._time -= u, o._tTime -= u), o.shiftChildren(-u, !1, -1 / 0), a = 0), c._end > s && c._ts && (s = c._end), c = l;
      sn(o, o === it && o._time > s ? o._time : s, 1, 1), o._dirty = 0;
    }
    return o._tDur;
  }, t.updateRoot = function(r) {
    if (it._ts && (so(it, lr(r, it)), no = Ft.frame), Ft.frame >= li) {
      li += qt.autoSleep || 120;
      var s = it._first;
      if ((!s || !s._ts) && qt.autoSleep && Ft._listeners.length < 2) {
        for (; s && !s._ts; )
          s = s._next;
        s || Ft.sleep();
      }
    }
  }, t;
}(Cn);
Gt(Ct.prototype, {
  _lock: 0,
  _hasPause: 0,
  _forcing: 0
});
var Ca = function(t, e, n, r, s, o, c) {
  var a = new Dt(this._pt, t, e, 0, 1, Lo, null, s), l = 0, u = 0, f, d, _, p, h, m, g, v;
  for (a.b = n, a.e = r, n += "", r += "", (g = ~r.indexOf("random(")) && (r = Tn(r)), o && (v = [n, r], o(v, t, e), n = v[0], r = v[1]), d = n.match($r) || []; f = $r.exec(r); )
    p = f[0], h = r.substring(l, f.index), _ ? _ = (_ + 1) % 5 : h.substr(-5) === "rgba(" && (_ = 1), p !== d[u++] && (m = parseFloat(d[u - 1]) || 0, a._pt = {
      _next: a._pt,
      p: h || u === 1 ? h : ",",
      //note: SVG spec allows omission of comma/space when a negative sign is wedged between two numbers, like 2.5-5.3 instead of 2.5,-5.3 but when tweening, the negative value may switch to positive, so we insert the comma just in case.
      s: m,
      c: p.charAt(1) === "=" ? Ze(m, p) - m : parseFloat(p) - m,
      m: _ && _ < 4 ? Math.round : 0
    }, l = $r.lastIndex);
  return a.c = l < r.length ? r.substring(l, r.length) : "", a.fp = c, (Zi.test(r) || g) && (a.e = 0), this._pt = a, a;
}, Rs = function(t, e, n, r, s, o, c, a, l, u) {
  lt(r) && (r = r(s || 0, t, o));
  var f = t[e], d = n !== "get" ? n : lt(f) ? l ? t[e.indexOf("set") || !lt(t["get" + e.substr(3)]) ? e : "get" + e.substr(3)](l) : t[e]() : f, _ = lt(f) ? l ? Ea : Eo : $s, p;
  if (bt(r) && (~r.indexOf("random(") && (r = Tn(r)), r.charAt(1) === "=" && (p = Ze(d, r) + (xt(d) || 0), (p || p === 0) && (r = p))), !u || d !== r || rs)
    return !isNaN(d * r) && r !== "" ? (p = new Dt(this._pt, t, e, +d || 0, r - (d || 0), typeof f == "boolean" ? La : Do, 0, _), l && (p.fp = l), c && p.modifier(c, this, t), this._pt = p) : (!f && !(e in t) && Ms(e, r), Ca.call(this, t, e, d, r, _, a || qt.stringFilter, l));
}, Oa = function(t, e, n, r, s) {
  if (lt(t) && (t = wn(t, s, e, n, r)), !oe(t) || t.style && t.nodeType || Tt(t) || Ki(t))
    return bt(t) ? wn(t, s, e, n, r) : t;
  var o = {}, c;
  for (c in t)
    o[c] = wn(t[c], s, e, n, r);
  return o;
}, Ao = function(t, e, n, r, s, o) {
  var c, a, l, u;
  if ($t[t] && (c = new $t[t]()).init(s, c.rawVars ? e[t] : Oa(e[t], r, s, o, n), n, r, o) !== !1 && (n._pt = a = new Dt(n._pt, s, t, 0, 1, c.render, c, 0, c.priority), n !== Ge))
    for (l = n._ptLookup[n._targets.indexOf(s)], u = c._props.length; u--; )
      l[c._props[u]] = a;
  return c;
}, ve, rs, Is = function i(t, e, n) {
  var r = t.vars, s = r.ease, o = r.startAt, c = r.immediateRender, a = r.lazy, l = r.onUpdate, u = r.runBackwards, f = r.yoyoEase, d = r.keyframes, _ = r.autoRevert, p = t._dur, h = t._startAt, m = t._targets, g = t.parent, v = g && g.data === "nested" ? g.vars.targets : m, x = t._overwrite === "auto" && !Cs, y = t.timeline, b, S, T, k, w, O, E, M, L, $, q, H, N;
  if (y && (!d || !s) && (s = "none"), t._ease = He(s, nn.ease), t._yEase = f ? To(He(f === !0 ? s : f, nn.ease)) : 0, f && t._yoyo && !t._repeat && (f = t._yEase, t._yEase = t._ease, t._ease = f), t._from = !y && !!r.runBackwards, !y || d && !r.stagger) {
    if (M = m[0] ? Fe(m[0]).harness : 0, H = M && r[M.prop], b = ar(r, Es), h && (h._zTime < 0 && h.progress(1), e < 0 && u && c && !_ ? h.render(-1, !0) : h.revert(u && p ? Jn : ea), h._lazy = 0), o) {
      if (Ce(t._startAt = _t.set(m, Gt({
        data: "isStart",
        overwrite: !1,
        parent: g,
        immediateRender: !0,
        lazy: !h && Mt(a),
        startAt: null,
        delay: 0,
        onUpdate: l && function() {
          return Nt(t, "onUpdate");
        },
        stagger: 0
      }, o))), t._startAt._dp = 0, t._startAt._sat = t, e < 0 && (St || !c && !_) && t._startAt.revert(Jn), c && p && e <= 0 && n <= 0) {
        e && (t._zTime = e);
        return;
      }
    } else if (u && p && !h) {
      if (e && (c = !1), T = Gt({
        overwrite: !1,
        data: "isFromStart",
        //we tag the tween with as "isFromStart" so that if [inside a plugin] we need to only do something at the very END of a tween, we have a way of identifying this tween as merely the one that's setting the beginning values for a "from()" tween. For example, clearProps in CSSPlugin should only get applied at the very END of a tween and without this tag, from(...{height:100, clearProps:"height", delay:1}) would wipe the height at the beginning of the tween and after 1 second, it'd kick back in.
        lazy: c && !h && Mt(a),
        immediateRender: c,
        //zero-duration tweens render immediately by default, but if we're not specifically instructed to render this tween immediately, we should skip this and merely _init() to record the starting values (rendering them immediately would push them to completion which is wasteful in that case - we'd have to render(-1) immediately after)
        stagger: 0,
        parent: g
        //ensures that nested tweens that had a stagger are handled properly, like gsap.from(".class", {y: gsap.utils.wrap([-100,100]), stagger: 0.5})
      }, b), H && (T[M.prop] = H), Ce(t._startAt = _t.set(m, T)), t._startAt._dp = 0, t._startAt._sat = t, e < 0 && (St ? t._startAt.revert(Jn) : t._startAt.render(-1, !0)), t._zTime = e, !c)
        i(t._startAt, tt, tt);
      else if (!e)
        return;
    }
    for (t._pt = t._ptCache = 0, a = p && Mt(a) || a && !p, S = 0; S < m.length; S++) {
      if (w = m[S], E = w._gsap || Ls(m)[S]._gsap, t._ptLookup[S] = $ = {}, Zr[E.id] && xe.length && cr(), q = v === m ? S : v.indexOf(w), M && (L = new M()).init(w, H || b, t, q, v) !== !1 && (t._pt = k = new Dt(t._pt, w, L.name, 0, 1, L.render, L, 0, L.priority), L._props.forEach(function(W) {
        $[W] = k;
      }), L.priority && (O = 1)), !M || H)
        for (T in b)
          $t[T] && (L = Ao(T, b, t, q, w, v)) ? L.priority && (O = 1) : $[T] = k = Rs.call(t, w, T, "get", b[T], q, v, 0, r.stringFilter);
      t._op && t._op[S] && t.kill(w, t._op[S]), x && t._pt && (ve = t, it.killTweensOf(w, $, t.globalTime(e)), N = !t.parent, ve = 0), t._pt && a && (Zr[E.id] = 1);
    }
    O && Ro(t), t._onInit && t._onInit(t);
  }
  t._onUpdate = l, t._initted = (!t._op || t._pt) && !N, d && e <= 0 && y.render(Yt, !0, !0);
}, Aa = function(t, e, n, r, s, o, c, a) {
  var l = (t._pt && t._ptCache || (t._ptCache = {}))[e], u, f, d, _;
  if (!l)
    for (l = t._ptCache[e] = [], d = t._ptLookup, _ = t._targets.length; _--; ) {
      if (u = d[_][e], u && u.d && u.d._pt)
        for (u = u.d._pt; u && u.p !== e && u.fp !== e; )
          u = u._next;
      if (!u)
        return rs = 1, t.vars[e] = "+=0", Is(t, c), rs = 0, a ? xn(e + " not eligible for reset") : 1;
      l.push(u);
    }
  for (_ = l.length; _--; )
    f = l[_], u = f._pt || f, u.s = (r || r === 0) && !s ? r : u.s + (r || 0) + o * u.c, u.c = n - u.s, f.e && (f.e = ht(n) + xt(f.e)), f.b && (f.b = u.s + xt(f.b));
}, Pa = function(t, e) {
  var n = t[0] ? Fe(t[0]).harness : 0, r = n && n.aliases, s, o, c, a;
  if (!r)
    return e;
  s = Ve({}, e);
  for (o in r)
    if (o in s)
      for (a = r[o].split(","), c = a.length; c--; )
        s[a[c]] = s[o];
  return s;
}, Ma = function(t, e, n, r) {
  var s = e.ease || r || "power1.inOut", o, c;
  if (Tt(e))
    c = n[t] || (n[t] = []), e.forEach(function(a, l) {
      return c.push({
        t: l / (e.length - 1) * 100,
        v: a,
        e: s
      });
    });
  else
    for (o in e)
      c = n[o] || (n[o] = []), o === "ease" || c.push({
        t: parseFloat(t),
        v: e[o],
        e: s
      });
}, wn = function(t, e, n, r, s) {
  return lt(t) ? t.call(e, n, r, s) : bt(t) && ~t.indexOf("random(") ? Tn(t) : t;
}, Po = Ds + "repeat,repeatDelay,yoyo,repeatRefresh,yoyoEase,autoRevert", Mo = {};
Et(Po + ",id,stagger,delay,duration,paused,scrollTrigger", function(i) {
  return Mo[i] = 1;
});
var _t = /* @__PURE__ */ function(i) {
  Xi(t, i);
  function t(n, r, s, o) {
    var c;
    typeof r == "number" && (s.duration = r, r = s, s = null), c = i.call(this, o ? r : vn(r)) || this;
    var a = c.vars, l = a.duration, u = a.delay, f = a.immediateRender, d = a.stagger, _ = a.overwrite, p = a.keyframes, h = a.defaults, m = a.scrollTrigger, g = a.yoyoEase, v = r.parent || it, x = (Tt(n) || Ki(n) ? pe(n[0]) : "length" in r) ? [n] : Xt(n), y, b, S, T, k, w, O, E;
    if (c._targets = x.length ? Ls(x) : xn("GSAP target " + n + " not found. https://gsap.com", !qt.nullTargetWarn) || [], c._ptLookup = [], c._overwrite = _, p || d || Kn(l) || Kn(u)) {
      if (r = c.vars, y = c.timeline = new Ct({
        data: "nested",
        defaults: h || {},
        targets: v && v.data === "nested" ? v.vars.targets : x
      }), y.kill(), y.parent = y._dp = le(c), y._start = 0, d || Kn(l) || Kn(u)) {
        if (T = x.length, O = d && po(d), oe(d))
          for (k in d)
            ~Po.indexOf(k) && (E || (E = {}), E[k] = d[k]);
        for (b = 0; b < T; b++)
          S = ar(r, Mo), S.stagger = 0, g && (S.yoyoEase = g), E && Ve(S, E), w = x[b], S.duration = +wn(l, le(c), b, w, x), S.delay = (+wn(u, le(c), b, w, x) || 0) - c._delay, !d && T === 1 && S.delay && (c._delay = u = S.delay, c._start += u, S.delay = 0), y.to(w, S, O ? O(b, w, x) : 0), y._ease = G.none;
        y.duration() ? l = u = 0 : c.timeline = 0;
      } else if (p) {
        vn(Gt(y.vars.defaults, {
          ease: "none"
        })), y._ease = He(p.ease || r.ease || "none");
        var M = 0, L, $, q;
        if (Tt(p))
          p.forEach(function(H) {
            return y.to(x, H, ">");
          }), y.duration();
        else {
          S = {};
          for (k in p)
            k === "ease" || k === "easeEach" || Ma(k, p[k], S, p.easeEach);
          for (k in S)
            for (L = S[k].sort(function(H, N) {
              return H.t - N.t;
            }), M = 0, b = 0; b < L.length; b++)
              $ = L[b], q = {
                ease: $.e,
                duration: ($.t - (b ? L[b - 1].t : 0)) / 100 * l
              }, q[k] = $.v, y.to(x, q, M), M += q.duration;
          y.duration() < l && y.to({}, {
            duration: l - y.duration()
          });
        }
      }
      l || c.duration(l = y.duration());
    } else
      c.timeline = 0;
    return _ === !0 && !Cs && (ve = le(c), it.killTweensOf(x), ve = 0), te(v, le(c), s), r.reversed && c.reverse(), r.paused && c.paused(!0), (f || !l && !p && c._start === vt(v._time) && Mt(f) && ca(le(c)) && v.data !== "nested") && (c._tTime = -tt, c.render(Math.max(0, -u) || 0)), m && lo(le(c), m), c;
  }
  var e = t.prototype;
  return e.render = function(r, s, o) {
    var c = this._time, a = this._tDur, l = this._dur, u = r < 0, f = r > a - tt && !u ? a : r < tt ? 0 : r, d, _, p, h, m, g, v, x, y;
    if (!l)
      la(this, r, s, o);
    else if (f !== this._tTime || !r || o || !this._initted && this._tTime || this._startAt && this._zTime < 0 !== u) {
      if (d = f, x = this.timeline, this._repeat) {
        if (h = l + this._rDelay, this._repeat < -1 && u)
          return this.totalTime(h * 100 + r, s, o);
        if (d = vt(f % h), f === a ? (p = this._repeat, d = l) : (p = ~~(f / h), p && p === vt(f / h) && (d = l, p--), d > l && (d = l)), g = this._yoyo && p & 1, g && (y = this._yEase, d = l - d), m = rn(this._tTime, h), d === c && !o && this._initted && p === m)
          return this._tTime = f, this;
        p !== m && (x && this._yEase && ko(x, g), this.vars.repeatRefresh && !g && !this._lock && this._time !== h && this._initted && (this._lock = o = 1, this.render(vt(h * p), !0).invalidate()._lock = 0));
      }
      if (!this._initted) {
        if (uo(this, u ? r : d, o, s, f))
          return this._tTime = 0, this;
        if (c !== this._time && !(o && this.vars.repeatRefresh && p !== m))
          return this;
        if (l !== this._dur)
          return this.render(r, s, o);
      }
      if (this._tTime = f, this._time = d, !this._act && this._ts && (this._act = 1, this._lazy = 0), this.ratio = v = (y || this._ease)(d / l), this._from && (this.ratio = v = 1 - v), d && !c && !s && !p && (Nt(this, "onStart"), this._tTime !== f))
        return this;
      for (_ = this._pt; _; )
        _.r(v, _.d), _ = _._next;
      x && x.render(r < 0 ? r : x._dur * x._ease(d / this._dur), s, o) || this._startAt && (this._zTime = r), this._onUpdate && !s && (u && Qr(this, r, s, o), Nt(this, "onUpdate")), this._repeat && p !== m && this.vars.onRepeat && !s && this.parent && Nt(this, "onRepeat"), (f === this._tDur || !f) && this._tTime === f && (u && !this._onUpdate && Qr(this, r, !0, !0), (r || !l) && (f === this._tDur && this._ts > 0 || !f && this._ts < 0) && Ce(this, 1), !s && !(u && !c) && (f || c || g) && (Nt(this, f === a ? "onComplete" : "onReverseComplete", !0), this._prom && !(f < a && this.timeScale() > 0) && this._prom()));
    }
    return this;
  }, e.targets = function() {
    return this._targets;
  }, e.invalidate = function(r) {
    return (!r || !this.vars.runBackwards) && (this._startAt = 0), this._pt = this._op = this._onUpdate = this._lazy = this.ratio = 0, this._ptLookup = [], this.timeline && this.timeline.invalidate(r), i.prototype.invalidate.call(this, r);
  }, e.resetTo = function(r, s, o, c, a) {
    kn || Ft.wake(), this._ts || this.play();
    var l = Math.min(this._dur, (this._dp._time - this._start) * this._ts), u;
    return this._initted || Is(this, l), u = this._ease(l / this._dur), Aa(this, r, s, o, c, u, l, a) ? this.resetTo(r, s, o, c, 1) : (Sr(this, 0), this.parent || co(this._dp, this, "_first", "_last", this._dp._sort ? "_start" : 0), this.render(0));
  }, e.kill = function(r, s) {
    if (s === void 0 && (s = "all"), !r && (!s || s === "all"))
      return this._lazy = this._pt = 0, this.parent ? gn(this) : this;
    if (this.timeline) {
      var o = this.timeline.totalDuration();
      return this.timeline.killTweensOf(r, s, ve && ve.vars.overwrite !== !0)._first || gn(this), this.parent && o !== this.timeline.totalDuration() && sn(this, this._dur * this.timeline._tDur / o, 0, 1), this;
    }
    var c = this._targets, a = r ? Xt(r) : c, l = this._ptLookup, u = this._pt, f, d, _, p, h, m, g;
    if ((!s || s === "all") && ia(c, a))
      return s === "all" && (this._pt = 0), gn(this);
    for (f = this._op = this._op || [], s !== "all" && (bt(s) && (h = {}, Et(s, function(v) {
      return h[v] = 1;
    }), s = h), s = Pa(c, s)), g = c.length; g--; )
      if (~a.indexOf(c[g])) {
        d = l[g], s === "all" ? (f[g] = s, p = d, _ = {}) : (_ = f[g] = f[g] || {}, p = s);
        for (h in p)
          m = d && d[h], m && ((!("kill" in m.d) || m.d.kill(h) === !0) && wr(this, m, "_pt"), delete d[h]), _ !== "all" && (_[h] = 1);
      }
    return this._initted && !this._pt && u && gn(this), this;
  }, t.to = function(r, s) {
    return new t(r, s, arguments[2]);
  }, t.from = function(r, s) {
    return bn(1, arguments);
  }, t.delayedCall = function(r, s, o, c) {
    return new t(s, 0, {
      immediateRender: !1,
      lazy: !1,
      overwrite: !1,
      delay: r,
      onComplete: s,
      onReverseComplete: s,
      onCompleteParams: o,
      onReverseCompleteParams: o,
      callbackScope: c
    });
  }, t.fromTo = function(r, s, o) {
    return bn(2, arguments);
  }, t.set = function(r, s) {
    return s.duration = 0, s.repeatDelay || (s.repeat = 0), new t(r, s);
  }, t.killTweensOf = function(r, s, o) {
    return it.killTweensOf(r, s, o);
  }, t;
}(Cn);
Gt(_t.prototype, {
  _targets: [],
  _lazy: 0,
  _startAt: 0,
  _op: 0,
  _onInit: 0
});
Et("staggerTo,staggerFrom,staggerFromTo", function(i) {
  _t[i] = function() {
    var t = new Ct(), e = ts.call(arguments, 0);
    return e.splice(i === "staggerFromTo" ? 5 : 4, 0, 0), t[i].apply(t, e);
  };
});
var $s = function(t, e, n) {
  return t[e] = n;
}, Eo = function(t, e, n) {
  return t[e](n);
}, Ea = function(t, e, n, r) {
  return t[e](r.fp, n);
}, Da = function(t, e, n) {
  return t.setAttribute(e, n);
}, Fs = function(t, e) {
  return lt(t[e]) ? Eo : Os(t[e]) && t.setAttribute ? Da : $s;
}, Do = function(t, e) {
  return e.set(e.t, e.p, Math.round((e.s + e.c * t) * 1e6) / 1e6, e);
}, La = function(t, e) {
  return e.set(e.t, e.p, !!(e.s + e.c * t), e);
}, Lo = function(t, e) {
  var n = e._pt, r = "";
  if (!t && e.b)
    r = e.b;
  else if (t === 1 && e.e)
    r = e.e;
  else {
    for (; n; )
      r = n.p + (n.m ? n.m(n.s + n.c * t) : Math.round((n.s + n.c * t) * 1e4) / 1e4) + r, n = n._next;
    r += e.c;
  }
  e.set(e.t, e.p, r, e);
}, zs = function(t, e) {
  for (var n = e._pt; n; )
    n.r(t, n.d), n = n._next;
}, Ra = function(t, e, n, r) {
  for (var s = this._pt, o; s; )
    o = s._next, s.p === r && s.modifier(t, e, n), s = o;
}, Ia = function(t) {
  for (var e = this._pt, n, r; e; )
    r = e._next, e.p === t && !e.op || e.op === t ? wr(this, e, "_pt") : e.dep || (n = 1), e = r;
  return !n;
}, $a = function(t, e, n, r) {
  r.mSet(t, e, r.m.call(r.tween, n, r.mt), r);
}, Ro = function(t) {
  for (var e = t._pt, n, r, s, o; e; ) {
    for (n = e._next, r = s; r && r.pr > e.pr; )
      r = r._next;
    (e._prev = r ? r._prev : o) ? e._prev._next = e : s = e, (e._next = r) ? r._prev = e : o = e, e = n;
  }
  t._pt = s;
}, Dt = /* @__PURE__ */ function() {
  function i(e, n, r, s, o, c, a, l, u) {
    this.t = n, this.s = s, this.c = o, this.p = r, this.r = c || Do, this.d = a || this, this.set = l || $s, this.pr = u || 0, this._next = e, e && (e._prev = this);
  }
  var t = i.prototype;
  return t.modifier = function(n, r, s) {
    this.mSet = this.mSet || this.set, this.set = $a, this.m = n, this.mt = s, this.tween = r;
  }, i;
}();
Et(Ds + "parent,duration,ease,delay,overwrite,runBackwards,startAt,yoyo,immediateRender,repeat,repeatDelay,data,paused,reversed,lazy,callbackScope,stringFilter,id,yoyoEase,stagger,inherit,repeatRefresh,keyframes,autoRevert,scrollTrigger", function(i) {
  return Es[i] = 1;
});
Vt.TweenMax = Vt.TweenLite = _t;
Vt.TimelineLite = Vt.TimelineMax = Ct;
it = new Ct({
  sortChildren: !1,
  defaults: nn,
  autoRemoveChildren: !0,
  id: "root",
  smoothChildTiming: !0
});
qt.stringFilter = So;
var Ne = [], er = {}, Fa = [], _i = 0, za = 0, qr = function(t) {
  return (er[t] || Fa).map(function(e) {
    return e();
  });
}, ss = function() {
  var t = Date.now(), e = [];
  t - _i > 2 && (qr("matchMediaInit"), Ne.forEach(function(n) {
    var r = n.queries, s = n.conditions, o, c, a, l;
    for (c in r)
      o = Jt.matchMedia(r[c]).matches, o && (a = 1), o !== s[c] && (s[c] = o, l = 1);
    l && (n.revert(), a && e.push(n));
  }), qr("matchMediaRevert"), e.forEach(function(n) {
    return n.onMatch(n, function(r) {
      return n.add(null, r);
    });
  }), _i = t, qr("matchMedia"));
}, Io = /* @__PURE__ */ function() {
  function i(e, n) {
    this.selector = n && es(n), this.data = [], this._r = [], this.isReverted = !1, this.id = za++, e && this.add(e);
  }
  var t = i.prototype;
  return t.add = function(n, r, s) {
    lt(n) && (s = r, r = n, n = lt);
    var o = this, c = function() {
      var l = rt, u = o.selector, f;
      return l && l !== o && l.data.push(o), s && (o.selector = es(s)), rt = o, f = r.apply(o, arguments), lt(f) && o._r.push(f), rt = l, o.selector = u, o.isReverted = !1, f;
    };
    return o.last = c, n === lt ? c(o, function(a) {
      return o.add(null, a);
    }) : n ? o[n] = c : c;
  }, t.ignore = function(n) {
    var r = rt;
    rt = null, n(this), rt = r;
  }, t.getTweens = function() {
    var n = [];
    return this.data.forEach(function(r) {
      return r instanceof i ? n.push.apply(n, r.getTweens()) : r instanceof _t && !(r.parent && r.parent.data === "nested") && n.push(r);
    }), n;
  }, t.clear = function() {
    this._r.length = this.data.length = 0;
  }, t.kill = function(n, r) {
    var s = this;
    if (n ? function() {
      for (var c = s.getTweens(), a = s.data.length, l; a--; )
        l = s.data[a], l.data === "isFlip" && (l.revert(), l.getChildren(!0, !0, !1).forEach(function(u) {
          return c.splice(c.indexOf(u), 1);
        }));
      for (c.map(function(u) {
        return {
          g: u._dur || u._delay || u._sat && !u._sat.vars.immediateRender ? u.globalTime(0) : -1 / 0,
          t: u
        };
      }).sort(function(u, f) {
        return f.g - u.g || -1 / 0;
      }).forEach(function(u) {
        return u.t.revert(n);
      }), a = s.data.length; a--; )
        l = s.data[a], l instanceof Ct ? l.data !== "nested" && (l.scrollTrigger && l.scrollTrigger.revert(), l.kill()) : !(l instanceof _t) && l.revert && l.revert(n);
      s._r.forEach(function(u) {
        return u(n, s);
      }), s.isReverted = !0;
    }() : this.data.forEach(function(c) {
      return c.kill && c.kill();
    }), this.clear(), r)
      for (var o = Ne.length; o--; )
        Ne[o].id === this.id && Ne.splice(o, 1);
  }, t.revert = function(n) {
    this.kill(n || {});
  }, i;
}(), Ha = /* @__PURE__ */ function() {
  function i(e) {
    this.contexts = [], this.scope = e, rt && rt.data.push(this);
  }
  var t = i.prototype;
  return t.add = function(n, r, s) {
    oe(n) || (n = {
      matches: n
    });
    var o = new Io(0, s || this.scope), c = o.conditions = {}, a, l, u;
    rt && !o.selector && (o.selector = rt.selector), this.contexts.push(o), r = o.add("onMatch", r), o.queries = n;
    for (l in n)
      l === "all" ? u = 1 : (a = Jt.matchMedia(n[l]), a && (Ne.indexOf(o) < 0 && Ne.push(o), (c[l] = a.matches) && (u = 1), a.addListener ? a.addListener(ss) : a.addEventListener("change", ss)));
    return u && r(o, function(f) {
      return o.add(null, f);
    }), this;
  }, t.revert = function(n) {
    this.kill(n || {});
  }, t.kill = function(n) {
    this.contexts.forEach(function(r) {
      return r.kill(n, !0);
    });
  }, i;
}(), ur = {
  registerPlugin: function() {
    for (var t = arguments.length, e = new Array(t), n = 0; n < t; n++)
      e[n] = arguments[n];
    e.forEach(function(r) {
      return bo(r);
    });
  },
  timeline: function(t) {
    return new Ct(t);
  },
  getTweensOf: function(t, e) {
    return it.getTweensOf(t, e);
  },
  getProperty: function(t, e, n, r) {
    bt(t) && (t = Xt(t)[0]);
    var s = Fe(t || {}).get, o = n ? oo : io;
    return n === "native" && (n = ""), t && (e ? o(($t[e] && $t[e].get || s)(t, e, n, r)) : function(c, a, l) {
      return o(($t[c] && $t[c].get || s)(t, c, a, l));
    });
  },
  quickSetter: function(t, e, n) {
    if (t = Xt(t), t.length > 1) {
      var r = t.map(function(u) {
        return Rt.quickSetter(u, e, n);
      }), s = r.length;
      return function(u) {
        for (var f = s; f--; )
          r[f](u);
      };
    }
    t = t[0] || {};
    var o = $t[e], c = Fe(t), a = c.harness && (c.harness.aliases || {})[e] || e, l = o ? function(u) {
      var f = new o();
      Ge._pt = 0, f.init(t, n ? u + n : u, Ge, 0, [t]), f.render(1, f), Ge._pt && zs(1, Ge);
    } : c.set(t, a);
    return o ? l : function(u) {
      return l(t, a, n ? u + n : u, c, 1);
    };
  },
  quickTo: function(t, e, n) {
    var r, s = Rt.to(t, Ve((r = {}, r[e] = "+=0.1", r.paused = !0, r), n || {})), o = function(a, l, u) {
      return s.resetTo(e, a, l, u);
    };
    return o.tween = s, o;
  },
  isTweening: function(t) {
    return it.getTweensOf(t, !0).length > 0;
  },
  defaults: function(t) {
    return t && t.ease && (t.ease = He(t.ease, nn.ease)), ui(nn, t || {});
  },
  config: function(t) {
    return ui(qt, t || {});
  },
  registerEffect: function(t) {
    var e = t.name, n = t.effect, r = t.plugins, s = t.defaults, o = t.extendTimeline;
    (r || "").split(",").forEach(function(c) {
      return c && !$t[c] && !Vt[c] && xn(e + " effect requires " + c + " plugin.");
    }), Fr[e] = function(c, a, l) {
      return n(Xt(c), Gt(a || {}, s), l);
    }, o && (Ct.prototype[e] = function(c, a, l) {
      return this.add(Fr[e](c, oe(a) ? a : (l = a) && {}, this), l);
    });
  },
  registerEase: function(t, e) {
    G[t] = He(e);
  },
  parseEase: function(t, e) {
    return arguments.length ? He(t, e) : G;
  },
  getById: function(t) {
    return it.getById(t);
  },
  exportRoot: function(t, e) {
    t === void 0 && (t = {});
    var n = new Ct(t), r, s;
    for (n.smoothChildTiming = Mt(t.smoothChildTiming), it.remove(n), n._dp = 0, n._time = n._tTime = it._time, r = it._first; r; )
      s = r._next, (e || !(!r._dur && r instanceof _t && r.vars.onComplete === r._targets[0])) && te(n, r, r._start - r._delay), r = s;
    return te(it, n, 0), n;
  },
  context: function(t, e) {
    return t ? new Io(t, e) : rt;
  },
  matchMedia: function(t) {
    return new Ha(t);
  },
  matchMediaRefresh: function() {
    return Ne.forEach(function(t) {
      var e = t.conditions, n, r;
      for (r in e)
        e[r] && (e[r] = !1, n = 1);
      n && t.revert();
    }) || ss();
  },
  addEventListener: function(t, e) {
    var n = er[t] || (er[t] = []);
    ~n.indexOf(e) || n.push(e);
  },
  removeEventListener: function(t, e) {
    var n = er[t], r = n && n.indexOf(e);
    r >= 0 && n.splice(r, 1);
  },
  utils: {
    wrap: ga,
    wrapYoyo: ya,
    distribute: po,
    random: mo,
    snap: _o,
    normalize: ma,
    getUnit: xt,
    clamp: ha,
    splitColor: wo,
    toArray: Xt,
    selector: es,
    mapRange: yo,
    pipe: pa,
    unitize: _a,
    interpolate: va,
    shuffle: ho
  },
  install: to,
  effects: Fr,
  ticker: Ft,
  updateRoot: Ct.updateRoot,
  plugins: $t,
  globalTimeline: it,
  core: {
    PropTween: Dt,
    globals: eo,
    Tween: _t,
    Timeline: Ct,
    Animation: Cn,
    getCache: Fe,
    _removeLinkedListItem: wr,
    reverting: function() {
      return St;
    },
    context: function(t) {
      return t && rt && (rt.data.push(t), t._ctx = rt), rt;
    },
    suppressOverwrites: function(t) {
      return Cs = t;
    }
  }
};
Et("to,from,fromTo,delayedCall,set,killTweensOf", function(i) {
  return ur[i] = _t[i];
});
Ft.add(Ct.updateRoot);
Ge = ur.to({}, {
  duration: 0
});
var Na = function(t, e) {
  for (var n = t._pt; n && n.p !== e && n.op !== e && n.fp !== e; )
    n = n._next;
  return n;
}, qa = function(t, e) {
  var n = t._targets, r, s, o;
  for (r in e)
    for (s = n.length; s--; )
      o = t._ptLookup[s][r], o && (o = o.d) && (o._pt && (o = Na(o, r)), o && o.modifier && o.modifier(e[r], t, n[s], r));
}, Br = function(t, e) {
  return {
    name: t,
    rawVars: 1,
    //don't pre-process function-based values or "random()" strings.
    init: function(r, s, o) {
      o._onInit = function(c) {
        var a, l;
        if (bt(s) && (a = {}, Et(s, function(u) {
          return a[u] = 1;
        }), s = a), e) {
          a = {};
          for (l in s)
            a[l] = e(s[l]);
          s = a;
        }
        qa(c, s);
      };
    }
  };
}, Rt = ur.registerPlugin({
  name: "attr",
  init: function(t, e, n, r, s) {
    var o, c, a;
    this.tween = n;
    for (o in e)
      a = t.getAttribute(o) || "", c = this.add(t, "setAttribute", (a || 0) + "", e[o], r, s, 0, 0, o), c.op = o, c.b = a, this._props.push(o);
  },
  render: function(t, e) {
    for (var n = e._pt; n; )
      St ? n.set(n.t, n.p, n.b, n) : n.r(t, n.d), n = n._next;
  }
}, {
  name: "endArray",
  init: function(t, e) {
    for (var n = e.length; n--; )
      this.add(t, n, t[n] || 0, e[n], 0, 0, 0, 0, 0, 1);
  }
}, Br("roundProps", ns), Br("modifiers"), Br("snap", _o)) || ur;
_t.version = Ct.version = Rt.version = "3.12.5";
Ji = 1;
As() && on();
G.Power0;
G.Power1;
G.Power2;
G.Power3;
G.Power4;
G.Linear;
G.Quad;
G.Cubic;
G.Quart;
G.Quint;
G.Strong;
G.Elastic;
G.Back;
G.SteppedEase;
G.Bounce;
G.Sine;
G.Expo;
G.Circ;
/*!
 * CSSPlugin 3.12.5
 * https://gsap.com
 *
 * Copyright 2008-2024, GreenSock. All rights reserved.
 * Subject to the terms at https://gsap.com/standard-license or for
 * Club GSAP members, the agreement issued with that membership.
 * @author: Jack Doyle, jack@greensock.com
*/
var mi, be, Qe, Hs, Ie, gi, Ns, Ba = function() {
  return typeof window < "u";
}, _e = {}, Re = 180 / Math.PI, Je = Math.PI / 180, Ye = Math.atan2, yi = 1e8, qs = /([A-Z])/g, Va = /(left|right|width|margin|padding|x)/i, Wa = /[\s,\(]\S/, ee = {
  autoAlpha: "opacity,visibility",
  scale: "scaleX,scaleY",
  alpha: "opacity"
}, is = function(t, e) {
  return e.set(e.t, e.p, Math.round((e.s + e.c * t) * 1e4) / 1e4 + e.u, e);
}, Ua = function(t, e) {
  return e.set(e.t, e.p, t === 1 ? e.e : Math.round((e.s + e.c * t) * 1e4) / 1e4 + e.u, e);
}, Ya = function(t, e) {
  return e.set(e.t, e.p, t ? Math.round((e.s + e.c * t) * 1e4) / 1e4 + e.u : e.b, e);
}, Xa = function(t, e) {
  var n = e.s + e.c * t;
  e.set(e.t, e.p, ~~(n + (n < 0 ? -0.5 : 0.5)) + e.u, e);
}, $o = function(t, e) {
  return e.set(e.t, e.p, t ? e.e : e.b, e);
}, Fo = function(t, e) {
  return e.set(e.t, e.p, t !== 1 ? e.b : e.e, e);
}, Ga = function(t, e, n) {
  return t.style[e] = n;
}, Ka = function(t, e, n) {
  return t.style.setProperty(e, n);
}, ja = function(t, e, n) {
  return t._gsap[e] = n;
}, Za = function(t, e, n) {
  return t._gsap.scaleX = t._gsap.scaleY = n;
}, Qa = function(t, e, n, r, s) {
  var o = t._gsap;
  o.scaleX = o.scaleY = n, o.renderTransform(s, o);
}, Ja = function(t, e, n, r, s) {
  var o = t._gsap;
  o[e] = n, o.renderTransform(s, o);
}, ot = "transform", Lt = ot + "Origin", tl = function i(t, e) {
  var n = this, r = this.target, s = r.style, o = r._gsap;
  if (t in _e && s) {
    if (this.tfm = this.tfm || {}, t !== "transform")
      t = ee[t] || t, ~t.indexOf(",") ? t.split(",").forEach(function(c) {
        return n.tfm[c] = he(r, c);
      }) : this.tfm[t] = o.x ? o[t] : he(r, t), t === Lt && (this.tfm.zOrigin = o.zOrigin);
    else
      return ee.transform.split(",").forEach(function(c) {
        return i.call(n, c, e);
      });
    if (this.props.indexOf(ot) >= 0)
      return;
    o.svg && (this.svgo = r.getAttribute("data-svg-origin"), this.props.push(Lt, e, "")), t = ot;
  }
  (s || e) && this.props.push(t, e, s[t]);
}, zo = function(t) {
  t.translate && (t.removeProperty("translate"), t.removeProperty("scale"), t.removeProperty("rotate"));
}, el = function() {
  var t = this.props, e = this.target, n = e.style, r = e._gsap, s, o;
  for (s = 0; s < t.length; s += 3)
    t[s + 1] ? e[t[s]] = t[s + 2] : t[s + 2] ? n[t[s]] = t[s + 2] : n.removeProperty(t[s].substr(0, 2) === "--" ? t[s] : t[s].replace(qs, "-$1").toLowerCase());
  if (this.tfm) {
    for (o in this.tfm)
      r[o] = this.tfm[o];
    r.svg && (r.renderTransform(), e.setAttribute("data-svg-origin", this.svgo || "")), s = Ns(), (!s || !s.isStart) && !n[ot] && (zo(n), r.zOrigin && n[Lt] && (n[Lt] += " " + r.zOrigin + "px", r.zOrigin = 0, r.renderTransform()), r.uncache = 1);
  }
}, Ho = function(t, e) {
  var n = {
    target: t,
    props: [],
    revert: el,
    save: tl
  };
  return t._gsap || Rt.core.getCache(t), e && e.split(",").forEach(function(r) {
    return n.save(r);
  }), n;
}, No, os = function(t, e) {
  var n = be.createElementNS ? be.createElementNS((e || "http://www.w3.org/1999/xhtml").replace(/^https/, "http"), t) : be.createElement(t);
  return n && n.style ? n : be.createElement(t);
}, se = function i(t, e, n) {
  var r = getComputedStyle(t);
  return r[e] || r.getPropertyValue(e.replace(qs, "-$1").toLowerCase()) || r.getPropertyValue(e) || !n && i(t, cn(e) || e, 1) || "";
}, vi = "O,Moz,ms,Ms,Webkit".split(","), cn = function(t, e, n) {
  var r = e || Ie, s = r.style, o = 5;
  if (t in s && !n)
    return t;
  for (t = t.charAt(0).toUpperCase() + t.substr(1); o-- && !(vi[o] + t in s); )
    ;
  return o < 0 ? null : (o === 3 ? "ms" : o >= 0 ? vi[o] : "") + t;
}, cs = function() {
  Ba() && window.document && (mi = window, be = mi.document, Qe = be.documentElement, Ie = os("div") || {
    style: {}
  }, os("div"), ot = cn(ot), Lt = ot + "Origin", Ie.style.cssText = "border-width:0;line-height:0;position:absolute;padding:0", No = !!cn("perspective"), Ns = Rt.core.reverting, Hs = 1);
}, Vr = function i(t) {
  var e = os("svg", this.ownerSVGElement && this.ownerSVGElement.getAttribute("xmlns") || "http://www.w3.org/2000/svg"), n = this.parentNode, r = this.nextSibling, s = this.style.cssText, o;
  if (Qe.appendChild(e), e.appendChild(this), this.style.display = "block", t)
    try {
      o = this.getBBox(), this._gsapBBox = this.getBBox, this.getBBox = i;
    } catch {
    }
  else this._gsapBBox && (o = this._gsapBBox());
  return n && (r ? n.insertBefore(this, r) : n.appendChild(this)), Qe.removeChild(e), this.style.cssText = s, o;
}, bi = function(t, e) {
  for (var n = e.length; n--; )
    if (t.hasAttribute(e[n]))
      return t.getAttribute(e[n]);
}, qo = function(t) {
  var e;
  try {
    e = t.getBBox();
  } catch {
    e = Vr.call(t, !0);
  }
  return e && (e.width || e.height) || t.getBBox === Vr || (e = Vr.call(t, !0)), e && !e.width && !e.x && !e.y ? {
    x: +bi(t, ["x", "cx", "x1"]) || 0,
    y: +bi(t, ["y", "cy", "y1"]) || 0,
    width: 0,
    height: 0
  } : e;
}, Bo = function(t) {
  return !!(t.getCTM && (!t.parentNode || t.ownerSVGElement) && qo(t));
}, We = function(t, e) {
  if (e) {
    var n = t.style, r;
    e in _e && e !== Lt && (e = ot), n.removeProperty ? (r = e.substr(0, 2), (r === "ms" || e.substr(0, 6) === "webkit") && (e = "-" + e), n.removeProperty(r === "--" ? e : e.replace(qs, "-$1").toLowerCase())) : n.removeAttribute(e);
  }
}, we = function(t, e, n, r, s, o) {
  var c = new Dt(t._pt, e, n, 0, 1, o ? Fo : $o);
  return t._pt = c, c.b = r, c.e = s, t._props.push(n), c;
}, wi = {
  deg: 1,
  rad: 1,
  turn: 1
}, nl = {
  grid: 1,
  flex: 1
}, Oe = function i(t, e, n, r) {
  var s = parseFloat(n) || 0, o = (n + "").trim().substr((s + "").length) || "px", c = Ie.style, a = Va.test(e), l = t.tagName.toLowerCase() === "svg", u = (l ? "client" : "offset") + (a ? "Width" : "Height"), f = 100, d = r === "px", _ = r === "%", p, h, m, g;
  if (r === o || !s || wi[r] || wi[o])
    return s;
  if (o !== "px" && !d && (s = i(t, e, n, "px")), g = t.getCTM && Bo(t), (_ || o === "%") && (_e[e] || ~e.indexOf("adius")))
    return p = g ? t.getBBox()[a ? "width" : "height"] : t[u], ht(_ ? s / p * f : s / 100 * p);
  if (c[a ? "width" : "height"] = f + (d ? o : r), h = ~e.indexOf("adius") || r === "em" && t.appendChild && !l ? t : t.parentNode, g && (h = (t.ownerSVGElement || {}).parentNode), (!h || h === be || !h.appendChild) && (h = be.body), m = h._gsap, m && _ && m.width && a && m.time === Ft.time && !m.uncache)
    return ht(s / m.width * f);
  if (_ && (e === "height" || e === "width")) {
    var v = t.style[e];
    t.style[e] = f + r, p = t[u], v ? t.style[e] = v : We(t, e);
  } else
    (_ || o === "%") && !nl[se(h, "display")] && (c.position = se(t, "position")), h === t && (c.position = "static"), h.appendChild(Ie), p = Ie[u], h.removeChild(Ie), c.position = "absolute";
  return a && _ && (m = Fe(h), m.time = Ft.time, m.width = h[u]), ht(d ? p * s / f : p && s ? f / p * s : 0);
}, he = function(t, e, n, r) {
  var s;
  return Hs || cs(), e in ee && e !== "transform" && (e = ee[e], ~e.indexOf(",") && (e = e.split(",")[0])), _e[e] && e !== "transform" ? (s = An(t, r), s = e !== "transformOrigin" ? s[e] : s.svg ? s.origin : hr(se(t, Lt)) + " " + s.zOrigin + "px") : (s = t.style[e], (!s || s === "auto" || r || ~(s + "").indexOf("calc(")) && (s = fr[e] && fr[e](t, e, n) || se(t, e) || ro(t, e) || (e === "opacity" ? 1 : 0))), n && !~(s + "").trim().indexOf(" ") ? Oe(t, e, s, n) + n : s;
}, rl = function(t, e, n, r) {
  if (!n || n === "none") {
    var s = cn(e, t, 1), o = s && se(t, s, 1);
    o && o !== n ? (e = s, n = o) : e === "borderColor" && (n = se(t, "borderTopColor"));
  }
  var c = new Dt(this._pt, t.style, e, 0, 1, Lo), a = 0, l = 0, u, f, d, _, p, h, m, g, v, x, y, b;
  if (c.b = n, c.e = r, n += "", r += "", r === "auto" && (h = t.style[e], t.style[e] = r, r = se(t, e) || r, h ? t.style[e] = h : We(t, e)), u = [n, r], So(u), n = u[0], r = u[1], d = n.match(Xe) || [], b = r.match(Xe) || [], b.length) {
    for (; f = Xe.exec(r); )
      m = f[0], v = r.substring(a, f.index), p ? p = (p + 1) % 5 : (v.substr(-5) === "rgba(" || v.substr(-5) === "hsla(") && (p = 1), m !== (h = d[l++] || "") && (_ = parseFloat(h) || 0, y = h.substr((_ + "").length), m.charAt(1) === "=" && (m = Ze(_, m) + y), g = parseFloat(m), x = m.substr((g + "").length), a = Xe.lastIndex - x.length, x || (x = x || qt.units[e] || y, a === r.length && (r += x, c.e += x)), y !== x && (_ = Oe(t, e, h, x) || 0), c._pt = {
        _next: c._pt,
        p: v || l === 1 ? v : ",",
        //note: SVG spec allows omission of comma/space when a negative sign is wedged between two numbers, like 2.5-5.3 instead of 2.5,-5.3 but when tweening, the negative value may switch to positive, so we insert the comma just in case.
        s: _,
        c: g - _,
        m: p && p < 4 || e === "zIndex" ? Math.round : 0
      });
    c.c = a < r.length ? r.substring(a, r.length) : "";
  } else
    c.r = e === "display" && r === "none" ? Fo : $o;
  return Zi.test(r) && (c.e = 0), this._pt = c, c;
}, xi = {
  top: "0%",
  bottom: "100%",
  left: "0%",
  right: "100%",
  center: "50%"
}, sl = function(t) {
  var e = t.split(" "), n = e[0], r = e[1] || "50%";
  return (n === "top" || n === "bottom" || r === "left" || r === "right") && (t = n, n = r, r = t), e[0] = xi[n] || n, e[1] = xi[r] || r, e.join(" ");
}, il = function(t, e) {
  if (e.tween && e.tween._time === e.tween._dur) {
    var n = e.t, r = n.style, s = e.u, o = n._gsap, c, a, l;
    if (s === "all" || s === !0)
      r.cssText = "", a = 1;
    else
      for (s = s.split(","), l = s.length; --l > -1; )
        c = s[l], _e[c] && (a = 1, c = c === "transformOrigin" ? Lt : ot), We(n, c);
    a && (We(n, ot), o && (o.svg && n.removeAttribute("transform"), An(n, 1), o.uncache = 1, zo(r)));
  }
}, fr = {
  clearProps: function(t, e, n, r, s) {
    if (s.data !== "isFromStart") {
      var o = t._pt = new Dt(t._pt, e, n, 0, 0, il);
      return o.u = r, o.pr = -10, o.tween = s, t._props.push(n), 1;
    }
  }
  /* className feature (about 0.4kb gzipped).
  , className(plugin, target, property, endValue, tween) {
  	let _renderClassName = (ratio, data) => {
  			data.css.render(ratio, data.css);
  			if (!ratio || ratio === 1) {
  				let inline = data.rmv,
  					target = data.t,
  					p;
  				target.setAttribute("class", ratio ? data.e : data.b);
  				for (p in inline) {
  					_removeProperty(target, p);
  				}
  			}
  		},
  		_getAllStyles = (target) => {
  			let styles = {},
  				computed = getComputedStyle(target),
  				p;
  			for (p in computed) {
  				if (isNaN(p) && p !== "cssText" && p !== "length") {
  					styles[p] = computed[p];
  				}
  			}
  			_setDefaults(styles, _parseTransform(target, 1));
  			return styles;
  		},
  		startClassList = target.getAttribute("class"),
  		style = target.style,
  		cssText = style.cssText,
  		cache = target._gsap,
  		classPT = cache.classPT,
  		inlineToRemoveAtEnd = {},
  		data = {t:target, plugin:plugin, rmv:inlineToRemoveAtEnd, b:startClassList, e:(endValue.charAt(1) !== "=") ? endValue : startClassList.replace(new RegExp("(?:\\s|^)" + endValue.substr(2) + "(?![\\w-])"), "") + ((endValue.charAt(0) === "+") ? " " + endValue.substr(2) : "")},
  		changingVars = {},
  		startVars = _getAllStyles(target),
  		transformRelated = /(transform|perspective)/i,
  		endVars, p;
  	if (classPT) {
  		classPT.r(1, classPT.d);
  		_removeLinkedListItem(classPT.d.plugin, classPT, "_pt");
  	}
  	target.setAttribute("class", data.e);
  	endVars = _getAllStyles(target, true);
  	target.setAttribute("class", startClassList);
  	for (p in endVars) {
  		if (endVars[p] !== startVars[p] && !transformRelated.test(p)) {
  			changingVars[p] = endVars[p];
  			if (!style[p] && style[p] !== "0") {
  				inlineToRemoveAtEnd[p] = 1;
  			}
  		}
  	}
  	cache.classPT = plugin._pt = new PropTween(plugin._pt, target, "className", 0, 0, _renderClassName, data, 0, -11);
  	if (style.cssText !== cssText) { //only apply if things change. Otherwise, in cases like a background-image that's pulled dynamically, it could cause a refresh. See https://gsap.com/forums/topic/20368-possible-gsap-bug-switching-classnames-in-chrome/.
  		style.cssText = cssText; //we recorded cssText before we swapped classes and ran _getAllStyles() because in cases when a className tween is overwritten, we remove all the related tweening properties from that class change (otherwise class-specific stuff can't override properties we've directly set on the target's style object due to specificity).
  	}
  	_parseTransform(target, true); //to clear the caching of transforms
  	data.css = new gsap.plugins.css();
  	data.css.init(target, changingVars, tween);
  	plugin._props.push(...data.css._props);
  	return 1;
  }
  */
}, On = [1, 0, 0, 1, 0, 0], Vo = {}, Wo = function(t) {
  return t === "matrix(1, 0, 0, 1, 0, 0)" || t === "none" || !t;
}, Si = function(t) {
  var e = se(t, ot);
  return Wo(e) ? On : e.substr(7).match(ji).map(ht);
}, Bs = function(t, e) {
  var n = t._gsap || Fe(t), r = t.style, s = Si(t), o, c, a, l;
  return n.svg && t.getAttribute("transform") ? (a = t.transform.baseVal.consolidate().matrix, s = [a.a, a.b, a.c, a.d, a.e, a.f], s.join(",") === "1,0,0,1,0,0" ? On : s) : (s === On && !t.offsetParent && t !== Qe && !n.svg && (a = r.display, r.display = "block", o = t.parentNode, (!o || !t.offsetParent) && (l = 1, c = t.nextElementSibling, Qe.appendChild(t)), s = Si(t), a ? r.display = a : We(t, "display"), l && (c ? o.insertBefore(t, c) : o ? o.appendChild(t) : Qe.removeChild(t))), e && s.length > 6 ? [s[0], s[1], s[4], s[5], s[12], s[13]] : s);
}, as = function(t, e, n, r, s, o) {
  var c = t._gsap, a = s || Bs(t, !0), l = c.xOrigin || 0, u = c.yOrigin || 0, f = c.xOffset || 0, d = c.yOffset || 0, _ = a[0], p = a[1], h = a[2], m = a[3], g = a[4], v = a[5], x = e.split(" "), y = parseFloat(x[0]) || 0, b = parseFloat(x[1]) || 0, S, T, k, w;
  n ? a !== On && (T = _ * m - p * h) && (k = y * (m / T) + b * (-h / T) + (h * v - m * g) / T, w = y * (-p / T) + b * (_ / T) - (_ * v - p * g) / T, y = k, b = w) : (S = qo(t), y = S.x + (~x[0].indexOf("%") ? y / 100 * S.width : y), b = S.y + (~(x[1] || x[0]).indexOf("%") ? b / 100 * S.height : b)), r || r !== !1 && c.smooth ? (g = y - l, v = b - u, c.xOffset = f + (g * _ + v * h) - g, c.yOffset = d + (g * p + v * m) - v) : c.xOffset = c.yOffset = 0, c.xOrigin = y, c.yOrigin = b, c.smooth = !!r, c.origin = e, c.originIsAbsolute = !!n, t.style[Lt] = "0px 0px", o && (we(o, c, "xOrigin", l, y), we(o, c, "yOrigin", u, b), we(o, c, "xOffset", f, c.xOffset), we(o, c, "yOffset", d, c.yOffset)), t.setAttribute("data-svg-origin", y + " " + b);
}, An = function(t, e) {
  var n = t._gsap || new Oo(t);
  if ("x" in n && !e && !n.uncache)
    return n;
  var r = t.style, s = n.scaleX < 0, o = "px", c = "deg", a = getComputedStyle(t), l = se(t, Lt) || "0", u, f, d, _, p, h, m, g, v, x, y, b, S, T, k, w, O, E, M, L, $, q, H, N, W, U, j, F, C, R, D, A;
  return u = f = d = h = m = g = v = x = y = 0, _ = p = 1, n.svg = !!(t.getCTM && Bo(t)), a.translate && ((a.translate !== "none" || a.scale !== "none" || a.rotate !== "none") && (r[ot] = (a.translate !== "none" ? "translate3d(" + (a.translate + " 0 0").split(" ").slice(0, 3).join(", ") + ") " : "") + (a.rotate !== "none" ? "rotate(" + a.rotate + ") " : "") + (a.scale !== "none" ? "scale(" + a.scale.split(" ").join(",") + ") " : "") + (a[ot] !== "none" ? a[ot] : "")), r.scale = r.rotate = r.translate = "none"), T = Bs(t, n.svg), n.svg && (n.uncache ? (W = t.getBBox(), l = n.xOrigin - W.x + "px " + (n.yOrigin - W.y) + "px", N = "") : N = !e && t.getAttribute("data-svg-origin"), as(t, N || l, !!N || n.originIsAbsolute, n.smooth !== !1, T)), b = n.xOrigin || 0, S = n.yOrigin || 0, T !== On && (E = T[0], M = T[1], L = T[2], $ = T[3], u = q = T[4], f = H = T[5], T.length === 6 ? (_ = Math.sqrt(E * E + M * M), p = Math.sqrt($ * $ + L * L), h = E || M ? Ye(M, E) * Re : 0, v = L || $ ? Ye(L, $) * Re + h : 0, v && (p *= Math.abs(Math.cos(v * Je))), n.svg && (u -= b - (b * E + S * L), f -= S - (b * M + S * $))) : (A = T[6], R = T[7], j = T[8], F = T[9], C = T[10], D = T[11], u = T[12], f = T[13], d = T[14], k = Ye(A, C), m = k * Re, k && (w = Math.cos(-k), O = Math.sin(-k), N = q * w + j * O, W = H * w + F * O, U = A * w + C * O, j = q * -O + j * w, F = H * -O + F * w, C = A * -O + C * w, D = R * -O + D * w, q = N, H = W, A = U), k = Ye(-L, C), g = k * Re, k && (w = Math.cos(-k), O = Math.sin(-k), N = E * w - j * O, W = M * w - F * O, U = L * w - C * O, D = $ * O + D * w, E = N, M = W, L = U), k = Ye(M, E), h = k * Re, k && (w = Math.cos(k), O = Math.sin(k), N = E * w + M * O, W = q * w + H * O, M = M * w - E * O, H = H * w - q * O, E = N, q = W), m && Math.abs(m) + Math.abs(h) > 359.9 && (m = h = 0, g = 180 - g), _ = ht(Math.sqrt(E * E + M * M + L * L)), p = ht(Math.sqrt(H * H + A * A)), k = Ye(q, H), v = Math.abs(k) > 2e-4 ? k * Re : 0, y = D ? 1 / (D < 0 ? -D : D) : 0), n.svg && (N = t.getAttribute("transform"), n.forceCSS = t.setAttribute("transform", "") || !Wo(se(t, ot)), N && t.setAttribute("transform", N))), Math.abs(v) > 90 && Math.abs(v) < 270 && (s ? (_ *= -1, v += h <= 0 ? 180 : -180, h += h <= 0 ? 180 : -180) : (p *= -1, v += v <= 0 ? 180 : -180)), e = e || n.uncache, n.x = u - ((n.xPercent = u && (!e && n.xPercent || (Math.round(t.offsetWidth / 2) === Math.round(-u) ? -50 : 0))) ? t.offsetWidth * n.xPercent / 100 : 0) + o, n.y = f - ((n.yPercent = f && (!e && n.yPercent || (Math.round(t.offsetHeight / 2) === Math.round(-f) ? -50 : 0))) ? t.offsetHeight * n.yPercent / 100 : 0) + o, n.z = d + o, n.scaleX = ht(_), n.scaleY = ht(p), n.rotation = ht(h) + c, n.rotationX = ht(m) + c, n.rotationY = ht(g) + c, n.skewX = v + c, n.skewY = x + c, n.transformPerspective = y + o, (n.zOrigin = parseFloat(l.split(" ")[2]) || !e && n.zOrigin || 0) && (r[Lt] = hr(l)), n.xOffset = n.yOffset = 0, n.force3D = qt.force3D, n.renderTransform = n.svg ? cl : No ? Uo : ol, n.uncache = 0, n;
}, hr = function(t) {
  return (t = t.split(" "))[0] + " " + t[1];
}, Wr = function(t, e, n) {
  var r = xt(e);
  return ht(parseFloat(e) + parseFloat(Oe(t, "x", n + "px", r))) + r;
}, ol = function(t, e) {
  e.z = "0px", e.rotationY = e.rotationX = "0deg", e.force3D = 0, Uo(t, e);
}, De = "0deg", mn = "0px", Le = ") ", Uo = function(t, e) {
  var n = e || this, r = n.xPercent, s = n.yPercent, o = n.x, c = n.y, a = n.z, l = n.rotation, u = n.rotationY, f = n.rotationX, d = n.skewX, _ = n.skewY, p = n.scaleX, h = n.scaleY, m = n.transformPerspective, g = n.force3D, v = n.target, x = n.zOrigin, y = "", b = g === "auto" && t && t !== 1 || g === !0;
  if (x && (f !== De || u !== De)) {
    var S = parseFloat(u) * Je, T = Math.sin(S), k = Math.cos(S), w;
    S = parseFloat(f) * Je, w = Math.cos(S), o = Wr(v, o, T * w * -x), c = Wr(v, c, -Math.sin(S) * -x), a = Wr(v, a, k * w * -x + x);
  }
  m !== mn && (y += "perspective(" + m + Le), (r || s) && (y += "translate(" + r + "%, " + s + "%) "), (b || o !== mn || c !== mn || a !== mn) && (y += a !== mn || b ? "translate3d(" + o + ", " + c + ", " + a + ") " : "translate(" + o + ", " + c + Le), l !== De && (y += "rotate(" + l + Le), u !== De && (y += "rotateY(" + u + Le), f !== De && (y += "rotateX(" + f + Le), (d !== De || _ !== De) && (y += "skew(" + d + ", " + _ + Le), (p !== 1 || h !== 1) && (y += "scale(" + p + ", " + h + Le), v.style[ot] = y || "translate(0, 0)";
}, cl = function(t, e) {
  var n = e || this, r = n.xPercent, s = n.yPercent, o = n.x, c = n.y, a = n.rotation, l = n.skewX, u = n.skewY, f = n.scaleX, d = n.scaleY, _ = n.target, p = n.xOrigin, h = n.yOrigin, m = n.xOffset, g = n.yOffset, v = n.forceCSS, x = parseFloat(o), y = parseFloat(c), b, S, T, k, w;
  a = parseFloat(a), l = parseFloat(l), u = parseFloat(u), u && (u = parseFloat(u), l += u, a += u), a || l ? (a *= Je, l *= Je, b = Math.cos(a) * f, S = Math.sin(a) * f, T = Math.sin(a - l) * -d, k = Math.cos(a - l) * d, l && (u *= Je, w = Math.tan(l - u), w = Math.sqrt(1 + w * w), T *= w, k *= w, u && (w = Math.tan(u), w = Math.sqrt(1 + w * w), b *= w, S *= w)), b = ht(b), S = ht(S), T = ht(T), k = ht(k)) : (b = f, k = d, S = T = 0), (x && !~(o + "").indexOf("px") || y && !~(c + "").indexOf("px")) && (x = Oe(_, "x", o, "px"), y = Oe(_, "y", c, "px")), (p || h || m || g) && (x = ht(x + p - (p * b + h * T) + m), y = ht(y + h - (p * S + h * k) + g)), (r || s) && (w = _.getBBox(), x = ht(x + r / 100 * w.width), y = ht(y + s / 100 * w.height)), w = "matrix(" + b + "," + S + "," + T + "," + k + "," + x + "," + y + ")", _.setAttribute("transform", w), v && (_.style[ot] = w);
}, al = function(t, e, n, r, s) {
  var o = 360, c = bt(s), a = parseFloat(s) * (c && ~s.indexOf("rad") ? Re : 1), l = a - r, u = r + l + "deg", f, d;
  return c && (f = s.split("_")[1], f === "short" && (l %= o, l !== l % (o / 2) && (l += l < 0 ? o : -o)), f === "cw" && l < 0 ? l = (l + o * yi) % o - ~~(l / o) * o : f === "ccw" && l > 0 && (l = (l - o * yi) % o - ~~(l / o) * o)), t._pt = d = new Dt(t._pt, e, n, r, l, Ua), d.e = u, d.u = "deg", t._props.push(n), d;
}, Ti = function(t, e) {
  for (var n in e)
    t[n] = e[n];
  return t;
}, ll = function(t, e, n) {
  var r = Ti({}, n._gsap), s = "perspective,force3D,transformOrigin,svgOrigin", o = n.style, c, a, l, u, f, d, _, p;
  r.svg ? (l = n.getAttribute("transform"), n.setAttribute("transform", ""), o[ot] = e, c = An(n, 1), We(n, ot), n.setAttribute("transform", l)) : (l = getComputedStyle(n)[ot], o[ot] = e, c = An(n, 1), o[ot] = l);
  for (a in _e)
    l = r[a], u = c[a], l !== u && s.indexOf(a) < 0 && (_ = xt(l), p = xt(u), f = _ !== p ? Oe(n, a, l, p) : parseFloat(l), d = parseFloat(u), t._pt = new Dt(t._pt, c, a, f, d - f, is), t._pt.u = p || 0, t._props.push(a));
  Ti(c, r);
};
Et("padding,margin,Width,Radius", function(i, t) {
  var e = "Top", n = "Right", r = "Bottom", s = "Left", o = (t < 3 ? [e, n, r, s] : [e + s, e + n, r + n, r + s]).map(function(c) {
    return t < 2 ? i + c : "border" + c + i;
  });
  fr[t > 1 ? "border" + i : i] = function(c, a, l, u, f) {
    var d, _;
    if (arguments.length < 4)
      return d = o.map(function(p) {
        return he(c, p, l);
      }), _ = d.join(" "), _.split(d[0]).length === 5 ? d[0] : _;
    d = (u + "").split(" "), _ = {}, o.forEach(function(p, h) {
      return _[p] = d[h] = d[h] || d[(h - 1) / 2 | 0];
    }), c.init(a, _, f);
  };
});
var Yo = {
  name: "css",
  register: cs,
  targetTest: function(t) {
    return t.style && t.nodeType;
  },
  init: function(t, e, n, r, s) {
    var o = this._props, c = t.style, a = n.vars.startAt, l, u, f, d, _, p, h, m, g, v, x, y, b, S, T, k;
    Hs || cs(), this.styles = this.styles || Ho(t), k = this.styles.props, this.tween = n;
    for (h in e)
      if (h !== "autoRound" && (u = e[h], !($t[h] && Ao(h, e, n, r, t, s)))) {
        if (_ = typeof u, p = fr[h], _ === "function" && (u = u.call(n, r, t, s), _ = typeof u), _ === "string" && ~u.indexOf("random(") && (u = Tn(u)), p)
          p(this, t, h, u, n) && (T = 1);
        else if (h.substr(0, 2) === "--")
          l = (getComputedStyle(t).getPropertyValue(h) + "").trim(), u += "", Se.lastIndex = 0, Se.test(l) || (m = xt(l), g = xt(u)), g ? m !== g && (l = Oe(t, h, l, g) + g) : m && (u += m), this.add(c, "setProperty", l, u, r, s, 0, 0, h), o.push(h), k.push(h, 0, c[h]);
        else if (_ !== "undefined") {
          if (a && h in a ? (l = typeof a[h] == "function" ? a[h].call(n, r, t, s) : a[h], bt(l) && ~l.indexOf("random(") && (l = Tn(l)), xt(l + "") || l === "auto" || (l += qt.units[h] || xt(he(t, h)) || ""), (l + "").charAt(1) === "=" && (l = he(t, h))) : l = he(t, h), d = parseFloat(l), v = _ === "string" && u.charAt(1) === "=" && u.substr(0, 2), v && (u = u.substr(2)), f = parseFloat(u), h in ee && (h === "autoAlpha" && (d === 1 && he(t, "visibility") === "hidden" && f && (d = 0), k.push("visibility", 0, c.visibility), we(this, c, "visibility", d ? "inherit" : "hidden", f ? "inherit" : "hidden", !f)), h !== "scale" && h !== "transform" && (h = ee[h], ~h.indexOf(",") && (h = h.split(",")[0]))), x = h in _e, x) {
            if (this.styles.save(h), y || (b = t._gsap, b.renderTransform && !e.parseTransform || An(t, e.parseTransform), S = e.smoothOrigin !== !1 && b.smooth, y = this._pt = new Dt(this._pt, c, ot, 0, 1, b.renderTransform, b, 0, -1), y.dep = 1), h === "scale")
              this._pt = new Dt(this._pt, b, "scaleY", b.scaleY, (v ? Ze(b.scaleY, v + f) : f) - b.scaleY || 0, is), this._pt.u = 0, o.push("scaleY", h), h += "X";
            else if (h === "transformOrigin") {
              k.push(Lt, 0, c[Lt]), u = sl(u), b.svg ? as(t, u, 0, S, 0, this) : (g = parseFloat(u.split(" ")[2]) || 0, g !== b.zOrigin && we(this, b, "zOrigin", b.zOrigin, g), we(this, c, h, hr(l), hr(u)));
              continue;
            } else if (h === "svgOrigin") {
              as(t, u, 1, S, 0, this);
              continue;
            } else if (h in Vo) {
              al(this, b, h, d, v ? Ze(d, v + u) : u);
              continue;
            } else if (h === "smoothOrigin") {
              we(this, b, "smooth", b.smooth, u);
              continue;
            } else if (h === "force3D") {
              b[h] = u;
              continue;
            } else if (h === "transform") {
              ll(this, u, t);
              continue;
            }
          } else h in c || (h = cn(h) || h);
          if (x || (f || f === 0) && (d || d === 0) && !Wa.test(u) && h in c)
            m = (l + "").substr((d + "").length), f || (f = 0), g = xt(u) || (h in qt.units ? qt.units[h] : m), m !== g && (d = Oe(t, h, l, g)), this._pt = new Dt(this._pt, x ? b : c, h, d, (v ? Ze(d, v + f) : f) - d, !x && (g === "px" || h === "zIndex") && e.autoRound !== !1 ? Xa : is), this._pt.u = g || 0, m !== g && g !== "%" && (this._pt.b = l, this._pt.r = Ya);
          else if (h in c)
            rl.call(this, t, h, l, v ? v + u : u);
          else if (h in t)
            this.add(t, h, l || t[h], v ? v + u : u, r, s);
          else if (h !== "parseTransform") {
            Ms(h, u);
            continue;
          }
          x || (h in c ? k.push(h, 0, c[h]) : k.push(h, 1, l || t[h])), o.push(h);
        }
      }
    T && Ro(this);
  },
  render: function(t, e) {
    if (e.tween._time || !Ns())
      for (var n = e._pt; n; )
        n.r(t, n.d), n = n._next;
    else
      e.styles.revert();
  },
  get: he,
  aliases: ee,
  getSetter: function(t, e, n) {
    var r = ee[e];
    return r && r.indexOf(",") < 0 && (e = r), e in _e && e !== Lt && (t._gsap.x || he(t, "x")) ? n && gi === n ? e === "scale" ? Za : ja : (gi = n || {}) && (e === "scale" ? Qa : Ja) : t.style && !Os(t.style[e]) ? Ga : ~e.indexOf("-") ? Ka : Fs(t, e);
  },
  core: {
    _removeProperty: We,
    _getMatrix: Bs
  }
};
Rt.utils.checkPrefix = cn;
Rt.core.getStyleSaver = Ho;
(function(i, t, e, n) {
  var r = Et(i + "," + t + "," + e, function(s) {
    _e[s] = 1;
  });
  Et(t, function(s) {
    qt.units[s] = "deg", Vo[s] = 1;
  }), ee[r[13]] = i + "," + t, Et(n, function(s) {
    var o = s.split(":");
    ee[o[1]] = r[o[0]];
  });
})("x,y,z,scale,scaleX,scaleY,xPercent,yPercent", "rotation,rotationX,rotationY,skewX,skewY", "transform,transformOrigin,svgOrigin,force3D,smoothOrigin,transformPerspective", "0:translateX,1:translateY,2:translateZ,8:rotate,8:rotationZ,8:rotateZ,9:rotateX,10:rotateY");
Et("x,y,z,top,right,bottom,left,width,height,fontSize,padding,margin,perspective", function(i) {
  qt.units[i] = "px";
});
Rt.registerPlugin(Yo);
var Vs = Rt.registerPlugin(Yo) || Rt;
Vs.core.Tween;
/*!
 * ScrollToPlugin 3.12.5
 * https://gsap.com
 *
 * @license Copyright 2008-2024, GreenSock. All rights reserved.
 * Subject to the terms at https://gsap.com/standard-license or for
 * Club GSAP members, the agreement issued with that membership.
 * @author: Jack Doyle, jack@greensock.com
*/
var Ot, Xo, de, ne, Te, Go, Ko, jn, jo = function() {
  return typeof window < "u";
}, Zo = function() {
  return Ot || jo() && (Ot = window.gsap) && Ot.registerPlugin && Ot;
}, Qo = function(t) {
  return typeof t == "string";
}, ki = function(t) {
  return typeof t == "function";
}, Pn = function(t, e) {
  var n = e === "x" ? "Width" : "Height", r = "scroll" + n, s = "client" + n;
  return t === de || t === ne || t === Te ? Math.max(ne[r], Te[r]) - (de["inner" + n] || ne[s] || Te[s]) : t[r] - t["offset" + n];
}, Mn = function(t, e) {
  var n = "scroll" + (e === "x" ? "Left" : "Top");
  return t === de && (t.pageXOffset != null ? n = "page" + e.toUpperCase() + "Offset" : t = ne[n] != null ? ne : Te), function() {
    return t[n];
  };
}, ul = function(t, e, n, r) {
  if (ki(t) && (t = t(e, n, r)), typeof t != "object")
    return Qo(t) && t !== "max" && t.charAt(1) !== "=" ? {
      x: t,
      y: t
    } : {
      y: t
    };
  if (t.nodeType)
    return {
      y: t,
      x: t
    };
  var s = {}, o;
  for (o in t)
    s[o] = o !== "onAutoKill" && ki(t[o]) ? t[o](e, n, r) : t[o];
  return s;
}, Jo = function(t, e) {
  if (t = Go(t)[0], !t || !t.getBoundingClientRect)
    return console.warn("scrollTo target doesn't exist. Using 0") || {
      x: 0,
      y: 0
    };
  var n = t.getBoundingClientRect(), r = !e || e === de || e === Te, s = r ? {
    top: ne.clientTop - (de.pageYOffset || ne.scrollTop || Te.scrollTop || 0),
    left: ne.clientLeft - (de.pageXOffset || ne.scrollLeft || Te.scrollLeft || 0)
  } : e.getBoundingClientRect(), o = {
    x: n.left - s.left,
    y: n.top - s.top
  };
  return !r && e && (o.x += Mn(e, "x")(), o.y += Mn(e, "y")()), o;
}, Ci = function(t, e, n, r, s) {
  return !isNaN(t) && typeof t != "object" ? parseFloat(t) - s : Qo(t) && t.charAt(1) === "=" ? parseFloat(t.substr(2)) * (t.charAt(0) === "-" ? -1 : 1) + r - s : t === "max" ? Pn(e, n) - s : Math.min(Pn(e, n), Jo(t, e)[n] - s);
}, Oi = function() {
  Ot = Zo(), jo() && Ot && typeof document < "u" && document.body && (de = window, Te = document.body, ne = document.documentElement, Go = Ot.utils.toArray, Ot.config({
    autoKillThreshold: 7
  }), Ko = Ot.config(), Xo = 1);
}, In = {
  version: "3.12.5",
  name: "scrollTo",
  rawVars: 1,
  register: function(t) {
    Ot = t, Oi();
  },
  init: function(t, e, n, r, s) {
    Xo || Oi();
    var o = this, c = Ot.getProperty(t, "scrollSnapType");
    o.isWin = t === de, o.target = t, o.tween = n, e = ul(e, r, t, s), o.vars = e, o.autoKill = !!e.autoKill, o.getX = Mn(t, "x"), o.getY = Mn(t, "y"), o.x = o.xPrev = o.getX(), o.y = o.yPrev = o.getY(), jn || (jn = Ot.core.globals().ScrollTrigger), Ot.getProperty(t, "scrollBehavior") === "smooth" && Ot.set(t, {
      scrollBehavior: "auto"
    }), c && c !== "none" && (o.snap = 1, o.snapInline = t.style.scrollSnapType, t.style.scrollSnapType = "none"), e.x != null ? (o.add(o, "x", o.x, Ci(e.x, t, "x", o.x, e.offsetX || 0), r, s), o._props.push("scrollTo_x")) : o.skipX = 1, e.y != null ? (o.add(o, "y", o.y, Ci(e.y, t, "y", o.y, e.offsetY || 0), r, s), o._props.push("scrollTo_y")) : o.skipY = 1;
  },
  render: function(t, e) {
    for (var n = e._pt, r = e.target, s = e.tween, o = e.autoKill, c = e.xPrev, a = e.yPrev, l = e.isWin, u = e.snap, f = e.snapInline, d, _, p, h, m; n; )
      n.r(t, n.d), n = n._next;
    d = l || !e.skipX ? e.getX() : c, _ = l || !e.skipY ? e.getY() : a, p = _ - a, h = d - c, m = Ko.autoKillThreshold, e.x < 0 && (e.x = 0), e.y < 0 && (e.y = 0), o && (!e.skipX && (h > m || h < -m) && d < Pn(r, "x") && (e.skipX = 1), !e.skipY && (p > m || p < -m) && _ < Pn(r, "y") && (e.skipY = 1), e.skipX && e.skipY && (s.kill(), e.vars.onAutoKill && e.vars.onAutoKill.apply(s, e.vars.onAutoKillParams || []))), l ? de.scrollTo(e.skipX ? d : e.x, e.skipY ? _ : e.y) : (e.skipY || (r.scrollTop = e.y), e.skipX || (r.scrollLeft = e.x)), u && (t === 1 || t === 0) && (_ = r.scrollTop, d = r.scrollLeft, f ? r.style.scrollSnapType = f : r.style.removeProperty("scroll-snap-type"), r.scrollTop = _ + 1, r.scrollLeft = d + 1, r.scrollTop = _, r.scrollLeft = d), e.xPrev = e.x, e.yPrev = e.y, jn && jn.update();
  },
  kill: function(t) {
    var e = t === "scrollTo", n = this._props.indexOf(t);
    return (e || t === "scrollTo_x") && (this.skipX = 1), (e || t === "scrollTo_y") && (this.skipY = 1), n > -1 && this._props.splice(n, 1), !this._props.length;
  }
};
In.max = Pn;
In.getOffset = Jo;
In.buildGetter = Mn;
Zo() && Ot.registerPlugin(In);
Vs.registerPlugin(In);
const tc = {
  scroller: window,
  speed: 600,
  ease: "ease",
  offset: 0
}, Ws = (i, t, e) => {
  const n = { ...tc, ...t }, { spacerSelector: r } = n, s = r ? document.querySelector(r) : null, o = (s == null ? void 0 : s.clientHeight) || 0;
  let c = 0;
  if (typeof i == "string") {
    const a = document.querySelector(i);
    if (a)
      c = a.offsetTop;
    else {
      console.error(`Element not found for selector: ${i}`);
      return;
    }
  } else if (i instanceof HTMLElement)
    c = i.offsetTop;
  else {
    console.error("Invalid targetElement type.");
    return;
  }
  Vs.to(n.scroller, {
    scrollTo: {
      y: c,
      // 目標元素
      offsetY: n.offset + o
    },
    duration: n.speed / 1e3,
    ease: n.ease,
    onComplete: e
  });
};
class vu {
  constructor(t, e) {
    P(this, "container");
    P(this, "selector");
    P(this, "options");
    P(this, "isScrolling");
    P(this, "init", () => {
      if (!this.container) {
        console.error("Can't not found [k-tools-container]");
        return;
      }
      this.container.addEventListener("click", this.handleAnchorClick);
    });
    P(this, "handleAnchorClick", (t) => {
      if (this.isScrolling) return;
      const n = t.target.closest(this.selector);
      if (n) {
        const r = n.getAttribute("k-anchor-target"), s = this.extractOptionsFromAttributes(n), o = r ? document.querySelector(r) : document.body;
        o && (this.isScrolling = !0, Ws(o, s, () => {
          this.isScrolling = !1;
        }));
      }
    });
    P(this, "extractOptionsFromAttributes", (t) => {
      const { scroller: e, speed: n, ease: r, offset: s, spacerSelector: o } = this.options;
      return {
        scroller: t.getAttribute("k-anchor-scroller") ?? e,
        speed: t.hasAttribute("k-anchor-speed") ? Number(t.getAttribute("k-anchor-speed")) : n,
        ease: t.getAttribute("k-anchor-ease") ?? r,
        offset: t.hasAttribute("k-anchor-offset") ? Number(t.getAttribute("k-anchor-offset")) : s,
        spacerSelector: t.getAttribute("k-anchor-spacer-selector") ?? o
      };
    });
    P(this, "update", () => {
      this.init();
    });
    typeof (e == null ? void 0 : e.scroller) == "string" && (e.scroller = document.querySelector(e.scroller) || window), this.container = document.querySelector("[k-tools-container]"), this.selector = t, this.options = { ...tc, ...e }, this.isScrolling = !1, this.init();
  }
}
class bu {
  constructor(t, e) {
    P(this, "container");
    P(this, "selector");
    P(this, "tabs");
    P(this, "tabPanels");
    P(this, "url");
    P(this, "options");
    /**
     * 初始化
     */
    P(this, "init", () => {
      if (!this.container) {
        console.error("Can't not found [k-tools-container]");
        return;
      }
      this.container.addEventListener("click", this.handleTabClick), this.options.history && this.changeTabFromHistory();
    });
    /**
     * 點擊事件處理
     * @param event 點擊事件
     * @param tab 點擊的頁籤按鈕元素
     */
    P(this, "handleTabClick", (t) => {
      const n = t.target.closest(this.selector);
      n && this.activateTab(n);
    });
    /**
     * 透過網址參數切換頁籤
     * @returns
     */
    P(this, "changeTabFromHistory", () => {
      const t = this.url.searchParams;
      if (!t.has("tab")) return;
      const e = t.get("tab"), [n, r] = this.parseTabId(e);
      if (r >= 0) {
        const s = document.querySelectorAll(`${this.selector}[k-tab-ctrl="${n}"]`)[r];
        s instanceof HTMLElement && this.activateTab(s);
      }
    });
    /**
     * 解析頁籤 ID
     * @param tabId 頁籤 ID
     * @returns Array - [頁籤名稱,頁籤索引]
     */
    P(this, "parseTabId", (t) => {
      const e = t.lastIndexOf("-");
      if (e === -1) return [t, -1];
      const n = t.slice(0, e), r = parseInt(t.slice(e + 1)) - 1;
      return [n, r];
    });
    /**
     * 切換到指定的頁籤
     * @param tab 欲切換的頁籤元素
     * @returns
     */
    P(this, "activateTab", (t) => {
      var u, f;
      const e = t.getAttribute("k-tab-ctrl"), n = t.getAttribute("k-tab-target"), r = "active";
      if (!e || !n) return;
      const s = Array.from(document.querySelectorAll(`[k-tab-ctrl="${e}"]`) ?? []), o = document.querySelector(`[k-tab-id="${e}"]`), c = Array.from((o == null ? void 0 : o.querySelectorAll(":scope > .tab__panel")) ?? []);
      s.forEach((d) => d.classList.remove(r)), c.forEach((d) => d.classList.remove(r)), document.querySelectorAll(`[k-tab-ctrl="${e}"][k-tab-target="${n}"]`).forEach((d) => d.classList.add(r));
      const a = o == null ? void 0 : o.querySelector(`[panel-name="${n}"]`);
      a && (a.classList.add(r), this.options.onChangeAnchor && this.scrollToTabContainer(t)), this.options.history && this.updateHistory(e, c.indexOf(a));
      const l = {
        tabID: e,
        tabEl: document.querySelector(`[k-tab-id="${e}"]`),
        panels: Array.from(document.querySelectorAll(`[k-tab-id="${e}"] [panel-name]`)),
        activePanelEl: document.querySelector(`[k-tab-id="${e}"] [panel-name="${n}"]`),
        activePanelName: n
      };
      (f = (u = this.options).onChange) == null || f.call(u, l);
    });
    /**
     * 解析設定值
     * @param element 頁籤元素
     * @returns
     */
    P(this, "extractScrollOptions", (t) => {
      const { scroller: e, speed: n, ease: r, offset: s, spacerSelector: o } = this.options;
      return {
        scroller: t.getAttribute("k-tab-scroller") ?? e,
        speed: t.hasAttribute("k-tab-speed") ? Number(t.getAttribute("k-tab-speed")) : n,
        ease: t.getAttribute("k-tab-ease") ?? r,
        offset: t.hasAttribute("k-tab-offset") ? Number(t.getAttribute("k-tab-offset")) : s,
        spacerSelector: t.getAttribute("k-tab-spacer-selector") ?? o
      };
    });
    /**
     * 滾動到頁籤容器
     * @param tab 頁籤元素
     */
    P(this, "scrollToTabContainer", (t) => {
      const e = t.closest(".tab__container");
      if (!e) return;
      const n = this.extractScrollOptions(t);
      Ws(e, n);
    });
    // 更新 URL 的 history
    P(this, "updateHistory", (t, e) => {
      if (e >= 0) {
        const n = new URLSearchParams({ tab: `${t}-${e + 1}` });
        this.url.search = n.toString(), history.replaceState(null, "", this.url.href);
      }
    });
    const n = {
      onChangeAnchor: !0,
      history: !1,
      scroller: window,
      speed: 600,
      ease: "ease",
      offset: 0
    };
    this.container = document.querySelector("[k-tools-container]"), this.selector = t, this.options = { ...n, ...e }, this.tabs = Array.from(document.querySelectorAll(this.selector)), this.tabPanels = this.tabs.map((r) => {
      const s = r.getAttribute("k-tab-ctrl"), o = r.getAttribute("k-tab-target");
      return document.querySelector(`[k-tab-id="${s}"] [panel-name="${o}"]`);
    }).filter((r) => r !== null), this.url = new URL(document.location.href), this.init();
  }
}
const Us = (i, t = 250) => {
  let e = null;
  return function(...n) {
    const r = this;
    e && clearTimeout(e), e = setTimeout(() => {
      i.apply(r, n);
    }, t);
  };
}, fl = (i, t = 250) => {
  let e, n = null;
  return function(...r) {
    const s = this, o = +/* @__PURE__ */ new Date();
    e && o < e + t ? (n && clearTimeout(n), n = setTimeout(() => {
      e = o, i.apply(s, r);
    }, t)) : (e = o, i.apply(s, r));
  };
}, hl = (i) => new DOMParser().parseFromString(i, "text/html").body.childNodes[0], dl = (i, t) => {
  const e = Math.pow(10, t);
  return Math.round(i * e) / e;
}, pl = (i) => {
  const t = getComputedStyle(i).transform;
  let e = t.match(/^matrix3d\((.+)\)$/);
  return e ? parseFloat(e[1].split(", ")[12]) : (e = t.match(/^matrix\((.+)\)$/), e ? parseFloat(e[1].split(", ")[4]) : 0);
}, ls = (i) => {
  const t = getComputedStyle(i).transform;
  let e = t.match(/^matrix3d\((.+)\)$/);
  return e ? parseFloat(e[1].split(", ")[13]) : (e = t.match(/^matrix\((.+)\)$/), e ? parseFloat(e[1].split(", ")[5]) : 0);
}, _l = (i) => {
  if (!i) return !1;
  for (; i; ) {
    const t = window.getComputedStyle(i);
    if (t.display === "none" || t.visibility === "hidden")
      return !1;
    if (i === document.body)
      break;
    i = i.parentElement;
  }
  return !0;
}, us = () => Date.now().toString(36) + Math.random().toString(36).substring(2, 11), wu = {
  debounce: Us,
  throttle: fl,
  htmlStringToDOM: hl,
  formatFloat: dl,
  getTransformX: pl,
  getTransformY: ls,
  isVisible: _l,
  createUniqueID: us
};
class xu {
  constructor(t, e) {
    P(this, "container");
    P(this, "selector");
    P(this, "elements");
    P(this, "options");
    P(this, "viewWidth");
    /**
     * 初始化
     */
    P(this, "init", () => {
      if (!this.container) {
        console.error("Can't not found [k-tools-container]");
        return;
      }
      this.scrollTrigger(), this.options.marker && (this.elements.forEach((t) => {
        this.container.contains(t) && this.createMarker(t);
      }), window.addEventListener(
        "resize",
        Us(() => {
          this.viewWidth !== window.innerWidth && (this.viewWidth = window.innerWidth, this.resetMarker());
        })
      ));
    });
    /**
     * 判斷元素是否進入視窗範圍
     */
    P(this, "isInViewport", () => {
      if (document.querySelectorAll(".k-st-observe:not(.st-entered)").length <= 0) return;
      let t = 0, e = 0;
      const n = (s, o) => typeof s == "string" && s.includes("%") ? parseFloat(s) / 100 * o : parseFloat(s);
      this.options.scroller === window ? (e = window.innerHeight, t = window.scrollY) : this.options.scroller instanceof Element && (e = this.options.scroller.clientHeight, t = this.options.scroller.scrollTop);
      const r = (s, o) => {
        const c = o.getBoundingClientRect();
        if (s === window)
          return Math.floor(o.getBoundingClientRect().top + window.scrollY - ls(o));
        if (s instanceof Element) {
          const a = s.getBoundingClientRect();
          return Math.floor(c.top - a.top + s.scrollTop - ls(o));
        }
        return 0;
      };
      this.elements.forEach((s) => {
        if (!this.container.contains(s)) return;
        const o = r(this.options.scroller, s), c = s.clientHeight, a = s.getAttribute("k-st-start") ?? this.options.start, [l, u] = this.convertPositionString(a).split(" "), f = n(l, c), d = n(u, e);
        o + f <= t + d && s.classList.add("st-entered");
      });
    });
    P(this, "scrollTrigger", () => {
      if (this.elements.length <= 0) return;
      this.elements.forEach((e) => e.classList.add("k-st-observe"));
      const t = () => {
        this.isInViewport();
      };
      this.isInViewport(), (this.options.scroller instanceof Element || this.options.scroller === window) && this.options.scroller.addEventListener("scroll", t);
    });
    /**
     * 將位置轉換為對應百分比
     * @param position 位置的字串
     * @returns 返回百分比 top > 0%, center > 50%, bottom > 100%
     */
    P(this, "convertPositionString", (t) => {
      const e = {
        top: "0%",
        center: "50%",
        bottom: "100%"
      };
      return t.toLowerCase().split(" ").map((n) => e[n] || n).join(" ");
    });
    /**
     * 將屬性值轉換為像素值
     * @param attrString - 屬性值
     * @param baseVal - 基準值
     * @returns 轉換後的像素值
     */
    P(this, "covertToPixel", (t, e) => {
      if (/^-?\d+px$/.test(t))
        return parseInt(t.replace("px", ""), 10);
      if (/^-?\d+%$/.test(t) && e) {
        const n = parseInt(t.replace("%", ""), 10) / 100;
        return e * n;
      }
      return 0;
    });
    /**
     * 獲取元素與頁面頂部間的距離
     * @param element 欲獲取的元素
     * @returns
     */
    P(this, "getElementTopAbsolute", (t) => {
      let e = 0;
      for (; t; )
        e += t.offsetTop, t = t.offsetParent;
      return e;
    });
    /**
     * 產生標記
     * @param element 綁定 scroll-trigger 的元素
     */
    P(this, "createMarker", (t) => {
      var f;
      if (!t || !this.options.marker) return;
      const { scroller: e, start: n } = this.options, r = this.getElementTopAbsolute(t), s = t.clientHeight, o = t.getAttribute("k-st-start") ?? n, [c, a] = this.convertPositionString(o).split(" "), l = () => `${r + this.covertToPixel(c, s)}px`, u = (d, _) => {
        let p = d.querySelector(`.${_.split(" ").join(".")}`);
        return p || (p = document.createElement("div"), p.className = _, d.prepend(p)), p;
      };
      if (e !== window) {
        const d = e, _ = d.offsetWidth - d.clientWidth, p = "k-st-wrapper", h = "scroll-marker-wrapper", m = "element-marker-wrapper";
        let g = d.parentElement;
        (!g || !g.classList.contains(p)) && (g = document.createElement("div"), g.className = p, d.style.position = "relative", (f = d.parentNode) == null || f.insertBefore(g, d), g.appendChild(d));
        const v = u(g, h), x = u(d, m);
        this.insertMarker(v, "viewpoint", a), this.insertMarker(
          x,
          "observe-element",
          `${t.offsetTop + this.covertToPixel(c, s)}px`
        ), v.style.setProperty("--scrollbarWidth", _ + "px");
      } else {
        const d = "scroll-marker-wrapper inner-body", _ = "element-marker-wrapper inner-body", p = u(document.body, d), h = u(document.body, _);
        this.insertMarker(p, "viewpoint", a), this.insertMarker(h, "observe-element", l());
      }
    });
    /**
     * 重新設定標記的位置
     */
    P(this, "resetMarker", () => {
      const t = document.getElementById("st-marker-wrapper");
      t && (t.innerHTML = ""), this.elements.forEach((e) => {
        this.container.contains(e) && this.createMarker(e);
      });
    });
    /**
     * 重置所有進場效果
     * @param container 父層容器
     */
    P(this, "reset", (t, e) => {
      Array.from(t.querySelectorAll(e)).forEach((r) => {
        r.classList.remove("st-entered");
      }), this.isInViewport();
    });
    typeof e.scroller == "string" && (e.scroller = document.querySelector(e.scroller) || window);
    const n = {
      scroller: window,
      start: "top center",
      marker: !1
    };
    this.container = document.querySelector("[k-tools-container]"), this.selector = t, this.elements = Array.from(document.querySelectorAll(this.selector)), this.options = { ...n, ...e }, this.viewWidth = window.innerWidth, this.init();
  }
  /**
   * 插入標記
   * @param wrapper 容器元素
   * @param type 標記類型
   * @param start 標記的 --start 屬性值
   */
  insertMarker(t, e, n) {
    const r = Array.from(t.querySelectorAll(`.marker-item.${e}`)).find(
      (o) => getComputedStyle(o).getPropertyValue("--start") === n
    );
    if (r && getComputedStyle(r).getPropertyValue("--start") === n)
      return;
    const s = document.createElement("div");
    s.className = `marker-item ${e}`, s.style.setProperty("--start", n), t.appendChild(s);
  }
}
class Su {
  constructor(t, e) {
    P(this, "container");
    P(this, "selector");
    P(this, "elements");
    P(this, "options");
    P(this, "viewWidth");
    P(this, "itemSelector");
    P(this, "headingSelector");
    P(this, "contentSelector");
    /**
     * 初始化
     */
    P(this, "init", () => {
      if (!this.container) {
        console.error("Can't not found [k-tools-container]");
        return;
      }
      this.event();
    });
    /**
     * 事件綁定
     */
    P(this, "event", () => {
      const t = this, { firstOpen: e, allOpen: n } = t.options;
      t.setContentHeight(), t.elements.forEach((r) => {
        const s = Array.from(r.querySelectorAll(t.itemSelector));
        if (s.length !== 0) {
          if (n) {
            s.forEach((o) => o.classList.add("active"));
            return;
          }
          e && s[0].classList.add("active");
        }
      }), document.querySelectorAll(t.selector).forEach((r) => {
        r.addEventListener("click", t.handleAccordionClick);
      }), window.addEventListener(
        "resize",
        Us(() => {
          this.viewWidth !== window.innerWidth && (this.viewWidth = window.innerWidth, this.updateAll());
        })
      );
    });
    /**
     * 點擊事件處理
     */
    P(this, "handleAccordionClick", (t) => {
      var _;
      const {
        onlyOneOpen: e,
        allOpen: n,
        onOpenAnchor: r,
        anchorScroller: s,
        anchorSpeed: o,
        anchorEase: c,
        anchorSpacerSelector: a,
        anchorOffset: l
      } = this.options, u = t.target, f = u.closest(this.selector), d = u.closest(this.headingSelector);
      if (d) {
        const p = d.closest(this.itemSelector), h = Array.from(p.querySelectorAll(this.contentSelector))[0];
        if ((_ = p.parentElement) != null && _.closest(this.itemSelector)) {
          let g = p;
          for (; g != null && g.parentElement; )
            g = g.parentElement, g.matches(this.itemSelector) && Array.from(g.querySelectorAll(this.contentSelector))[0].style.setProperty("--height", "auto");
        }
        p.classList.contains("active") ? this.handleClose(p) : (!n && e && p.parentElement instanceof Element && Array.from(p.parentElement.children).filter(
          (v) => v.matches(this.itemSelector)
        ).forEach((v) => {
          v instanceof HTMLElement && p !== v && this.handleClose(v);
        }), this.handleOpen(p));
        const m = (g) => {
          var v, x;
          g.target === h && (this.update(f), (x = (v = this.options).onToggle) == null || x.call(v), p.classList.contains("active") && r && Ws(p, {
            scroller: s,
            speed: o,
            ease: c,
            spacerSelector: a,
            offset: l
          })), h.removeEventListener("transitionend", m);
        };
        h.addEventListener("transitionend", m);
      }
    });
    /**
     * 獲取收合高度
     */
    P(this, "getContentHeight", (t) => {
      const e = t.firstElementChild;
      return t instanceof HTMLElement && e instanceof HTMLElement ? e.offsetHeight : 0;
    });
    /**
     * 設定收合高度
     */
    P(this, "setContentHeight", () => {
      this.elements.forEach((t) => {
        Array.from(t.querySelectorAll(this.contentSelector)).forEach((n) => {
          n instanceof HTMLElement && n.style.setProperty("--height", `${this.getContentHeight(n)}px`);
        });
      });
    });
    /**
     * 打開
     * @param item 欲控制的收合元素
     */
    P(this, "handleOpen", (t) => {
      t.classList.add("active");
    });
    /**
     * 關閉
     * @param item 欲控制的收合元素
     */
    P(this, "handleClose", (t) => {
      t.classList.remove("active");
    });
    /**
     * 更新指定收合的高度
     * @param accordionContainer 欲更新的收合元素
     */
    P(this, "update", (t) => {
      Array.from(t.querySelectorAll(this.contentSelector)).forEach((n) => {
        n instanceof HTMLElement && n.style.setProperty("--height", `${this.getContentHeight(n)}px`);
      });
    });
    /**
     * 更新全部收合高度
     */
    P(this, "updateAll", () => {
      this.setContentHeight();
    });
    const n = {
      firstOpen: !0,
      onlyOneOpen: !0,
      allOpen: !1,
      onOpenAnchor: !0,
      anchorScroller: window,
      anchorSpeed: 600,
      anchorEase: "ease",
      anchorSpacerSelector: "",
      anchorOffset: 0
    };
    this.container = document.querySelector("[k-tools-container]"), this.selector = t, this.elements = Array.from(document.querySelectorAll(this.selector)), this.options = { ...n, ...e }, this.viewWidth = window.innerWidth, this.itemSelector = ".accordion__item", this.headingSelector = ".accordion__heading", this.contentSelector = ".accordion__content", this.init();
  }
}
class Tu {
  constructor(t, e) {
    P(this, "container");
    P(this, "selector");
    P(this, "elements");
    P(this, "options");
    P(this, "init", () => {
      if (!this.container) {
        console.error("Can't not found [k-tools-container]");
        return;
      }
      this.detectVisibility();
    });
    P(this, "detectVisibility", () => {
      if (this.elements.length <= 0) return;
      this.elements.forEach((n) => n.classList.add("k-scrollspy-observe"));
      const t = () => {
        const { offset: n, spacerSelector: r } = this.options, s = r ? document.querySelector(r) : null, o = (s == null ? void 0 : s.offsetHeight) || 0, c = window.innerHeight + window.scrollY >= document.body.offsetHeight;
        this.elements.forEach((a, l) => {
          var h, m, g, v;
          if (!this.container.contains(a)) return;
          const u = a.getAttribute("k-scrollspy-id"), f = Array.from(document.querySelectorAll(`[k-scrollspy-href="${u}"]`)), d = a.getBoundingClientRect(), _ = Math.floor(d.top) <= n + o && Math.floor(d.bottom) > n + o, p = Math.floor(d.top) > n + o || Math.floor(d.top) <= -a.clientHeight + n + o;
          _ && !a.classList.contains("active") && (f.forEach((x) => {
            x.classList.add("active");
          }), (m = (h = this.options).onEnter) == null || m.call(h, u)), p && f.forEach((x) => {
            x.classList.remove("active");
          }), c && l === this.elements.length - 1 && !a.classList.contains("active") && (this.elements.forEach((x) => {
            const y = x.getAttribute("k-scrollspy-id");
            Array.from(document.querySelectorAll(`[k-scrollspy-href="${y}"]`)).forEach((S) => S.classList.remove("active"));
          }), f.forEach((x) => x.classList.add("active")), (v = (g = this.options).onEnter) == null || v.call(g, u));
        });
      }, e = () => {
        t();
      };
      t(), (this.options.scroller instanceof Element || this.options.scroller === window) && this.options.scroller.addEventListener("scroll", e);
    });
    typeof (e == null ? void 0 : e.scroller) == "string" && (e.scroller = document.querySelector(e.scroller) || window);
    const n = {
      scroller: window,
      offset: 0
    };
    this.container = document.querySelector("[k-tools-container]"), this.selector = t, this.elements = Array.from(document.querySelectorAll(this.selector)), this.options = { ...n, ...e }, this.init();
  }
}
/*!
 * OverlayScrollbars
 * Version: 2.10.1
 *
 * Copyright (c) Rene Haas | KingSora.
 * https://github.com/KingSora
 *
 * Released under the MIT license.
 */
const It = (i, t) => {
  const { o: e, i: n, u: r } = i;
  let s = e, o;
  const c = (u, f) => {
    const d = s, _ = u, p = f || (n ? !n(d, _) : d !== _);
    return (p || r) && (s = _, o = d), [s, p, o];
  };
  return [t ? (u) => c(t(s, o), u) : c, (u) => [s, !!u, o]];
}, ml = typeof window < "u" && typeof HTMLElement < "u" && !!window.document, Pt = ml ? window : {}, ec = Math.max, gl = Math.min, fs = Math.round, dr = Math.abs, Ai = Math.sign, nc = Pt.cancelAnimationFrame, Ys = Pt.requestAnimationFrame, pr = Pt.setTimeout, hs = Pt.clearTimeout, Tr = (i) => typeof Pt[i] < "u" ? Pt[i] : void 0, yl = Tr("MutationObserver"), Pi = Tr("IntersectionObserver"), _r = Tr("ResizeObserver"), nr = Tr("ScrollTimeline"), Xs = (i) => i === void 0, kr = (i) => i === null, ie = (i) => typeof i == "number", $n = (i) => typeof i == "string", Gs = (i) => typeof i == "boolean", Kt = (i) => typeof i == "function", ce = (i) => Array.isArray(i), mr = (i) => typeof i == "object" && !ce(i) && !kr(i), Ks = (i) => {
  const t = !!i && i.length, e = ie(t) && t > -1 && t % 1 == 0;
  return ce(i) || !Kt(i) && e ? t > 0 && mr(i) ? t - 1 in i : !0 : !1;
}, gr = (i) => !!i && i.constructor === Object, yr = (i) => i instanceof HTMLElement, Cr = (i) => i instanceof Element;
function Z(i, t) {
  if (Ks(i))
    for (let e = 0; e < i.length && t(i[e], e, i) !== !1; e++)
      ;
  else i && Z(Object.keys(i), (e) => t(i[e], e, i));
  return i;
}
const rc = (i, t) => i.indexOf(t) >= 0, En = (i, t) => i.concat(t), ct = (i, t, e) => (!$n(t) && Ks(t) ? Array.prototype.push.apply(i, t) : i.push(t), i), Me = (i) => Array.from(i || []), js = (i) => ce(i) ? i : !$n(i) && Ks(i) ? Me(i) : [i], ds = (i) => !!i && !i.length, ps = (i) => Me(new Set(i)), Bt = (i, t, e) => {
  Z(i, (r) => r ? r.apply(void 0, t || []) : !0), !e && (i.length = 0);
}, sc = "paddingTop", ic = "paddingRight", oc = "paddingLeft", cc = "paddingBottom", ac = "marginLeft", lc = "marginRight", uc = "marginBottom", fc = "overflowX", hc = "overflowY", Or = "width", Ar = "height", ye = "visible", $e = "hidden", an = "scroll", vl = (i) => {
  const t = String(i || "");
  return t ? t[0].toUpperCase() + t.slice(1) : "";
}, Pr = (i, t, e, n) => {
  if (i && t) {
    let r = !0;
    return Z(e, (s) => {
      const o = i[s], c = t[s];
      o !== c && (r = !1);
    }), r;
  }
  return !1;
}, dc = (i, t) => Pr(i, t, ["w", "h"]), rr = (i, t) => Pr(i, t, ["x", "y"]), bl = (i, t) => Pr(i, t, ["t", "r", "b", "l"]), qe = () => {
}, V = (i, ...t) => i.bind(0, ...t), Ke = (i) => {
  let t;
  const e = i ? pr : Ys, n = i ? hs : nc;
  return [(r) => {
    n(t), t = e(() => r(), Kt(i) ? i() : i);
  }, () => n(t)];
}, _s = (i, t) => {
  const { _: e, p: n, v: r, S: s } = t || {};
  let o, c, a, l, u = qe;
  const f = function(m) {
    u(), hs(o), l = o = c = void 0, u = qe, i.apply(this, m);
  }, d = (h) => s && c ? s(c, h) : h, _ = () => {
    u !== qe && f(d(a) || a);
  }, p = function() {
    const m = Me(arguments), g = Kt(e) ? e() : e;
    if (ie(g) && g >= 0) {
      const x = Kt(n) ? n() : n, y = ie(x) && x >= 0, b = g > 0 ? pr : Ys, S = g > 0 ? hs : nc, k = d(m) || m, w = f.bind(0, k);
      let O;
      u(), r && !l ? (w(), l = !0, O = b(() => l = void 0, g)) : (O = b(w, g), y && !o && (o = pr(_, x))), u = () => S(O), c = a = k;
    } else
      f(m);
  };
  return p.m = _, p;
}, pc = (i, t) => Object.prototype.hasOwnProperty.call(i, t), jt = (i) => i ? Object.keys(i) : [], K = (i, t, e, n, r, s, o) => {
  const c = [t, e, n, r, s, o];
  return (typeof i != "object" || kr(i)) && !Kt(i) && (i = {}), Z(c, (a) => {
    Z(a, (l, u) => {
      const f = a[u];
      if (i === f)
        return !0;
      const d = ce(f);
      if (f && gr(f)) {
        const _ = i[u];
        let p = _;
        d && !ce(_) ? p = [] : !d && !gr(_) && (p = {}), i[u] = K(p, f);
      } else
        i[u] = d ? f.slice() : f;
    });
  }), i;
}, _c = (i, t) => Z(K({}, i), (e, n, r) => {
  e === void 0 ? delete r[n] : e && gr(e) && (r[n] = _c(e));
}), Zs = (i) => !jt(i).length, mc = (i, t, e) => ec(i, gl(t, e)), Be = (i) => ps((ce(i) ? i : (i || "").split(" ")).filter((t) => t)), Qs = (i, t) => i && i.getAttribute(t), Mi = (i, t) => i && i.hasAttribute(t), ue = (i, t, e) => {
  Z(Be(t), (n) => {
    i && i.setAttribute(n, String(e || ""));
  });
}, Qt = (i, t) => {
  Z(Be(t), (e) => i && i.removeAttribute(e));
}, Mr = (i, t) => {
  const e = Be(Qs(i, t)), n = V(ue, i, t), r = (s, o) => {
    const c = new Set(e);
    return Z(Be(s), (a) => {
      c[o](a);
    }), Me(c).join(" ");
  };
  return {
    O: (s) => n(r(s, "delete")),
    $: (s) => n(r(s, "add")),
    C: (s) => {
      const o = Be(s);
      return o.reduce((c, a) => c && e.includes(a), o.length > 0);
    }
  };
}, gc = (i, t, e) => (Mr(i, t).O(e), V(Js, i, t, e)), Js = (i, t, e) => (Mr(i, t).$(e), V(gc, i, t, e)), vr = (i, t, e, n) => (n ? Js : gc)(i, t, e), ti = (i, t, e) => Mr(i, t).C(e), yc = (i) => Mr(i, "class"), vc = (i, t) => {
  yc(i).O(t);
}, ei = (i, t) => (yc(i).$(t), V(vc, i, t)), bc = (i, t) => {
  const e = t ? Cr(t) && t : document;
  return e ? Me(e.querySelectorAll(i)) : [];
}, wl = (i, t) => {
  const e = t ? Cr(t) && t : document;
  return e && e.querySelector(i);
}, ms = (i, t) => Cr(i) && i.matches(t), wc = (i) => ms(i, "body"), gs = (i) => i ? Me(i.childNodes) : [], Dn = (i) => i && i.parentElement, je = (i, t) => Cr(i) && i.closest(t), ys = (i) => document.activeElement, xl = (i, t, e) => {
  const n = je(i, t), r = i && wl(e, n), s = je(r, t) === n;
  return n && r ? n === i || r === i || s && je(je(i, e), t) !== n : !1;
}, ln = (i) => {
  Z(js(i), (t) => {
    const e = Dn(t);
    t && e && e.removeChild(t);
  });
}, zt = (i, t) => V(ln, i && t && Z(js(t), (e) => {
  e && i.appendChild(e);
})), tn = (i) => {
  const t = document.createElement("div");
  return ue(t, "class", i), t;
}, xc = (i) => {
  const t = tn();
  return t.innerHTML = i.trim(), Z(gs(t), (e) => ln(e));
}, Ei = (i, t) => i.getPropertyValue(t) || i[t] || "", Sc = (i) => {
  const t = i || 0;
  return isFinite(t) ? t : 0;
}, Zn = (i) => Sc(parseFloat(i || "")), vs = (i) => Math.round(i * 1e4) / 1e4, Tc = (i) => `${vs(Sc(i))}px`;
function Ln(i, t) {
  i && t && Z(t, (e, n) => {
    try {
      const r = i.style, s = kr(e) || Gs(e) ? "" : ie(e) ? Tc(e) : e;
      n.indexOf("--") === 0 ? r.setProperty(n, s) : r[n] = s;
    } catch {
    }
  });
}
function me(i, t, e) {
  const n = $n(t);
  let r = n ? "" : {};
  if (i) {
    const s = Pt.getComputedStyle(i, e) || i.style;
    r = n ? Ei(s, t) : Me(t).reduce((o, c) => (o[c] = Ei(s, c), o), r);
  }
  return r;
}
const Di = (i, t, e) => {
  const n = t ? `${t}-` : "", r = e ? `-${e}` : "", s = `${n}top${r}`, o = `${n}right${r}`, c = `${n}bottom${r}`, a = `${n}left${r}`, l = me(i, [s, o, c, a]);
  return {
    t: Zn(l[s]),
    r: Zn(l[o]),
    b: Zn(l[c]),
    l: Zn(l[a])
  };
}, Sl = (i, t) => `translate${mr(i) ? `(${i.x},${i.y})` : `Y(${i})`}`, Tl = (i) => !!(i.offsetWidth || i.offsetHeight || i.getClientRects().length), kl = {
  w: 0,
  h: 0
}, Er = (i, t) => t ? {
  w: t[`${i}Width`],
  h: t[`${i}Height`]
} : kl, Cl = (i) => Er("inner", i || Pt), en = V(Er, "offset"), kc = V(Er, "client"), br = V(Er, "scroll"), ni = (i) => {
  const t = parseFloat(me(i, Or)) || 0, e = parseFloat(me(i, Ar)) || 0;
  return {
    w: t - fs(t),
    h: e - fs(e)
  };
}, Ur = (i) => i.getBoundingClientRect(), Ol = (i) => !!i && Tl(i), bs = (i) => !!(i && (i[Ar] || i[Or])), Cc = (i, t) => {
  const e = bs(i);
  return !bs(t) && e;
}, Li = (i, t, e, n) => {
  Z(Be(t), (r) => {
    i && i.removeEventListener(r, e, n);
  });
}, nt = (i, t, e, n) => {
  var r;
  const s = (r = n && n.H) != null ? r : !0, o = n && n.I || !1, c = n && n.A || !1, a = {
    passive: s,
    capture: o
  };
  return V(Bt, Be(t).map((l) => {
    const u = c ? (f) => {
      Li(i, l, u, o), e && e(f);
    } : e;
    return i && i.addEventListener(l, u, a), V(Li, i, l, u, o);
  }));
}, Oc = (i) => i.stopPropagation(), ws = (i) => i.preventDefault(), Ac = (i) => Oc(i) || ws(i), re = (i, t) => {
  const { x: e, y: n } = ie(t) ? {
    x: t,
    y: t
  } : t || {};
  ie(e) && (i.scrollLeft = e), ie(n) && (i.scrollTop = n);
}, Ht = (i) => ({
  x: i.scrollLeft,
  y: i.scrollTop
}), Pc = () => ({
  D: {
    x: 0,
    y: 0
  },
  M: {
    x: 0,
    y: 0
  }
}), Al = (i, t) => {
  const { D: e, M: n } = i, { w: r, h: s } = t, o = (f, d, _) => {
    let p = Ai(f) * _, h = Ai(d) * _;
    if (p === h) {
      const m = dr(f), g = dr(d);
      h = m > g ? 0 : h, p = m < g ? 0 : p;
    }
    return p = p === h ? 0 : p, [p + 0, h + 0];
  }, [c, a] = o(e.x, n.x, r), [l, u] = o(e.y, n.y, s);
  return {
    D: {
      x: c,
      y: l
    },
    M: {
      x: a,
      y: u
    }
  };
}, Ri = ({ D: i, M: t }) => {
  const e = (n, r) => n === 0 && n <= r;
  return {
    x: e(i.x, t.x),
    y: e(i.y, t.y)
  };
}, Ii = ({ D: i, M: t }, e) => {
  const n = (r, s, o) => mc(0, 1, (r - o) / (r - s) || 0);
  return {
    x: n(i.x, t.x, e.x),
    y: n(i.y, t.y, e.y)
  };
}, xs = (i) => {
  i && i.focus && i.focus({
    preventScroll: !0
  });
}, $i = (i, t) => {
  Z(js(t), i);
}, Ss = (i) => {
  const t = /* @__PURE__ */ new Map(), e = (s, o) => {
    if (s) {
      const c = t.get(s);
      $i((a) => {
        c && c[a ? "delete" : "clear"](a);
      }, o);
    } else
      t.forEach((c) => {
        c.clear();
      }), t.clear();
  }, n = (s, o) => {
    if ($n(s)) {
      const l = t.get(s) || /* @__PURE__ */ new Set();
      return t.set(s, l), $i((u) => {
        Kt(u) && l.add(u);
      }, o), V(e, s, o);
    }
    Gs(o) && o && e();
    const c = jt(s), a = [];
    return Z(c, (l) => {
      const u = s[l];
      u && ct(a, n(l, u));
    }), V(Bt, a);
  }, r = (s, o) => {
    Z(Me(t.get(s)), (c) => {
      o && !ds(o) ? c.apply(0, o) : c();
    });
  };
  return n(i || {}), [n, e, r];
}, Mc = {}, Ec = {}, Pl = (i) => {
  Z(i, (t) => Z(t, (e, n) => {
    Mc[n] = t[n];
  }));
}, Dc = (i, t, e) => jt(i).map((n) => {
  const { static: r, instance: s } = i[n], [o, c, a] = e || [], l = e ? s : r;
  if (l) {
    const u = e ? l(o, c, t) : l(t);
    return (a || Ec)[n] = u;
  }
}), Fn = (i) => Ec[i], Ml = "__osOptionsValidationPlugin", fn = "data-overlayscrollbars", sr = "os-environment", Qn = `${sr}-scrollbar-hidden`, Yr = `${fn}-initialize`, ir = "noClipping", Fi = `${fn}-body`, ke = fn, El = "host", fe = `${fn}-viewport`, Dl = fc, Ll = hc, Rl = "arrange", Lc = "measuring", Il = "scrolling", Rc = "scrollbarHidden", $l = "noContent", Ts = `${fn}-padding`, zi = `${fn}-content`, ri = "os-size-observer", Fl = `${ri}-appear`, zl = `${ri}-listener`, Hl = "os-trinsic-observer", Nl = "os-theme-none", Wt = "os-scrollbar", ql = `${Wt}-rtl`, Bl = `${Wt}-horizontal`, Vl = `${Wt}-vertical`, Ic = `${Wt}-track`, si = `${Wt}-handle`, Wl = `${Wt}-visible`, Ul = `${Wt}-cornerless`, Hi = `${Wt}-interaction`, Ni = `${Wt}-unusable`, ks = `${Wt}-auto-hide`, qi = `${ks}-hidden`, Bi = `${Wt}-wheel`, Yl = `${Ic}-interactive`, Xl = `${si}-interactive`, Gl = "__osSizeObserverPlugin", Kl = (i, t) => {
  const { T: e } = t, [n, r] = i("showNativeOverlaidScrollbars");
  return [n && e.x && e.y, r];
}, un = (i) => i.indexOf(ye) === 0, jl = (i, t) => {
  const e = (r, s, o, c) => {
    const a = r === ye ? $e : r.replace(`${ye}-`, ""), l = un(r), u = un(o);
    return !s && !c ? $e : l && u ? ye : l ? s && c ? a : s ? ye : $e : s ? a : u && c ? ye : $e;
  }, n = {
    x: e(t.x, i.x, t.y, i.y),
    y: e(t.y, i.y, t.x, i.x)
  };
  return {
    k: n,
    R: {
      x: n.x === an,
      y: n.y === an
    }
  };
}, $c = "__osScrollbarsHidingPlugin", Zl = "__osClickScrollPlugin", Vi = (i) => JSON.stringify(i, (t, e) => {
  if (Kt(e))
    throw 0;
  return e;
}), Wi = (i, t) => i ? `${t}`.split(".").reduce((e, n) => e && pc(e, n) ? e[n] : void 0, i) : void 0, Ql = {
  paddingAbsolute: !1,
  showNativeOverlaidScrollbars: !1,
  update: {
    elementEvents: [["img", "load"]],
    debounce: [0, 33],
    attributes: null,
    ignoreMutation: null
  },
  overflow: {
    x: "scroll",
    y: "scroll"
  },
  scrollbars: {
    theme: "os-theme-dark",
    visibility: "auto",
    autoHide: "never",
    autoHideDelay: 1300,
    autoHideSuspend: !1,
    dragScroll: !0,
    clickScroll: !1,
    pointers: ["mouse", "touch", "pen"]
  }
}, Fc = (i, t) => {
  const e = {}, n = En(jt(t), jt(i));
  return Z(n, (r) => {
    const s = i[r], o = t[r];
    if (mr(s) && mr(o))
      K(e[r] = {}, Fc(s, o)), Zs(e[r]) && delete e[r];
    else if (pc(t, r) && o !== s) {
      let c = !0;
      if (ce(s) || ce(o))
        try {
          Vi(s) === Vi(o) && (c = !1);
        } catch {
        }
      c && (e[r] = o);
    }
  }), e;
}, Ui = (i, t, e) => (n) => [Wi(i, n), e || Wi(t, n) !== void 0];
let zc;
const Jl = () => zc, tu = (i) => {
  zc = i;
};
let Xr;
const eu = () => {
  const i = (y, b, S) => {
    zt(document.body, y), zt(document.body, y);
    const T = kc(y), k = en(y), w = ni(b);
    return S && ln(y), {
      x: k.h - T.h + w.h,
      y: k.w - T.w + w.w
    };
  }, t = (y) => {
    let b = !1;
    const S = ei(y, Qn);
    try {
      b = me(y, "scrollbar-width") === "none" || me(y, "display", "::-webkit-scrollbar") === "none";
    } catch {
    }
    return S(), b;
  }, e = `.${sr}{scroll-behavior:auto!important;position:fixed;opacity:0;visibility:hidden;overflow:scroll;height:200px;width:200px;z-index:-1}.${sr} div{width:200%;height:200%;margin:10px 0}.${Qn}{scrollbar-width:none!important}.${Qn}::-webkit-scrollbar,.${Qn}::-webkit-scrollbar-corner{appearance:none!important;display:none!important;width:0!important;height:0!important}`, r = xc(`<div class="${sr}"><div></div><style>${e}</style></div>`)[0], s = r.firstChild, o = r.lastChild, c = Jl();
  c && (o.nonce = c);
  const [a, , l] = Ss(), [u, f] = It({
    o: i(r, s),
    i: rr
  }, V(i, r, s, !0)), [d] = f(), _ = t(r), p = {
    x: d.x === 0,
    y: d.y === 0
  }, h = {
    elements: {
      host: null,
      padding: !_,
      viewport: (y) => _ && wc(y) && y,
      content: !1
    },
    scrollbars: {
      slot: !0
    },
    cancel: {
      nativeScrollbarsOverlaid: !1,
      body: null
    }
  }, m = K({}, Ql), g = V(K, {}, m), v = V(K, {}, h), x = {
    N: d,
    T: p,
    P: _,
    G: !!nr,
    K: V(a, "r"),
    Z: v,
    tt: (y) => K(h, y) && v(),
    nt: g,
    ot: (y) => K(m, y) && g(),
    st: K({}, h),
    et: K({}, m)
  };
  if (Qt(r, "style"), ln(r), nt(Pt, "resize", () => {
    l("r", []);
  }), Kt(Pt.matchMedia) && !_ && (!p.x || !p.y)) {
    const y = (b) => {
      const S = Pt.matchMedia(`(resolution: ${Pt.devicePixelRatio}dppx)`);
      nt(S, "change", () => {
        b(), y(b);
      }, {
        A: !0
      });
    };
    y(() => {
      const [b, S] = u();
      K(x.N, b), l("r", [S]);
    });
  }
  return x;
}, ae = () => (Xr || (Xr = eu()), Xr), nu = (i, t, e) => {
  let n = !1;
  const r = e ? /* @__PURE__ */ new WeakMap() : !1, s = () => {
    n = !0;
  }, o = (c) => {
    if (r && e) {
      const a = e.map((l) => {
        const [u, f] = l || [];
        return [f && u ? (c || bc)(u, i) : [], f];
      });
      Z(a, (l) => Z(l[0], (u) => {
        const f = l[1], d = r.get(u) || [];
        if (i.contains(u) && f) {
          const p = nt(u, f, (h) => {
            n ? (p(), r.delete(u)) : t(h);
          });
          r.set(u, ct(d, p));
        } else
          Bt(d), r.delete(u);
      }));
    }
  };
  return o(), [s, o];
}, Yi = (i, t, e, n) => {
  let r = !1;
  const { ct: s, rt: o, lt: c, it: a, ut: l, _t: u } = n || {}, f = _s(() => r && e(!0), {
    _: 33,
    p: 99
  }), [d, _] = nu(i, f, c), p = s || [], h = o || [], m = En(p, h), g = (x, y) => {
    if (!ds(y)) {
      const b = l || qe, S = u || qe, T = [], k = [];
      let w = !1, O = !1;
      if (Z(y, (E) => {
        const { attributeName: M, target: L, type: $, oldValue: q, addedNodes: H, removedNodes: N } = E, W = $ === "attributes", U = $ === "childList", j = i === L, F = W && M, C = F && Qs(L, M || ""), R = $n(C) ? C : null, D = F && q !== R, A = rc(h, M) && D;
        if (t && (U || !j)) {
          const z = W && D, I = z && a && ms(L, a), X = (I ? !b(L, M, q, R) : !W || z) && !S(E, !!I, i, n);
          Z(H, (Q) => ct(T, Q)), Z(N, (Q) => ct(T, Q)), O = O || X;
        }
        !t && j && D && !b(L, M, q, R) && (ct(k, M), w = w || A);
      }), _((E) => ps(T).reduce((M, L) => (ct(M, bc(E, L)), ms(L, E) ? ct(M, L) : M), [])), t)
        return !x && O && e(!1), [!1];
      if (!ds(k) || w) {
        const E = [ps(k), w];
        return !x && e.apply(0, E), E;
      }
    }
  }, v = new yl(V(g, !1));
  return [() => (v.observe(i, {
    attributes: !0,
    attributeOldValue: !0,
    attributeFilter: m,
    subtree: t,
    childList: t,
    characterData: t
  }), r = !0, () => {
    r && (d(), v.disconnect(), r = !1);
  }), () => {
    if (r)
      return f.m(), g(!0, v.takeRecords());
  }];
}, Hc = (i, t, e) => {
  const { dt: n } = e || {}, r = Fn(Gl), [s] = It({
    o: !1,
    u: !0
  });
  return () => {
    const o = [], a = xc(`<div class="${ri}"><div class="${zl}"></div></div>`)[0], l = a.firstChild, u = (f) => {
      const d = f instanceof ResizeObserverEntry;
      let _ = !1, p = !1;
      if (d) {
        const [h, , m] = s(f.contentRect), g = bs(h);
        p = Cc(h, m), _ = !p && !g;
      } else
        p = f === !0;
      _ || t({
        ft: !0,
        dt: p
      });
    };
    if (_r) {
      const f = new _r((d) => u(d.pop()));
      f.observe(l), ct(o, () => {
        f.disconnect();
      });
    } else if (r) {
      const [f, d] = r(l, u, n);
      ct(o, En([ei(a, Fl), nt(a, "animationstart", f)], d));
    } else
      return qe;
    return V(Bt, ct(o, zt(i, a)));
  };
}, ru = (i, t) => {
  let e;
  const n = (a) => a.h === 0 || a.isIntersecting || a.intersectionRatio > 0, r = tn(Hl), [s] = It({
    o: !1
  }), o = (a, l) => {
    if (a) {
      const u = s(n(a)), [, f] = u;
      return f && !l && t(u) && [u];
    }
  }, c = (a, l) => o(l.pop(), a);
  return [() => {
    const a = [];
    if (Pi)
      e = new Pi(V(c, !1), {
        root: i
      }), e.observe(r), ct(a, () => {
        e.disconnect();
      });
    else {
      const l = () => {
        const u = en(r);
        o(u);
      };
      ct(a, Hc(r, l)()), l();
    }
    return V(Bt, ct(a, zt(i, r)));
  }, () => e && c(!0, e.takeRecords())];
}, su = (i, t, e, n) => {
  let r, s, o, c, a, l;
  const u = `[${ke}]`, f = `[${fe}]`, d = ["id", "class", "style", "open", "wrap", "cols", "rows"], { vt: _, ht: p, U: h, gt: m, bt: g, L: v, wt: x, yt: y, St: b, Ot: S } = i, T = (A) => me(A, "direction") === "rtl", k = {
    $t: !1,
    F: T(_)
  }, w = ae(), O = Fn($c), [E] = It({
    i: dc,
    o: {
      w: 0,
      h: 0
    }
  }, () => {
    const A = O && O.V(i, t, k, w, e).X, I = !(x && v) && ti(p, ke, ir), B = !v && y(Rl), X = B && Ht(m), Q = X && S(), dt = b(Lc, I), at = B && A && A()[0], wt = br(h), Y = ni(h);
    return at && at(), re(m, X), Q && Q(), I && dt(), {
      w: wt.w + Y.w,
      h: wt.h + Y.h
    };
  }), M = _s(n, {
    _: () => r,
    p: () => s,
    S(A, z) {
      const [I] = A, [B] = z;
      return [En(jt(I), jt(B)).reduce((X, Q) => (X[Q] = I[Q] || B[Q], X), {})];
    }
  }), L = (A) => {
    const z = T(_);
    K(A, {
      Ct: l !== z
    }), K(k, {
      F: z
    }), l = z;
  }, $ = (A, z) => {
    const [I, B] = A, X = {
      xt: B
    };
    return K(k, {
      $t: I
    }), !z && n(X), X;
  }, q = ({ ft: A, dt: z }) => {
    const B = !(A && !z) && w.P ? M : n, X = {
      ft: A || z,
      dt: z
    };
    L(X), B(X);
  }, H = (A, z) => {
    const [, I] = E(), B = {
      Ht: I
    };
    return L(B), I && !z && (A ? n : M)(B), B;
  }, N = (A, z, I) => {
    const B = {
      Et: z
    };
    return L(B), z && !I && M(B), B;
  }, [W, U] = g ? ru(p, $) : [], j = !v && Hc(p, q, {
    dt: !0
  }), [F, C] = Yi(p, !1, N, {
    rt: d,
    ct: d
  }), R = v && _r && new _r((A) => {
    const z = A[A.length - 1].contentRect;
    q({
      ft: !0,
      dt: Cc(z, a)
    }), a = z;
  }), D = _s(() => {
    const [, A] = E();
    n({
      Ht: A
    });
  }, {
    _: 222,
    v: !0
  });
  return [() => {
    R && R.observe(p);
    const A = j && j(), z = W && W(), I = F(), B = w.K((X) => {
      X ? M({
        zt: X
      }) : D();
    });
    return () => {
      R && R.disconnect(), A && A(), z && z(), c && c(), I(), B();
    };
  }, ({ It: A, At: z, Dt: I }) => {
    const B = {}, [X] = A("update.ignoreMutation"), [Q, dt] = A("update.attributes"), [at, wt] = A("update.elementEvents"), [Y, pt] = A("update.debounce"), At = wt || dt, mt = z || I, gt = (ut) => Kt(X) && X(ut);
    if (At) {
      o && o(), c && c();
      const [ut, ft] = Yi(g || h, !0, H, {
        ct: En(d, Q || []),
        lt: at,
        it: u,
        _t: (st, et) => {
          const { target: yt, attributeName: kt } = st;
          return (!et && kt && !v ? xl(yt, u, f) : !1) || !!je(yt, `.${Wt}`) || !!gt(st);
        }
      });
      c = ut(), o = ft;
    }
    if (pt)
      if (M.m(), ce(Y)) {
        const ut = Y[0], ft = Y[1];
        r = ie(ut) && ut, s = ie(ft) && ft;
      } else ie(Y) ? (r = Y, s = !1) : (r = !1, s = !1);
    if (mt) {
      const ut = C(), ft = U && U(), st = o && o();
      ut && K(B, N(ut[0], ut[1], mt)), ft && K(B, $(ft[0], mt)), st && K(B, H(st[0], mt));
    }
    return L(B), B;
  }, k];
}, Nc = (i, t) => Kt(t) ? t.apply(0, i) : t, iu = (i, t, e, n) => {
  const r = Xs(n) ? e : n;
  return Nc(i, r) || t.apply(0, i);
}, qc = (i, t, e, n) => {
  const r = Xs(n) ? e : n, s = Nc(i, r);
  return !!s && (yr(s) ? s : t.apply(0, i));
}, ou = (i, t) => {
  const { nativeScrollbarsOverlaid: e, body: n } = t || {}, { T: r, P: s, Z: o } = ae(), { nativeScrollbarsOverlaid: c, body: a } = o().cancel, l = e ?? c, u = Xs(n) ? a : n, f = (r.x || r.y) && l, d = i && (kr(u) ? !s : u);
  return !!f || !!d;
}, cu = (i, t, e, n) => {
  const r = "--os-viewport-percent", s = "--os-scroll-percent", o = "--os-scroll-direction", { Z: c } = ae(), { scrollbars: a } = c(), { slot: l } = a, { vt: u, ht: f, U: d, Mt: _, gt: p, wt: h, L: m } = t, { scrollbars: g } = _ ? {} : i, { slot: v } = g || {}, x = [], y = [], b = [], S = qc([u, f, d], () => m && h ? u : f, l, v), T = (F) => {
    if (nr) {
      const C = new nr({
        source: p,
        axis: F
      });
      return {
        kt: (D) => {
          const A = D.Tt.animate({
            clear: ["left"],
            [s]: [0, 1]
          }, {
            timeline: C
          });
          return () => A.cancel();
        }
      };
    }
  }, k = {
    x: T("x"),
    y: T("y")
  }, w = () => {
    const { Rt: F, Vt: C } = e, R = (D, A) => mc(0, 1, D / (D + A) || 0);
    return {
      x: R(C.x, F.x),
      y: R(C.y, F.y)
    };
  }, O = (F, C, R) => {
    const D = R ? ei : vc;
    Z(F, (A) => {
      D(A.Tt, C);
    });
  }, E = (F, C) => {
    Z(F, (R) => {
      const [D, A] = C(R);
      Ln(D, A);
    });
  }, M = (F, C, R) => {
    const D = Gs(R), A = D ? R : !0, z = D ? !R : !0;
    A && O(y, F, C), z && O(b, F, C);
  }, L = () => {
    const F = w(), C = (R) => (D) => [D.Tt, {
      [r]: vs(R) + ""
    }];
    E(y, C(F.x)), E(b, C(F.y));
  }, $ = () => {
    if (!nr) {
      const { Lt: F } = e, C = Ii(F, Ht(p)), R = (D) => (A) => [A.Tt, {
        [s]: vs(D) + ""
      }];
      E(y, R(C.x)), E(b, R(C.y));
    }
  }, q = () => {
    const { Lt: F } = e, C = Ri(F), R = (D) => (A) => [A.Tt, {
      [o]: D ? "0" : "1"
    }];
    E(y, R(C.x)), E(b, R(C.y));
  }, H = () => {
    if (m && !h) {
      const { Rt: F, Lt: C } = e, R = Ri(C), D = Ii(C, Ht(p)), A = (z) => {
        const { Tt: I } = z, B = Dn(I) === d && I, X = (Q, dt, at) => {
          const wt = dt * Q;
          return Tc(at ? wt : -wt);
        };
        return [B, B && {
          transform: Sl({
            x: X(D.x, F.x, R.x),
            y: X(D.y, F.y, R.y)
          })
        }];
      };
      E(y, A), E(b, A);
    }
  }, N = (F) => {
    const C = F ? "x" : "y", D = tn(`${Wt} ${F ? Bl : Vl}`), A = tn(Ic), z = tn(si), I = {
      Tt: D,
      Ut: A,
      Pt: z
    }, B = k[C];
    return ct(F ? y : b, I), ct(x, [zt(D, A), zt(A, z), V(ln, D), B && B.kt(I), n(I, M, F)]), I;
  }, W = V(N, !0), U = V(N, !1), j = () => (zt(S, y[0].Tt), zt(S, b[0].Tt), V(Bt, x));
  return W(), U(), [{
    Nt: L,
    qt: $,
    Bt: q,
    Ft: H,
    jt: M,
    Yt: {
      Wt: y,
      Xt: W,
      Jt: V(E, y)
    },
    Gt: {
      Wt: b,
      Xt: U,
      Jt: V(E, b)
    }
  }, j];
}, au = (i, t, e, n) => (r, s, o) => {
  const { ht: c, U: a, L: l, gt: u, Kt: f, Ot: d } = t, { Tt: _, Ut: p, Pt: h } = r, [m, g] = Ke(333), [v, x] = Ke(444), y = (T) => {
    Kt(u.scrollBy) && u.scrollBy({
      behavior: "smooth",
      left: T.x,
      top: T.y
    });
  }, b = () => {
    const T = "pointerup pointercancel lostpointercapture", k = `client${o ? "X" : "Y"}`, w = o ? Or : Ar, O = o ? "left" : "top", E = o ? "w" : "h", M = o ? "x" : "y", L = (q, H) => (N) => {
      const { Rt: W } = e, U = en(p)[E] - en(h)[E], F = H * N / U * W[M];
      re(u, {
        [M]: q + F
      });
    }, $ = [];
    return nt(p, "pointerdown", (q) => {
      const H = je(q.target, `.${si}`) === h, N = H ? h : p, W = i.scrollbars, U = W[H ? "dragScroll" : "clickScroll"], { button: j, isPrimary: F, pointerType: C } = q, { pointers: R } = W;
      if (j === 0 && F && U && (R || []).includes(C)) {
        Bt($), x();
        const A = !H && (q.shiftKey || U === "instant"), z = V(Ur, h), I = V(Ur, p), B = (et, yt) => (et || z())[O] - (yt || I())[O], X = fs(Ur(u)[w]) / en(u)[E] || 1, Q = L(Ht(u)[M], 1 / X), dt = q[k], at = z(), wt = I(), Y = at[w], pt = B(at, wt) + Y / 2, At = dt - wt[O], mt = H ? 0 : At - pt, gt = (et) => {
          Bt(st), N.releasePointerCapture(et.pointerId);
        }, ut = H || A, ft = d(), st = [nt(f, T, gt), nt(f, "selectstart", (et) => ws(et), {
          H: !1
        }), nt(p, T, gt), ut && nt(p, "pointermove", (et) => Q(mt + (et[k] - dt))), ut && (() => {
          const et = Ht(u);
          ft();
          const yt = Ht(u), kt = {
            x: yt.x - et.x,
            y: yt.y - et.y
          };
          (dr(kt.x) > 3 || dr(kt.y) > 3) && (d(), re(u, et), y(kt), v(ft));
        })];
        if (N.setPointerCapture(q.pointerId), A)
          Q(mt);
        else if (!H) {
          const et = Fn(Zl);
          if (et) {
            const yt = et(Q, mt, Y, (kt) => {
              kt ? ft() : ct(st, ft);
            });
            ct(st, yt), ct($, V(yt, !0));
          }
        }
      }
    });
  };
  let S = !0;
  return V(Bt, [nt(h, "pointermove pointerleave", n), nt(_, "pointerenter", () => {
    s(Hi, !0);
  }), nt(_, "pointerleave pointercancel", () => {
    s(Hi, !1);
  }), !l && nt(_, "mousedown", () => {
    const T = ys();
    (Mi(T, fe) || Mi(T, ke) || T === document.body) && pr(V(xs, a), 25);
  }), nt(_, "wheel", (T) => {
    const { deltaX: k, deltaY: w, deltaMode: O } = T;
    S && O === 0 && Dn(_) === c && y({
      x: k,
      y: w
    }), S = !1, s(Bi, !0), m(() => {
      S = !0, s(Bi);
    }), ws(T);
  }, {
    H: !1,
    I: !0
  }), nt(_, "pointerdown", V(nt, f, "click", Ac, {
    A: !0,
    I: !0,
    H: !1
  }), {
    I: !0
  }), b(), g, x]);
}, lu = (i, t, e, n, r, s) => {
  let o, c, a, l, u, f = qe, d = 0;
  const _ = ["mouse", "pen"], p = (C) => _.includes(C.pointerType), [h, m] = Ke(), [g, v] = Ke(100), [x, y] = Ke(100), [b, S] = Ke(() => d), [T, k] = cu(i, r, n, au(t, r, n, (C) => p(C) && W())), { ht: w, Qt: O, wt: E } = r, { jt: M, Nt: L, qt: $, Bt: q, Ft: H } = T, N = (C, R) => {
    if (S(), C)
      M(qi);
    else {
      const D = V(M, qi, !0);
      d > 0 && !R ? b(D) : D();
    }
  }, W = () => {
    (a ? !o : !l) && (N(!0), g(() => {
      N(!1);
    }));
  }, U = (C) => {
    M(ks, C, !0), M(ks, C, !1);
  }, j = (C) => {
    p(C) && (o = a, a && N(!0));
  }, F = [S, v, y, m, () => f(), nt(w, "pointerover", j, {
    A: !0
  }), nt(w, "pointerenter", j), nt(w, "pointerleave", (C) => {
    p(C) && (o = !1, a && N(!1));
  }), nt(w, "pointermove", (C) => {
    p(C) && c && W();
  }), nt(O, "scroll", (C) => {
    h(() => {
      $(), W();
    }), s(C), H();
  })];
  return [() => V(Bt, ct(F, k())), ({ It: C, Dt: R, Zt: D, tn: A }) => {
    const { nn: z, sn: I, en: B, cn: X } = A || {}, { Ct: Q, dt } = D || {}, { F: at } = e, { T: wt } = ae(), { k: Y, rn: pt } = n, [At, mt] = C("showNativeOverlaidScrollbars"), [gt, ut] = C("scrollbars.theme"), [ft, st] = C("scrollbars.visibility"), [et, yt] = C("scrollbars.autoHide"), [kt, hn] = C("scrollbars.autoHideSuspend"), [zn] = C("scrollbars.autoHideDelay"), [Hn, Nn] = C("scrollbars.dragScroll"), [Ee, dn] = C("scrollbars.clickScroll"), [qn, Dr] = C("overflow"), Lr = dt && !R, Rr = pt.x || pt.y, Zt = z || I || X || Q || R, Ir = B || st || Dr, Bn = At && wt.x && wt.y, Vn = (ge, pn, _n) => {
      const Wn = ge.includes(an) && (ft === ye || ft === "auto" && pn === an);
      return M(Wl, Wn, _n), Wn;
    };
    if (d = zn, Lr && (kt && Rr ? (U(!1), f(), x(() => {
      f = nt(O, "scroll", V(U, !0), {
        A: !0
      });
    })) : U(!0)), mt && M(Nl, Bn), ut && (M(u), M(gt, !0), u = gt), hn && !kt && U(!0), yt && (c = et === "move", a = et === "leave", l = et === "never", N(l, !0)), Nn && M(Xl, Hn), dn && M(Yl, !!Ee), Ir) {
      const ge = Vn(qn.x, Y.x, !0), pn = Vn(qn.y, Y.y, !1);
      M(Ul, !(ge && pn));
    }
    Zt && ($(), L(), H(), X && q(), M(Ni, !pt.x, !0), M(Ni, !pt.y, !1), M(ql, at && !E));
  }, {}, T];
}, uu = (i) => {
  const t = ae(), { Z: e, P: n } = t, { elements: r } = e(), { padding: s, viewport: o, content: c } = r, a = yr(i), l = a ? {} : i, { elements: u } = l, { padding: f, viewport: d, content: _ } = u || {}, p = a ? i : l.target, h = wc(p), m = p.ownerDocument, g = m.documentElement, v = () => m.defaultView || Pt, x = V(iu, [p]), y = V(qc, [p]), b = V(tn, ""), S = V(x, b, o), T = V(y, b, c), k = (Y) => {
    const pt = en(Y), At = br(Y), mt = me(Y, fc), gt = me(Y, hc);
    return At.w - pt.w > 0 && !un(mt) || At.h - pt.h > 0 && !un(gt);
  }, w = S(d), O = w === p, E = O && h, M = !O && T(_), L = !O && w === M, $ = E ? g : w, q = E ? $ : p, H = !O && y(b, s, f), N = !L && M, W = [N, $, H, q].map((Y) => yr(Y) && !Dn(Y) && Y), U = (Y) => Y && rc(W, Y), j = !U($) && k($) ? $ : p, F = E ? g : $, R = {
    vt: p,
    ht: q,
    U: $,
    ln: H,
    bt: N,
    gt: F,
    Qt: E ? m : $,
    an: h ? g : j,
    Kt: m,
    wt: h,
    Mt: a,
    L: O,
    un: v,
    yt: (Y) => ti($, fe, Y),
    St: (Y, pt) => vr($, fe, Y, pt),
    Ot: () => vr(F, fe, Il, !0)
  }, { vt: D, ht: A, ln: z, U: I, bt: B } = R, X = [() => {
    Qt(A, [ke, Yr]), Qt(D, Yr), h && Qt(g, [Yr, ke]);
  }];
  let Q = gs([B, I, z, A, D].find((Y) => Y && !U(Y)));
  const dt = E ? D : B || I, at = V(Bt, X);
  return [R, () => {
    const Y = v(), pt = ys(), At = (st) => {
      zt(Dn(st), gs(st)), ln(st);
    }, mt = (st) => nt(st, "focusin focusout focus blur", Ac, {
      I: !0,
      H: !1
    }), gt = "tabindex", ut = Qs(I, gt), ft = mt(pt);
    return ue(A, ke, O ? "" : El), ue(z, Ts, ""), ue(I, fe, ""), ue(B, zi, ""), O || (ue(I, gt, ut || "-1"), h && ue(g, Fi, "")), zt(dt, Q), zt(A, z), zt(z || A, !O && I), zt(I, B), ct(X, [ft, () => {
      const st = ys(), et = U(I), yt = et && st === I ? D : st, kt = mt(yt);
      Qt(z, Ts), Qt(B, zi), Qt(I, fe), h && Qt(g, Fi), ut ? ue(I, gt, ut) : Qt(I, gt), U(B) && At(B), et && At(I), U(z) && At(z), xs(yt), kt();
    }]), n && !O && (Js(I, fe, Rc), ct(X, V(Qt, I, fe))), xs(!O && h && pt === D && Y.top === Y ? I : pt), ft(), Q = 0, at;
  }, at];
}, fu = ({ bt: i }) => ({ Zt: t, _n: e, Dt: n }) => {
  const { xt: r } = t || {}, { $t: s } = e;
  i && (r || n) && Ln(i, {
    [Ar]: s && "100%"
  });
}, hu = ({ ht: i, ln: t, U: e, L: n }, r) => {
  const [s, o] = It({
    i: bl,
    o: Di()
  }, V(Di, i, "padding", ""));
  return ({ It: c, Zt: a, _n: l, Dt: u }) => {
    let [f, d] = o(u);
    const { P: _ } = ae(), { ft: p, Ht: h, Ct: m } = a || {}, { F: g } = l, [v, x] = c("paddingAbsolute");
    (p || d || (u || h)) && ([f, d] = s(u));
    const b = !n && (x || m || d);
    if (b) {
      const S = !v || !t && !_, T = f.r + f.l, k = f.t + f.b, w = {
        [lc]: S && !g ? -T : 0,
        [uc]: S ? -k : 0,
        [ac]: S && g ? -T : 0,
        top: S ? -f.t : 0,
        right: S ? g ? -f.r : "auto" : 0,
        left: S ? g ? "auto" : -f.l : 0,
        [Or]: S && `calc(100% + ${T}px)`
      }, O = {
        [sc]: S ? f.t : 0,
        [ic]: S ? f.r : 0,
        [cc]: S ? f.b : 0,
        [oc]: S ? f.l : 0
      };
      Ln(t || e, w), Ln(e, O), K(r, {
        ln: f,
        dn: !S,
        j: t ? O : K({}, w, O)
      });
    }
    return {
      fn: b
    };
  };
}, du = (i, t) => {
  const e = ae(), { ht: n, ln: r, U: s, L: o, Qt: c, gt: a, wt: l, St: u, un: f } = i, { P: d } = e, _ = l && o, p = V(ec, 0), h = {
    display: () => !1,
    direction: (C) => C !== "ltr",
    flexDirection: (C) => C.endsWith("-reverse"),
    writingMode: (C) => C !== "horizontal-tb"
  }, m = jt(h), g = {
    i: dc,
    o: {
      w: 0,
      h: 0
    }
  }, v = {
    i: rr,
    o: {}
  }, x = (C) => {
    u(Lc, !_ && C);
  }, y = (C) => {
    if (!m.some((dt) => {
      const at = C[dt];
      return at && h[dt](at);
    }))
      return {
        D: {
          x: 0,
          y: 0
        },
        M: {
          x: 1,
          y: 1
        }
      };
    x(!0);
    const D = Ht(a), A = u($l, !0), z = nt(c, an, (dt) => {
      const at = Ht(a);
      dt.isTrusted && at.x === D.x && at.y === D.y && Oc(dt);
    }, {
      I: !0,
      A: !0
    });
    re(a, {
      x: 0,
      y: 0
    }), A();
    const I = Ht(a), B = br(a);
    re(a, {
      x: B.w,
      y: B.h
    });
    const X = Ht(a);
    re(a, {
      x: X.x - I.x < 1 && -B.w,
      y: X.y - I.y < 1 && -B.h
    });
    const Q = Ht(a);
    return re(a, D), Ys(() => z()), {
      D: I,
      M: Q
    };
  }, b = (C, R) => {
    const D = Pt.devicePixelRatio % 1 !== 0 ? 1 : 0, A = {
      w: p(C.w - R.w),
      h: p(C.h - R.h)
    };
    return {
      w: A.w > D ? A.w : 0,
      h: A.h > D ? A.h : 0
    };
  }, [S, T] = It(g, V(ni, s)), [k, w] = It(g, V(br, s)), [O, E] = It(g), [M] = It(v), [L, $] = It(g), [q] = It(v), [H] = It({
    i: (C, R) => Pr(C, R, m),
    o: {}
  }, () => Ol(s) ? me(s, m) : {}), [N, W] = It({
    i: (C, R) => rr(C.D, R.D) && rr(C.M, R.M),
    o: Pc()
  }), U = Fn($c), j = (C, R) => `${R ? Dl : Ll}${vl(C)}`, F = (C) => {
    const R = (A) => [ye, $e, an].map((z) => j(z, A)), D = R(!0).concat(R()).join(" ");
    u(D), u(jt(C).map((A) => j(C[A], A === "x")).join(" "), !0);
  };
  return ({ It: C, Zt: R, _n: D, Dt: A }, { fn: z }) => {
    const { ft: I, Ht: B, Ct: X, dt: Q, zt: dt } = R || {}, at = U && U.V(i, t, D, e, C), { W: wt, X: Y, J: pt } = at || {}, [At, mt] = Kl(C, e), [gt, ut] = C("overflow"), ft = un(gt.x), st = un(gt.y), et = !0;
    let yt = T(A), kt = w(A), hn = E(A), zn = $(A);
    mt && d && u(Rc, !At);
    {
      ti(n, ke, ir) && x(!0);
      const [ci] = Y ? Y() : [], [Un] = yt = S(A), [Yn] = kt = k(A), Xn = kc(s), Gn = _ && Cl(f()), Xc = {
        w: p(Yn.w + Un.w),
        h: p(Yn.h + Un.h)
      }, ai = {
        w: p((Gn ? Gn.w : Xn.w + p(Xn.w - Yn.w)) + Un.w),
        h: p((Gn ? Gn.h : Xn.h + p(Xn.h - Yn.h)) + Un.h)
      };
      ci && ci(), zn = L(ai), hn = O(b(Xc, ai), A);
    }
    const [Hn, Nn] = zn, [Ee, dn] = hn, [qn, Dr] = kt, [Lr, Rr] = yt, [Zt, Ir] = M({
      x: Ee.w > 0,
      y: Ee.h > 0
    }), Bn = ft && st && (Zt.x || Zt.y) || ft && Zt.x && !Zt.y || st && Zt.y && !Zt.x, Vn = z || X || dt || Rr || Dr || Nn || dn || ut || mt || et, ge = jl(Zt, gt), [pn, _n] = q(ge.k), [Wn, Wc] = H(A), oi = X || Q || Wc || Ir || A, [Uc, Yc] = oi ? N(y(Wn), A) : W();
    return Vn && (_n && F(ge.k), pt && wt && Ln(s, pt(ge, D, wt(ge, qn, Lr)))), x(!1), vr(n, ke, ir, Bn), vr(r, Ts, ir, Bn), K(t, {
      k: pn,
      Vt: {
        x: Hn.w,
        y: Hn.h
      },
      Rt: {
        x: Ee.w,
        y: Ee.h
      },
      rn: Zt,
      Lt: Al(Uc, Ee)
    }), {
      en: _n,
      nn: Nn,
      sn: dn,
      cn: Yc || dn,
      pn: oi
    };
  };
}, pu = (i) => {
  const [t, e, n] = uu(i), r = {
    ln: {
      t: 0,
      r: 0,
      b: 0,
      l: 0
    },
    dn: !1,
    j: {
      [lc]: 0,
      [uc]: 0,
      [ac]: 0,
      [sc]: 0,
      [ic]: 0,
      [cc]: 0,
      [oc]: 0
    },
    Vt: {
      x: 0,
      y: 0
    },
    Rt: {
      x: 0,
      y: 0
    },
    k: {
      x: $e,
      y: $e
    },
    rn: {
      x: !1,
      y: !1
    },
    Lt: Pc()
  }, { vt: s, gt: o, L: c, Ot: a } = t, { P: l, T: u } = ae(), f = !l && (u.x || u.y), d = [fu(t), hu(t, r), du(t, r)];
  return [e, (_) => {
    const p = {}, m = f && Ht(o), g = m && a();
    return Z(d, (v) => {
      K(p, v(_, p) || {});
    }), re(o, m), g && g(), !c && re(s, 0), p;
  }, r, t, n];
}, _u = (i, t, e, n, r) => {
  let s = !1;
  const o = Ui(t, {}), [c, a, l, u, f] = pu(i), [d, _, p] = su(u, l, o, (y) => {
    x({}, y);
  }), [h, m, , g] = lu(i, t, p, l, u, r), v = (y) => jt(y).some((b) => !!y[b]), x = (y, b) => {
    if (e())
      return !1;
    const { vn: S, Dt: T, At: k, hn: w } = y, O = S || {}, E = !!T || !s, M = {
      It: Ui(t, O, E),
      vn: O,
      Dt: E
    };
    if (w)
      return m(M), !1;
    const L = b || _(K({}, M, {
      At: k
    })), $ = a(K({}, M, {
      _n: p,
      Zt: L
    }));
    m(K({}, M, {
      Zt: L,
      tn: $
    }));
    const q = v(L), H = v($), N = q || H || !Zs(O) || E;
    return s = !0, N && n(y, {
      Zt: L,
      tn: $
    }), N;
  };
  return [() => {
    const { an: y, gt: b, Ot: S } = u, T = Ht(y), k = [d(), c(), h()], w = S();
    return re(b, T), w(), V(Bt, k);
  }, x, () => ({
    gn: p,
    bn: l
  }), {
    wn: u,
    yn: g
  }, f];
}, ii = /* @__PURE__ */ new WeakMap(), mu = (i, t) => {
  ii.set(i, t);
}, gu = (i) => {
  ii.delete(i);
}, Bc = (i) => ii.get(i), Ae = (i, t, e) => {
  const { nt: n } = ae(), r = yr(i), s = r ? i : i.target, o = Bc(s);
  if (t && !o) {
    let c = !1;
    const a = [], l = {}, u = (O) => {
      const E = _c(O), M = Fn(Ml);
      return M ? M(E, !0) : E;
    }, f = K({}, n(), u(t)), [d, _, p] = Ss(), [h, m, g] = Ss(e), v = (O, E) => {
      g(O, E), p(O, E);
    }, [x, y, b, S, T] = _u(i, f, () => c, ({ vn: O, Dt: E }, { Zt: M, tn: L }) => {
      const { ft: $, Ct: q, xt: H, Ht: N, Et: W, dt: U } = M, { nn: j, sn: F, en: C, cn: R } = L;
      v("updated", [w, {
        updateHints: {
          sizeChanged: !!$,
          directionChanged: !!q,
          heightIntrinsicChanged: !!H,
          overflowEdgeChanged: !!j,
          overflowAmountChanged: !!F,
          overflowStyleChanged: !!C,
          scrollCoordinatesChanged: !!R,
          contentMutation: !!N,
          hostMutation: !!W,
          appear: !!U
        },
        changedOptions: O || {},
        force: !!E
      }]);
    }, (O) => v("scroll", [w, O])), k = (O) => {
      gu(s), Bt(a), c = !0, v("destroyed", [w, O]), _(), m();
    }, w = {
      options(O, E) {
        if (O) {
          const M = E ? n() : {}, L = Fc(f, K(M, u(O)));
          Zs(L) || (K(f, L), y({
            vn: L
          }));
        }
        return K({}, f);
      },
      on: h,
      off: (O, E) => {
        O && E && m(O, E);
      },
      state() {
        const { gn: O, bn: E } = b(), { F: M } = O, { Vt: L, Rt: $, k: q, rn: H, ln: N, dn: W, Lt: U } = E;
        return K({}, {
          overflowEdge: L,
          overflowAmount: $,
          overflowStyle: q,
          hasOverflow: H,
          scrollCoordinates: {
            start: U.D,
            end: U.M
          },
          padding: N,
          paddingAbsolute: W,
          directionRTL: M,
          destroyed: c
        });
      },
      elements() {
        const { vt: O, ht: E, ln: M, U: L, bt: $, gt: q, Qt: H } = S.wn, { Yt: N, Gt: W } = S.yn, U = (F) => {
          const { Pt: C, Ut: R, Tt: D } = F;
          return {
            scrollbar: D,
            track: R,
            handle: C
          };
        }, j = (F) => {
          const { Wt: C, Xt: R } = F, D = U(C[0]);
          return K({}, D, {
            clone: () => {
              const A = U(R());
              return y({
                hn: !0
              }), A;
            }
          });
        };
        return K({}, {
          target: O,
          host: E,
          padding: M || L,
          viewport: L,
          content: $ || L,
          scrollOffsetElement: q,
          scrollEventElement: H,
          scrollbarHorizontal: j(N),
          scrollbarVertical: j(W)
        });
      },
      update: (O) => y({
        Dt: O,
        At: !0
      }),
      destroy: V(k, !1),
      plugin: (O) => l[jt(O)[0]]
    };
    return ct(a, [T]), mu(s, w), Dc(Mc, Ae, [w, d, l]), ou(S.wn.wt, !r && i.cancel) ? (k(!0), w) : (ct(a, x()), v("initialized", [w]), w.update(), w);
  }
  return o;
};
Ae.plugin = (i) => {
  const t = ce(i), e = t ? i : [i], n = e.map((r) => Dc(r, Ae)[0]);
  return Pl(e), t ? n : n[0];
};
Ae.valid = (i) => {
  const t = i && i.elements, e = Kt(t) && t();
  return gr(e) && !!Bc(e.target);
};
Ae.env = () => {
  const { N: i, T: t, P: e, G: n, st: r, et: s, Z: o, tt: c, nt: a, ot: l } = ae();
  return K({}, {
    scrollbarsSize: i,
    scrollbarsOverlaid: t,
    scrollbarsHiding: e,
    scrollTimeline: n,
    staticDefaultInitialization: r,
    staticDefaultOptions: s,
    getDefaultInitialization: o,
    setDefaultInitialization: c,
    getDefaultOptions: a,
    setDefaultOptions: l
  });
};
Ae.nonce = tu;
class Vc {
  constructor() {
    P(this, "container");
    P(this, "type");
    P(this, "options");
    P(this, "state", /* @__PURE__ */ new Map());
    P(this, "animationAbort", /* @__PURE__ */ new Map());
    /* ---------- 建立 ---------- */
    P(this, "createModal", (t, e) => {
      var r;
      const n = document.createElement("div");
      n.classList.add("modal__container", "dynamic-create", `--type-${this.type}`), n.setAttribute("k-modal-id", t), n.innerHTML = `
      <div class="modal__scroller">
        <div class="modal__wrapper">
          <div class="modal__content">
            <div class="modal__close-btn" k-modal-close></div>
          </div>
        </div>
      </div>
    `, (r = n.querySelector(".modal__content")) == null || r.appendChild(e), this.container.appendChild(n), this.state.set(t, "closed");
    });
    /* ---------- 開啟 ---------- */
    P(this, "open", async (t, e) => {
      var u, f, d, _;
      const n = document.querySelector(`[k-modal-id="${t}"]`);
      if (!n) return;
      const r = this.state.get(t);
      if (r === "open" || r === "opening") return;
      this.cancelRunning(t);
      const o = this.createAbort(t).signal;
      this.state.set(t, "opening");
      const c = n.querySelector(".modal__scroller");
      c.getAttribute("data-overlayscrollbars") || Ae(c, { overflow: { x: "hidden" } });
      const a = (e == null ? void 0 : e.getAttribute("k-modal-effect")) || this.options.effectName;
      n.classList.add(`effect-${a}`), [...n.classList].some((p) => p.startsWith("--type-")) || n.classList.add(`--type-${this.type}`), await ((f = (u = this.options).beforeOpen) == null ? void 0 : f.call(u, t, e)), n.style.display = "block", n.offsetHeight, n.classList.remove("leaving"), n.classList.add("enter");
      const l = this.getDuration(n);
      try {
        await this.wait(l, o);
      } catch {
        return;
      }
      this.state.set(t, "open"), (_ = (d = this.options).afterOpen) == null || _.call(d, t, e);
    });
    /* ---------- 關閉 ---------- */
    P(this, "close", async (t) => {
      var c, a, l, u;
      const e = document.querySelector(`[k-modal-id="${t}"]`);
      if (!e) return;
      const n = this.state.get(t);
      if (n === "closed" || n === "closing") return;
      this.cancelRunning(t);
      const s = this.createAbort(t).signal;
      this.state.set(t, "closing"), await ((a = (c = this.options).beforeClose) == null ? void 0 : a.call(c, t)), e.classList.remove("enter"), e.classList.add("leaving");
      const o = this.getDuration(e);
      try {
        await this.wait(o, s);
      } catch {
        return;
      }
      e.style.display = "none", e.classList.remove("leaving"), this.state.set(t, "closed"), (u = (l = this.options).afterClose) == null || u.call(l, t), e.classList.contains("dynamic-create") && e.remove();
    });
    this.container = document.querySelector("[k-tools-container]"), this.type = "normal", this.options = {
      effectName: "fade",
      beforeOpen: () => {
      },
      afterOpen: () => {
      },
      beforeClose: () => {
      },
      afterClose: () => {
      }
    };
  }
  /* ---------- 工具 ---------- */
  getDuration(t) {
    const e = getComputedStyle(t);
    return Math.max(
      ...e.transitionDuration.split(",").map((r) => parseFloat(r) || 0),
      ...e.animationDuration.split(",").map((r) => parseFloat(r) || 0)
    ) * 1e3;
  }
  wait(t, e) {
    return new Promise((n, r) => {
      const s = setTimeout(n, t);
      e.addEventListener("abort", () => {
        clearTimeout(s), r("aborted");
      });
    });
  }
  cancelRunning(t) {
    var e;
    (e = this.animationAbort.get(t)) == null || e.abort();
  }
  createAbort(t) {
    const e = new AbortController();
    return this.animationAbort.set(t, e), e;
  }
}
class ku extends Vc {
  constructor(e, n) {
    super();
    P(this, "selector");
    P(this, "url");
    /**
     * 初始化
     * @returns
     */
    P(this, "init", () => {
      if (!this.container) {
        console.error("Can't not found [k-tools-container]");
        return;
      }
      this.container.addEventListener("click", this.handleOpenModalClick), this.container.addEventListener("click", this.handleCloseModalClick), this.options.history && this.openModalFromHistory();
    });
    /**
     * 請求HTML內容
     * @param route 欲請求的html路徑
     * @returns
     */
    P(this, "fetchHTML", async (e) => {
      try {
        const n = await fetch(e);
        if (!n.ok)
          throw new Error(`Response status: ${n.status}`);
        const r = await n.text(), c = new DOMParser().parseFromString(r, "text/html").querySelector("[k-modal-html]");
        if (!c) throw new Error("未找到 [k-modal-html] Attribute");
        return c;
      } catch (n) {
        return n instanceof Error ? console.error(`Error occurred: ${n.message}`) : console.error(`Unknown error: ${JSON.stringify(n)}`), null;
      }
    });
    /**
     * 打開動態生成的燈箱
     * @param htmlRoute html路徑
     * @param modalID 燈箱ID
     */
    P(this, "openDynamicModal", (e, n, r) => {
      this.fetchHTML(e).then(async (s) => {
        s instanceof HTMLElement && (this.createModal(n, s), this.open(n, r));
      });
    });
    /**
     * 透過網址參數打開燈箱
     * @returns
     */
    P(this, "openModalFromHistory", () => {
      const e = this.url.searchParams;
      if (!e.has("modal")) return;
      const n = e.get("modal");
      if (n) {
        const r = n;
        if (document.querySelector(`[k-modal-id="${r}"]`))
          this.open(r);
        else {
          const o = document.querySelector(`[k-modal-target="${r}"]`), c = o == null ? void 0 : o.getAttribute("k-modal-fetch");
          if (!o || !c) return;
          this.openDynamicModal(c, r, o);
        }
      }
    });
    /**
     * 點擊打開燈箱
     * @param event
     * @returns
     */
    P(this, "handleOpenModalClick", (e) => {
      const r = e.target.closest(this.selector);
      if (r) {
        const s = r.getAttribute("k-modal-target"), o = r.getAttribute("k-modal-fetch");
        if (!s) return;
        if (o ? this.openDynamicModal(o, s, r) : this.open(s, r), this.options.history) {
          const c = new URLSearchParams({ modal: s });
          this.url.search = c.toString(), history.replaceState(null, "", this.url.href);
        }
      }
    });
    /**
     * 點擊關閉燈箱
     * @param event
     * @returns
     */
    P(this, "handleCloseModalClick", (e) => {
      var a;
      const n = e.target, r = n.closest(".modal__wrapper"), s = n.closest("[k-modal-close]");
      let o = n === r ? r : s;
      const c = (a = o == null ? void 0 : o.closest(".modal__container")) == null ? void 0 : a.getAttribute("k-modal-id");
      c && (this.close(c), this.options.history && (this.url.searchParams.delete("modal"), window.history.replaceState({}, "", this.url)));
    });
    const r = {
      history: n.history ?? !1
    };
    this.selector = e, this.options = { ...this.options, ...r, ...n }, this.url = new URL(document.location.href), this.init();
  }
}
class Cu extends Vc {
  constructor(e, n) {
    var o;
    super();
    P(this, "selector");
    /**
     * 初始化
     * @returns
     */
    P(this, "init", () => {
      if (!this.container) {
        console.error("Can't not found [k-tools-container]");
        return;
      }
      this.container.addEventListener("click", this.handleOpenAlertClick), this.container.addEventListener("click", this.handleCloseAlertClick);
    });
    P(this, "createAlert", () => {
      const e = document.createElement("div");
      return e.innerHTML = `
      <div class="alert__body">
        <div class="alert__icon"></div>
        <div class="alert__title">${this.options.title}</div>
        <div class="alert__description">${this.options.description}</div>
      </div>
    `, e.appendChild(this.createButtons()), e;
    });
    P(this, "createButtons", () => {
      var n;
      const e = document.createElement("div");
      return e.classList.add("alert__buttons"), (n = this.options.buttons) == null || n.forEach((r) => {
        const s = document.createElement("div");
        s.classList.add("alert__button"), r.className && s.classList.add(`${r.className}`), s.textContent = r.text, e.appendChild(s);
        const o = async (c) => {
          var u;
          const l = (u = c.target.closest(".modal__container")) == null ? void 0 : u.getAttribute("k-modal-id");
          l && (await Promise.resolve(r.action(l)), r.closeOnClick && this.close(l));
        };
        s.addEventListener("click", o);
      }), e;
    });
    P(this, "handleOpenAlertClick", (e) => {
      const n = e.target;
      if (!this.selector) return;
      if (n.closest(this.selector)) {
        const s = us();
        this.createModal(s, this.createAlert()), this.open(s);
      }
    });
    P(this, "handleCloseAlertClick", (e) => {
      var a;
      const n = e.target, r = n.closest(".k-alert__wrapper"), s = n.closest("[k-alert-close]");
      let o = n === r ? r : s;
      const c = (a = o == null ? void 0 : o.closest(".k-alert__container")) == null ? void 0 : a.getAttribute("k-alert-id");
      c && this.close(c);
    });
    P(this, "openAlert", () => {
      const e = us();
      this.createModal(e, this.createAlert()), this.open(e);
    });
    const r = {
      title: "Alert Title",
      description: "Alert Description"
    };
    this.type = "alert", this.selector = e;
    const s = (o = n.buttons) == null ? void 0 : o.map((c) => ({
      ...c,
      closeOnClick: c.closeOnClick ?? !0
      // 若未提供 closeOnClick，預設為 true
    }));
    this.options = {
      ...this.options,
      ...r,
      ...n,
      buttons: s
    }, this.init();
  }
}
class Ou {
  constructor(t, e = "[k-tools-container]") {
    P(this, "container");
    P(this, "selector");
    P(this, "observer");
    P(this, "destroyed", !1);
    /* =========================
      點擊控制
    ========================= */
    P(this, "handleClick", (t) => {
      const e = t.target, n = e.closest(this.selector), r = e.closest(".select__button"), s = e.closest(".select__option");
      if (!n) {
        this.close();
        return;
      }
      n.dataset.kselectDisabled || (this.setup(n), r && (n.classList.contains("open") ? this.close(n) : (this.close(), this.open(n))), s && this.selectOption(s));
    });
    this.container = typeof e == "string" ? document.querySelector(e) : e, this.selector = t, this.init();
  }
  /* =========================
    初始化
  ========================= */
  init() {
    if (!this.destroyed) {
      if (!this.container) throw new Error("[KSelect] container not found");
      this.container.addEventListener("click", this.handleClick), this.scan(), this.observe();
    }
  }
  /* =========================
    掃描 DOM
  ========================= */
  refresh() {
    this.scan();
  }
  scan() {
    this.container.querySelectorAll(this.selector).forEach((t) => this.setup(t));
  }
  /* =========================
    初始化單一 select
  ========================= */
  setup(t) {
    if (t.dataset.kselectInit) return;
    t.dataset.kselectInit = "1";
    const e = t.querySelector(".select__dropdown"), n = t.querySelector(".select__dropdownScroller");
    if (!e || !n) return;
    const r = t.querySelector(".select__option.selected");
    r && this.applyValue(t, r), e.addEventListener("transitionend", (s) => {
      s.target === e && e.offsetHeight === 0 && (e.style.zIndex = "");
    }), Ae(n, { overflow: { x: "hidden" } });
  }
  /* =========================
    MutationObserver
  ========================= */
  observe() {
    this.observer = new MutationObserver((t) => {
      t.forEach((e) => {
        e.addedNodes.forEach((n) => {
          var r, s;
          n instanceof HTMLElement && ((r = n.matches) != null && r.call(n, this.selector) && this.setup(n), (s = n.querySelectorAll) == null || s.call(n, this.selector).forEach((o) => this.setup(o)));
        });
      });
    }), this.observer.observe(this.container, {
      childList: !0,
      subtree: !0
    });
  }
  /* =========================
    開關控制
  ========================= */
  open(t) {
    if (!t) return;
    const e = t.querySelector(".select__dropdown"), n = t.querySelector(".select__dropdownInner");
    t.classList.add("open"), e.style.cssText = `height:${n.offsetHeight}px;z-index:10;`;
  }
  close(t) {
    (t ? [t] : Array.from(this.container.querySelectorAll(this.selector))).forEach((n) => {
      const r = n.querySelector(".select__dropdown");
      n.classList.remove("open"), r.style.height = "";
    });
  }
  /* =========================
    選項選取
  ========================= */
  selectOption(t) {
    const e = t.closest(this.selector);
    if (!e) return;
    e.querySelectorAll(".select__option").forEach((r) => r.classList.remove("selected")), t.classList.add("selected"), this.applyValue(e, t);
    const n = new CustomEvent("select", {
      bubbles: !0,
      cancelable: !0,
      detail: {
        value: e.value,
        el: e
      }
    });
    e.dispatchEvent(n), this.close(e);
  }
  applyValue(t, e) {
    const n = t.querySelector(".select__display"), r = e.textContent || "", s = e.dataset.option || r;
    n.textContent = r, t.value = s;
  }
  /* =========================
    外部 API
  ========================= */
  /** 取得值 */
  getValue(t) {
    return t.value;
  }
  /** 設定值 */
  setValue(t, e) {
    const n = t.querySelector(`.select__option[data-option="${e}"]`);
    n && this.selectOption(n);
  }
  /** 禁用 */
  disable(t) {
    t.dataset.kselectDisabled = "1", t.classList.add("disabled");
  }
  /** 啟用 */
  enable(t) {
    delete t.dataset.kselectDisabled, t.classList.remove("disabled");
  }
  /* =========================
    銷毀
  ========================= */
  destroy() {
    var t;
    this.container.removeEventListener("click", this.handleClick), (t = this.observer) == null || t.disconnect(), this.destroyed = !0;
  }
}
export {
  Ws as AnchorTo,
  Su as KAccordion,
  Cu as KAlert,
  vu as KAnchor,
  ku as KModal,
  xu as KScrollTrigger,
  Tu as KScrollspy,
  Ou as KSelect,
  bu as KTab,
  wu as utils
};
